<template>
  <div class="app">
    <Loading :value="loading"></Loading>

    <!-- RACOURCIS -->
    <v-card>
      <v-card-title>
        <v-breadcrumbs icons divider="chevron_right">
          <v-breadcrumbs-item
            icons
            router
            :to="item.path"
            v-for="item in racourcis"
            :key="item.text"
            :disabled="item.disabled"
          >
            {{ item.text }}
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </v-card-title>
    </v-card>
    <br />

    <!-- STATS -->
    <v-container fluid grid-list-md>
      <v-layout row justify>
        <v-flex md4>
          <div id="chartsSortieAll" style="width: 450px; height: 300px"></div>
        </v-flex>
        <v-flex md8>
          <div id="chartsApproAll" style="width: 900px; height: 300px"></div>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- VIGNET -->
    <v-container fluid grid-list-md text-xs-center>
      <v-layout row justify>
        <v-flex md3>
          <v-chip
            text-color="white"
            label
            color="primary"
            style="font-size:20px; width:100%"
          >
            Approvisionnement : {{ nbrAppro }}
            <v-icon right>add_shopping_cart</v-icon>
          </v-chip>
        </v-flex>
        <v-flex md3>
          <v-chip
            text-color="white"
            label
            color="orange"
            style="font-size:20px; width:100%"
          >
            Demande de carburant : {{ nbrCarburant }}
            <v-icon right>list</v-icon>
          </v-chip>
        </v-flex>
        <v-flex md3>
          <v-chip
            text-color="white"
            label
            color="red"
            style="font-size:20px; width:100%"
          >
            Sortie : {{ nbrSortie }} <v-icon right>last_page</v-icon>
          </v-chip>
        </v-flex>
        <v-flex md3>
          <v-chip
            text-color="white"
            label
            color="green"
            style="font-size:20px; width:100%"
          >
            Retour : {{ nbrRetour }} <v-icon right>replay</v-icon>
          </v-chip>
        </v-flex>
        <v-flex md3>
          <v-chip
            text-color="white"
            label
            color="blue lighten-2"
            style="font-size:20px; width:100%"
          >
            Transfert : {{ nbrTrans }}
            <v-icon right>transfer_within_a_station</v-icon>
          </v-chip>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- BTN AJOUT -->
    <v-spacer></v-spacer>
    <div class="text-xs-right">
      <v-tooltip top>
        <v-btn
          slot="activator"
          icons
          color="primary"
          @click.stop="newEntrepot()"
          dark
          >Ajouter <v-icon right>add</v-icon></v-btn
        >
        Ajouter un nouvel entrepot
      </v-tooltip>
      <v-btn @click="dialogAide = true" fab color="primary" small dark>
        <v-icon>help_outline</v-icon>
      </v-btn>
      <!-- MODAL OPTION AIDE -->
      <v-bottom-sheet v-model="dialogAide">
        <v-list>
          <v-subheader>CLASSE A</v-subheader>
          <v-list-tile>
            <v-list-tile-title
              >Un entrepôt de classe A correspond à un entrepôt de haute
              fonctionnalité.</v-list-tile-title
            >
          </v-list-tile>
        </v-list>

        <v-list>
          <v-subheader>CLASSE B</v-subheader>
          <v-list-tile>
            <v-list-tile-title
              >Un entrepôt de classe B, est un entrepôt qui répond juste aux
              normes standard.</v-list-tile-title
            >
          </v-list-tile>
        </v-list>
        <v-list>
          <v-subheader>CLASSE C</v-subheader>
          <v-list-tile>
            <v-list-tile-title
              >Les entrepôts de classe C : ne répondant à aucun des critères des
              classes A et B.</v-list-tile-title
            >
          </v-list-tile>
        </v-list>
      </v-bottom-sheet>
    </div>

    <!-- MODAL SHOW ENTREPOT -->
    <v-dialog
      v-model="dialogShow"
      fullscreen
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title
            >Détails sur l'entrepot {{ entrepotCourant.ref }} /
            {{ entrepotCourant.libelle }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShow = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <!-- STATS -->
          <el-row :gutter="20">
            <v-container fluid grid-list-md>
              <v-layout row justify>
                <v-flex sm6 v-if="detailEntre.typeHydro" class="mr-1">
                  <v-layout row>
                    <!-- <v-flex sm6> -->
                    <v-layout
                      row
                      class="elevation-3 pt-2 pl-2 pr-2 pb-2 grey lighten-4"
                    >
                      <v-flex sm8>
                        <div
                          id="chartCiterneCarburant"
                          style="width:90%; height:90%"
                        ></div>
                      </v-flex>

                      <!--Commande livre -->
                      <v-flex sm4>
                        <v-layout row wrap class="pt-2 pl-2 pr-2 pb-2">
                          <v-flex sm12>
                            <v-card
                              color="teal lighten-1"
                              class="white--text elevation-5"
                            >
                              <v-container fluid grid-list-lg>
                                <v-layout row>
                                  <v-flex xs12>
                                    <div>Quantités sorties</div>
                                    <div class="display-2">
                                      {{
                                        new Intl.NumberFormat().format(
                                          nbQteUtilise
                                        )
                                      }}
                                      L
                                    </div>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-card>
                          </v-flex>

                          <v-flex sm12>
                            <v-card
                              color="deep-orange lighten-1"
                              class="white--text elevation-5"
                            >
                              <v-container fluid grid-list-lg>
                                <v-layout row>
                                  <v-flex xs12>
                                    <div>Quantités Disponibles</div>
                                    <div class="display-2">
                                      {{
                                        new Intl.NumberFormat().format(
                                          nbQteDisponible
                                        )
                                      }}
                                      L
                                    </div>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <!-- </v-flex> -->
                  </v-layout>
                </v-flex>

                <v-flex sm6 v-if="detailEntre.typeHydro == false">
                  <div
                    id="chartsSortieEntre"
                    style="width: 450px; height: 300px"
                  ></div>
                </v-flex>

                <v-flex sm6>
                  <div
                    id="chartsApproEntre"
                    style="width: 900px; height: 300px"
                  ></div>
                </v-flex>
              </v-layout>
            </v-container>
          </el-row>

          <!-- GAUGE DE CARBURANT -->

          <!-- VIGNET -->
          <el-row :gutter="20">
            <v-container fluid grid-list-md text-xs-center>
              <v-layout row justify>
                <v-flex md3>
                  <v-chip
                    text-color="white"
                    label
                    color="primary"
                    style="font-size:20px; width:100%"
                  >
                    Approvisionnement : {{ nbrApproEntre }}
                    <v-icon right>add_shopping_cart</v-icon>
                  </v-chip>
                </v-flex>
                <v-flex md3 v-if="detailEntre.typeHydro">
                  <v-chip
                    text-color="white"
                    label
                    color="orange"
                    style="font-size:20px; width:100%"
                  >
                    Demande de carburant : {{ nbrCarburantEntre }}
                    <v-icon right>list</v-icon>
                  </v-chip>
                </v-flex>
                <v-flex md3>
                  <v-chip
                    text-color="white"
                    label
                    color="red"
                    style="font-size:20px; width:100%"
                  >
                    Sortie : {{ nbrSortieEntre }}
                    <v-icon right>last_page</v-icon>
                  </v-chip>
                </v-flex>
                <v-flex md3>
                  <v-chip
                    text-color="white"
                    label
                    color="green"
                    style="font-size:20px; width:100%"
                  >
                    Retour : {{ nbrRetourEntre }} <v-icon right>replay</v-icon>
                  </v-chip>
                </v-flex>
                <v-flex md3>
                  <v-chip
                    text-color="white"
                    label
                    color="blue lighten-2"
                    style="font-size:20px; width:100%"
                  >
                    Transfert : {{ nbrTransEntre }}
                    <v-icon right>transfer_within_a_station</v-icon>
                  </v-chip>
                </v-flex>
              </v-layout>
            </v-container>
          </el-row>

          <el-row :gutter="20">
            <div class="grid-content" style=" padding: 3px">
              <el-row>
                <el-tabs type="border-card" @tab-click="showClick">
                  <!-- FICHE ENTREPOT -->
                  <el-tab-pane name="fiche">
                    <span slot="label"
                      ><v-icon right>ic_person</v-icon> Fiche</span
                    >
                    <div class="grid-content bg-purple">
                      <div class="text item">
                        <v-layout row justify>
                          <v-flex md4>
                            <p><b>Réference : </b> {{ detailEntre.ref }}</p>
                            <p>
                              <b>Désignation : </b> {{ detailEntre.libelle }}
                            </p>
                            <p><b>Ville : </b> {{ detailEntre.ville }}</p>
                            <p >
                              <b>Projet : </b>
                              <v-chip label text-color="white" color="green">
                                {{ entrepotCourant.projet }} 
                              </v-chip>
                            </p> 
                          </v-flex>
                          <v-flex md4 >
                            <p><b>Commune : </b> {{ detailEntre.commune }}</p>
                            <p v-if="detailEntre.typeHydro">
                              <b>Capacité : </b>
                              <v-chip label text-color="white" color="green">
                                {{ entrepotCourant.citerne }} L
                              </v-chip>
                            </p>
                            <p>
                              <b>Type d'entrepot : </b>
                              <v-chip  outline text-color="orange" label color="orange">
                                {{ detailEntre.typeLibelle }}
                              </v-chip>
                            </p>
                          </v-flex>
                          <v-flex md4>
                            <p>
                              <b>Chef de l'entrepot : </b>
                              {{ detailEntre.chefEntre }}
                            </p>
                            <p>
                              <b>Chef de validation : </b>
                              {{ detailEntre.chefVali }}
                            </p>
                            <p>
                              <b>Date d'enregistrement : </b>
                              {{ detailEntre.created }}
                            </p>
                            <p>
                              <b>Date de modification : </b>
                              {{ detailEntre.modified }}
                            </p>
                          </v-flex>
                        </v-layout>
                      </div>
                    </div>
                  </el-tab-pane>
                  <!-- LISTE DU STOCKS -->
                  <el-tab-pane name="stock">
                    <span slot="label"
                      ><v-icon right>shopping_cart</v-icon> Stock</span
                    >

                    <div>
                      <div class="text-xs-right">
                        <v-layout row>
                          <v-flex
                            v-if="
                              droitAcces.imprime_pdf_histo_stock_liste_entrepot ||
                                droitAcces.imprime_exc_histo_stock_liste_entrepot
                            "
                          >
                            <el-popover
                              ref="popover5"
                              placement="top"
                              width="180"
                              trigger="hover"
                            >
                              <p>Veuillez choisir le format d'impression ?</p>
                              <div style="text-align: right; margin: 0">
                                <el-button
                                  type="success"
                                  size="mini"
                                  @click="imprimeListeHisEntrepotStock('PDF')"
                                  >PDF</el-button
                                >
                                <el-button
                                  type="primary"
                                  size="mini"
                                  @click="imprimeListeHisEntrepotStock('EXC')"
                                  >EXCEL</el-button
                                >
                              </div>
                            </el-popover>
                            <div>
                              <el-button
                                v-popover:popover5
                                type="warning"
                                :disabled="disabledBtnS"
                                icon="el-icon-printer"
                                >Rapport
                              </el-button>
                            </div>
                          </v-flex>
                        </v-layout>
                      </div>

                      <data-tables
                        ref="multipleTable"
                        @selection-change="stockMultiSortie"
                        :data="listStock"
                        :default-sort="{ prop: 'produit', order: 'descending' }"
                        stripe
                        border
                        height="350"
                        style="width: 100%"
                      >
                        <el-table-column
                          :selectable="stockSelect"
                          width="55"
                          type="selection"
                        ></el-table-column>
                        <el-table-column
                          prop="ref"
                          label="id"
                          width="110"
                          fixed
                        >
                          <template slot-scope="scope">
                            {{ scope.row.ref }}
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="produit"
                          label="Produit (Code article/catégorie)"
                          width="280"
                          fixed
                        >
                          <template slot-scope="scope">
                            <v-chip text-color="white" label color="orange">
                              {{ scope.row.codeGestion }}
                            </v-chip>
                            <v-chip text-color="white" label color="primary">
                              {{ scope.row.produit }}
                            </v-chip>
                            <v-chip
                              text-color="black"
                              v-if="scope.row.type != ''"
                              label
                              color="succes"
                            >
                              ({{ scope.row.type }} - {{ scope.row.reference }})
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="ref"
                          label="Dernière opération"
                          width="220"
                          fixed
                        >
                          <template slot-scope="scope">
                            <v-chip
                              v-if="scope.row.operationStock === 'ENLEVEMENT'"
                              outline
                              text-color="red"
                              label
                              color="red"
                            >
                              {{ scope.row.operationStock }} LE
                              {{ scope.row.dateStock }}
                            </v-chip>
                            <v-chip
                              v-if="
                                scope.row.operationStock === 'APPROVISIONNEMENT'
                              "
                              outline
                              text-color="primary"
                              label
                              color="primary"
                            >
                              {{ scope.row.operationStock }} LE
                              {{ scope.row.dateStock }}
                            </v-chip>
                            <v-chip
                              v-if="scope.row.operationStock === 'RETOUR'"
                              outline
                              text-color="green"
                              label
                              color="green"
                            >
                              {{ scope.row.operationStock }} LE
                              {{ scope.row.dateStock }}
                            </v-chip>
                            <v-chip
                              v-if="
                                scope.row.operationStock ===
                                  'NOUVEAU PRODUIT AJOUTER'
                              "
                              text-color="white"
                              label
                              color="primary"
                            >
                              {{ scope.row.operationStock }}
                            </v-chip>
                            <v-chip
                              v-if="
                                scope.row.operationStock === 'AUCUNE OPERATION'
                              "
                              text-color="white"
                              label
                              color="primary"
                            >
                              {{ scope.row.operationStock }}
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="address"
                          label="Mouvement"
                          width="220"
                        >
                          <template slot-scope="scope">
                            <v-chip
                              v-if="scope.row.typeStock === 'SORTIE'"
                              text-color="white"
                              label
                              color="red"
                            >
                              {{ scope.row.typeStock }}
                            </v-chip>
                            <v-chip
                              v-if="scope.row.typeStock === 'ENTREE'"
                              text-color="white"
                              label
                              color="green"
                            >
                              {{ scope.row.typeStock }}
                            </v-chip>
                            <v-chip
                              v-if="scope.row.typeStock === 'AUCUN'"
                              outline
                              text-color="secondary"
                              label
                              color="secondary"
                            >
                              {{ scope.row.typeStock }}
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="qte"
                          label="Quantité actuelle"
                          width="180"
                        >
                          <template slot-scope="scope">
                            <v-chip
                              v-if="scope.row.qte != 0"
                              text-color="white"
                              color="secondary"
                            >
                              {{ scope.row.qte }}
                            </v-chip>
                            <v-chip
                              v-if="scope.row.qte == 0"
                              text-color="white"
                              color="red"
                            >
                              VIDE
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column prop="unite" label="Unité" width="280">
                          <template slot-scope="scope">
                            <v-chip
                              outline
                              text-color="primary"
                              label
                              color="primary"
                            >
                              {{ scope.row.unite }}
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="prix"
                          label="Prix unitaire"
                          width="120"
                        >
                          <template slot-scope="scope">
                            <v-chip text-color="white" label color="secondary">
                              {{ scope.row.prix }} FCFA
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="valeur"
                          label="Valeur du stock"
                          width="140"
                        >
                          <template slot-scope="scope">
                            <v-chip text-color="white" label color="secondary">
                              {{ scope.row.valeur }} FCFA
                            </v-chip>
                          </template>
                        </el-table-column>
                      </data-tables>
                    </div>
                  </el-tab-pane>
                  <!-- LISTE DES APPROVISIONNEMENT -->
                  <el-tab-pane name="appro">
                    <span slot="label"
                      ><v-icon right>add_shopping_cart</v-icon>
                      Approvsionnement</span
                    >

                    <div>
                      <v-chip text-color="white" label color="primary">
                        LISTE DES APPROVISIONNEMENT
                        <v-icon right>add_shopping_cart</v-icon>
                      </v-chip>

                      <div class="text-xs-center">
                        <v-layout row>
                          <v-flex
                            v-if="
                              droitAcces.imprime_pdf_histo_stock_liste_approvi ||
                                droitAcces.imprime_exc_histo_stock_liste_approv
                            "
                          >
                            <el-popover
                              ref="popProjet"
                              placement="top"
                              width="180"
                              trigger="hover"
                            >
                              <p>Veuillez choisir le format d'impression ?</p>
                              <div style="text-align: right; margin: 0">
                                <el-button
                                  type="success"
                                  v-if="
                                    droitAcces.imprime_pdf_histo_stock_liste_approvi
                                  "
                                  size="mini"
                                  @click="imprimeListeHisEntrepotAppro('PDF')"
                                  >PDF</el-button
                                >
                                <el-button
                                  type="primary"
                                  v-if="
                                    droitAcces.imprime_exc_histo_stock_liste_approv
                                  "
                                  size="mini"
                                  @click="imprimeListeHisEntrepotAppro('EXC')"
                                  >EXCEL</el-button
                                >
                              </div>
                            </el-popover>
                            <div>
                              <el-button
                                v-popover:popProjet
                                type="warning"
                                :disabled="disabledBtnA"
                                icon="el-icon-printer"
                                >Rapport
                              </el-button>
                            </div>
                          </v-flex>
                        </v-layout>
                      </div>

                      <v-card-text>
                        <data-tables :data="listAppro" style="width: 100%">
                          <el-table-column
                            prop="ref"
                            label="Réference"
                            fixed="left"
                          >
                            <template slot-scope="scope">
                              <v-chip text-color="white" label color="primary">
                                {{ scope.row.ref }}
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column
                            v-if="detailEntre.libelle != 'HYDORLIQUE'"
                            prop="codeGestion"
                            label="Code analytique"
                            fixed="left"
                          >
                            <template slot-scope="scope">
                              <v-chip text-color="white" label color="indigo">
                                {{ scope.row.codeGestion }}
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="produit"
                            label="Produit"
                            width="370"
                          >
                            <template slot-scope="scope">
                              <v-chip text-color="white" label color="primary">
                                {{ scope.row.produit }} ({{ scope.row.type }} -
                                {{ scope.row.refProd }})
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column prop="qte" label="Quantité">
                            <template slot-scope="scope">
                              <v-chip color="green" text-color="white">{{
                                new Intl.NumberFormat().format(scope.row.qte)
                              }}</v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column prop="unite" label="Unité">
                            <template slot-scope="scope">
                              <v-chip color="orange" text-color="white">{{
                                scope.row.unite
                              }}</v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column prop="date" label="Date appro">
                            <template slot-scope="scope">
                              <v-chip text-color="white" color="orange">
                                {{ scope.row.date }}
                                <v-icon dark>date_range</v-icon>
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="valide"
                            label="Validation appro"
                          >
                            <template slot-scope="scope">
                              <v-chip
                                v-if="scope.row.valide == false"
                                text-color="white"
                                color="green"
                              >
                                Valide
                              </v-chip>

                              <v-chip
                                v-if="scope.row.valide == true"
                                text-color="white"
                                color="orange"
                              >
                                Validation en attente
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column label="Action" fixed="right">
                            <template slot-scope="scope">
                              <div class="text-xs-center">
                                <v-tooltip top>
                                  <v-btn
                                    slot="activator"
                                    @click.stop="showAppro(scope.row)"
                                    fab
                                    dark
                                    small
                                    color="green"
                                  >
                                    <v-icon dark>folder_open</v-icon>
                                  </v-btn>
                                  Détails
                                </v-tooltip>
                                <v-tooltip top>
                                  <v-btn
                                    v-if="
                                      scope.row.valide == true &&
                                        droitAcces.valid_liv_appro
                                    "
                                    slot="activator"
                                    @click="validLivrAppro(scope.row)"
                                    fab
                                    dark
                                    small
                                    color="green"
                                  >
                                    <v-icon dark>done_all</v-icon>
                                  </v-btn>
                                  Valider definitivement l'approvisionnement
                                </v-tooltip>
                                <v-tooltip top>
                                  <v-btn
                                    slot="activator"
                                    @click.stop="imprimerAppro(scope.row)"
                                    fab
                                    dark
                                    small
                                    color="orange"
                                  >
                                    <v-icon dark>print</v-icon>
                                  </v-btn>
                                  Imprimer
                                </v-tooltip>
                              </div>
                            </template>
                          </el-table-column>
                        </data-tables>
                      </v-card-text>
                    </div>
                  </el-tab-pane>
                  <!-- LISTE DES DEMMANDES DE CARBURANT -->
                  <el-tab-pane name="carburant" v-if="detailEntre.typeHydro">
                    <span slot="label"
                      ><v-icon right>list</v-icon> Demande de carburant</span
                    >
                    <div>
                      <v-chip text-color="white" label color="primary">
                        LISTE DES DEMANDES DE CARBURANT
                        <v-icon right>list</v-icon>
                      </v-chip>
                      <div class="text-xs-center">
                        <v-layout row>
                          <v-flex>
                            <el-popover
                              ref="popProjet"
                              placement="top"
                              width="180"
                              trigger="hover"
                            >
                              <p>Veuillez choisir le format d'impression ?</p>
                              <div style="text-align: right; margin: 0">
                                <el-button
                                  type="success"
                                  v-if="
                                    droitAcces.imprime_pdf_histo_stock_liste_approvi
                                  "
                                  size="mini"
                                  @click="imprimeListeHisEntrepotAppro('PDF')"
                                  >PDF</el-button
                                >
                                <el-button
                                  type="primary"
                                  v-if="
                                    droitAcces.imprime_exc_histo_stock_liste_approv
                                  "
                                  size="mini"
                                  @click="imprimeListeHisEntrepotAppro('EXC')"
                                  >EXCEL</el-button
                                >
                              </div>
                            </el-popover>
                            <div>
                              <el-button
                                v-popover:popProjet
                                type="warning"
                                :disabled="disabledBtnA"
                                icon="el-icon-printer"
                                >Rapport
                              </el-button>
                            </div>
                          </v-flex>
                        </v-layout>
                      </div>

                      <data-tables
                        ref="multipleTable"
                        @selection-change="stockMultiSortie"
                        :data="listCarburant"
                        :default-sort="{ prop: 'produit', order: 'descending' }"
                        stripe
                        border
                        height="350"
                        style="width: 100%"
                      >
                        <el-table-column
                          :selectable="stockDemande"
                          width="50"
                          type="selection"
                        ></el-table-column>
                        <el-table-column
                          prop="projet"
                          label="Projet / Tache"
                          width="400"
                        >
                          <template slot-scope="scope">
                            {{ scope.row.libelleTrx }}
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="demnandeur"
                          label="Demandeur"
                          width="170"
                        >
                          <template slot-scope="scope">
                            <v-chip
                              outline
                              text-color="primary"
                              label
                              color="primary"
                            >
                              {{ scope.row.demnandeur }}
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="produit"
                          label="Produit"
                          width="380"
                          fixed
                        >
                          <template slot-scope="scope">
                            <v-chip
                              outline
                              text-color="primary"
                              label
                              color="primary"
                            >
                              {{ scope.row.produit }}- {{ scope.row.refProd }})
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="qte"
                          label="Quantité"
                          width="100"
                        >
                          <template slot-scope="scope">
                            <v-chip color="green" text-color="white">{{
                              new Intl.NumberFormat().format(scope.row.qte)
                            }}</v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="unite"
                          label="Unitée"
                          width="100"
                        >
                          <template slot-scope="scope">
                            <v-chip color="primary" text-color="white"
                              >LITRE</v-chip
                            >
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="date"
                          label="Date de livraison"
                          width="150"
                        >
                          <template slot-scope="scope">
                            <v-chip text-color="white" color="orange">
                              {{ scope.row.date }}
                              <v-icon dark>date_range</v-icon>
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column label="Etat" fixed="right" width="150">
                          <template slot-scope="scope">
                            <v-chip
                              v-if="scope.row.etat == 0"
                              text-color="white"
                              color="orange"
                            >
                              {{ scope.row.etatLibelle }}
                            </v-chip>
                            <v-chip
                              v-if="scope.row.etat != 0"
                              text-color="white"
                              color="green"
                            >
                              {{ scope.row.etatLibelle }}
                            </v-chip>
                          </template>
                        </el-table-column>
                      </data-tables>
                    </div>
                  </el-tab-pane>
                  <!-- LISTE DES ENLEVEMENT -->
                  <el-tab-pane name="sortie">
                    <span slot="label"
                      ><v-icon right>last_page</v-icon> Enlèvement</span
                    >
                    <div>
                      <v-chip text-color="white" label color="primary">
                        LISTE DES ENLEVEMENTS <v-icon right>last_page</v-icon>
                      </v-chip>
                      <div class="text-xs-center">
                        <v-layout row>
                          <v-flex>
                            <el-popover
                              ref="popProjet"
                              placement="top"
                              width="180"
                              trigger="hover"
                            >
                              <p>Veuillez choisir le format d'impression ?</p>
                              <div style="text-align: right; margin: 0">
                                <el-button
                                  type="success"
                                  size="mini"
                                  v-if="
                                    droitAcces.imprime_pdf_histo_enlevmt_liste_entrpot
                                  "
                                  @click="imprimeListeHisEntrepotEnlevmt('PDF')"
                                  >PDF</el-button
                                >
                                <el-button
                                  type="primary"
                                  size="mini"
                                  v-if="
                                    droitAcces.imprime_exc_histo_enlvmt_liste_entrept
                                  "
                                  @click="imprimeListeHisEntrepotEnlevmt('EXC')"
                                  >EXCEL</el-button
                                >
                              </div>
                            </el-popover>
                            <div>
                              <el-button
                                v-popover:popProjet
                                type="warning"
                                :disabled="disabledBtnE"
                                icon="el-icon-printer"
                                >Rapport
                              </el-button>
                            </div>
                          </v-flex>
                        </v-layout>
                      </div>

                      <v-card-text>
                        <data-tables :data="listSortie" style="width: 100%">
                          <el-table-column
                            prop="ref"
                            label="Réference"
                            fixed="left"
                          >
                            <template slot-scope="scope">
                              <v-chip text-color="white" label color="primary">
                                {{ scope.row.ref }}
                              </v-chip>
                              <v-chip
                                v-if="scope.row.refDmd != ''"
                                text-color="white"
                                label
                                color="orange"
                              >
                                {{ scope.row.refDmd }}
                              </v-chip>
                              <v-chip
                                v-if="scope.row.refTravaux != ''"
                                text-color="white"
                                label
                                color="orange"
                              >
                                {{ scope.row.refTravaux }}
                              </v-chip>
                              <v-chip
                                v-if="scope.row.refInterv != ''"
                                text-color="white"
                                label
                                color="orange"
                              >
                                {{ scope.row.refInterv }}
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="produit"
                            label="Produit"
                            width="270"
                          >
                            <template slot-scope="scope">
                              <v-chip text-color="white" label color="primary">
                                {{ scope.row.produit }} ({{ scope.row.type }} -
                                {{ scope.row.refProd }})
                                <v-icon right>location_on</v-icon>
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column prop="qte" label="Quantité">
                            <template slot-scope="scope">
                              <v-chip color="green" text-color="white">{{
                                scope.row.qte
                              }}</v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column prop="unite" label="Unité">
                            <template slot-scope="scope">
                              <v-chip color="orange" text-color="white">{{
                                scope.row.unite
                              }}</v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column prop="dateS" label="Date de sortie">
                            <template slot-scope="scope">
                              <v-chip text-color="white" color="orange">
                                {{ scope.row.dateS }}
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="lastRetour"
                            label="Date de retour"
                            v-if="detailEntre.libelle != 'HYDORLIQUE'"
                          >
                            <template slot-scope="scope">
                              <v-chip
                                v-if="scope.row.lastRetour !== null && scope.row.lastRetour !== '' "
                                text-color="white"
                                label
                                color="primary"
                              >
                                {{ scope.row.lastRetour }}
                                <v-icon dark>date_range</v-icon>
                              </v-chip>
                              <v-chip
                                v-if="scope.row.lastRetour === null || scope.row.lastRetour === ''"
                                text-color="white"
                                label
                                color="red"
                              >
                                Aucun retour n'est prévu
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column label="Action" fixed="right">
                            <template slot-scope="scope">
                              <div class="text-xs-center">
                                <v-tooltip top>
                                  <v-btn
                                    slot="activator"
                                    @click.stop="showSortie(scope.row)"
                                    fab
                                    dark
                                    small
                                    color="green"
                                  >
                                    <v-icon dark>folder_open</v-icon>
                                  </v-btn>
                                  Détails
                                </v-tooltip>
                                <v-tooltip top>
                                  <!-- les enlevement peuvent etre lie a une laintenance ou un diagnostique lie a un intervention -->
                                  <!-- <v-btn v-if="scope.row.etatValide == false && scope.row.idDmd != ''" slot="activator" @click.stop="openDialogBon(scope.row)" fab dark small color="green">  -->
                                  <v-btn
                                    v-if="
                                      scope.row.etatValide == false &&
                                        droitAcces.show_sortie &&
                                        droitAcces.index_sortie_chefEntrepot &&
                                        droitAcces.index_stock_chefValidation
                                    "
                                    slot="activator"
                                    @click.stop="openDialogBon(scope.row)"
                                    fab
                                    dark
                                    small
                                    color="green"
                                  >
                                    <v-icon dark>done_all</v-icon>
                                  </v-btn>
                                  Valider la sortie du produit
                                </v-tooltip>
                                <v-tooltip
                                  top
                                  v-if="detailEntre.libelle != 'HYDORLIQUE'"
                                >
                                  <v-btn
                                    v-if="scope.row.retour"
                                    slot="activator"
                                    @click.stop="newEntree(scope.row)"
                                    fab
                                    dark
                                    small
                                    color="primary"
                                  >
                                    <v-icon dark>replay</v-icon>
                                  </v-btn>
                                  Faire un retour
                                </v-tooltip>
                                <v-tooltip top>
                                  <v-btn
                                    v-if="
                                      droitAcces.imprime_sortie &&
                                        scope.row.idDmd == ''
                                    "
                                    slot="activator"
                                    @click.stop="imprimerSortie(scope.row)"
                                    fab
                                    dark
                                    small
                                    color="orange"
                                  >
                                    <v-icon dark>print</v-icon>
                                  </v-btn>
                                  Imprimer
                                </v-tooltip>
                              </div>
                            </template>
                          </el-table-column>
                        </data-tables>
                      </v-card-text>
                    </div>
                  </el-tab-pane>
                  <!-- LISTE DES RETOURS -->
                  <el-tab-pane name="retour">
                    <span slot="label"
                      ><v-icon right>replay</v-icon> Retour</span
                    >

                    <div>
                      <v-chip text-color="white" label color="primary">
                        LISTE DES RETOURS <v-icon right>replay</v-icon>
                      </v-chip>

                      <div class="text-xs-center">
                        <v-layout row>
                          <v-flex
                            v-if="
                              droitAcces.imprime_pdf_histo_retour_liste_entrepot ||
                                droitAcces.imprime_exc_histo_retour_liste_entrept
                            "
                          >
                            <el-popover
                              ref="popProjet"
                              placement="top"
                              width="180"
                              trigger="hover"
                            >
                              <p>Veuillez choisir le format d'impression ?</p>
                              <div style="text-align: right; margin: 0">
                                <el-button
                                  type="success"
                                  size="mini"
                                  v-if="
                                    droitAcces.imprime_pdf_histo_retour_liste_entrepot
                                  "
                                  @click="imprimeListeHisEntrepotRetour('PDF')"
                                  >PDF</el-button
                                >
                                <el-button
                                  type="primary"
                                  size="mini"
                                  v-if="
                                    droitAcces.imprime_exc_histo_retour_liste_entrept
                                  "
                                  @click="imprimeListeHisEntrepotRetour('EXC')"
                                  >EXCEL</el-button
                                >
                              </div>
                            </el-popover>
                            <div>
                              <el-button
                                v-popover:popProjet
                                type="warning"
                                :disabled="disabledBtnR"
                                icon="el-icon-printer"
                                >Rapport
                              </el-button>
                            </div>
                          </v-flex>
                        </v-layout>
                      </div>

                      <v-card-text>
                        <data-tables :data="listEntree" style="width: 100%">
                          <el-table-column
                            prop="sortie"
                            label="Sortie concerné"
                            fixed="left"
                            width="370"
                          >
                            <template slot-scope="scope">
                              {{ scope.row.sortie }}
                              <v-chip
                                v-if="scope.row.clore === true"
                                outline
                                text-color="green"
                                label
                                color="green"
                              >
                                RETOUR CLORE
                              </v-chip>
                              <v-chip
                                v-if="scope.row.clore === false"
                                outline
                                text-color="red"
                                label
                                color="red"
                              >
                                RETOUR NON TERMINE
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="produit"
                            label="Produit"
                            width="370"
                          >
                            <template slot-scope="scope">
                              <v-chip text-color="white" label color="primary">
                                {{ scope.row.produit }} ({{ scope.row.type }} -
                                {{ scope.row.refProd }})
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="unite"
                            label="Unité"
                            width="100"
                          >
                            <template slot-scope="scope">
                              <v-chip text-color="white" label color="primary">
                                {{ scope.row.unite }}
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column prop="qteR" label="Quantité">
                            <template slot-scope="scope">
                              <v-chip color="green" text-color="white">
                                {{ scope.row.qteR }}
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column prop="dateS" label="Date de sortie">
                            <template slot-scope="scope">
                              <v-chip text-color="white" color="orange">
                                {{ scope.row.sortie }}
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column prop="dateR" label="Date de retour">
                            <template slot-scope="scope">
                              <v-chip
                                outline
                                text-color="primary"
                                label
                                color="primary"
                              >
                                {{ scope.row.dateR }}
                                <v-icon dark>date_range</v-icon>
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="Action"
                            fixed="right"
                            width="150"
                          >
                            <template slot-scope="scope">
                              <div class="text-xs-center">
                                <v-tooltip top>
                                  <v-btn
                                    slot="activator"
                                    @click.stop="showEntree(scope.row)"
                                    fab
                                    dark
                                    small
                                    color="green"
                                  >
                                    <v-icon dark>folder_open</v-icon>
                                  </v-btn>
                                  Détails
                                </v-tooltip>
                                <v-tooltip top>
                                  <v-btn
                                    slot="activator"
                                    @click.stop="imprimerEntree(scope.row)"
                                    fab
                                    dark
                                    small
                                    color="orange"
                                  >
                                    <v-icon dark>print</v-icon>
                                  </v-btn>
                                  Imprimer
                                </v-tooltip>
                              </div>
                            </template>
                          </el-table-column>
                        </data-tables>
                      </v-card-text>
                    </div>
                  </el-tab-pane>
                  <!-- LISTE DES TRANSFERT -->
                  <el-tab-pane name="transfert">
                    <span slot="label"
                      ><v-icon right>transfer_within_a_station</v-icon>
                      Transfert</span
                    >
                    <div>
                      <el-row :gutter="20">
                        <el-col :span="12">
                          <v-chip text-color="white" label color="primary">
                            TOUTES VOS DEMANDES DE TRANSFERT ÉMISES
                            <v-icon right>transfer_within_a_station</v-icon>
                          </v-chip>

                          <el-card class="box-card">
                            <div class="text-xs-center">
                              <v-layout row>
                                <v-flex>
                                  <el-popover
                                    ref="popover4"
                                    placement="top"
                                    width="180"
                                    trigger="hover"
                                  >
                                    <p>
                                      Veuillez choisir le format d'impression ?
                                    </p>
                                    <div style="text-align: right; margin: 0">
                                      <el-button
                                        type="success"
                                        size="mini"
                                        @click="
                                          imprimeListeHisEntrepotDmdTEmise(
                                            'PDF'
                                          )
                                        "
                                        >PDF</el-button
                                      >
                                      <el-button
                                        type="primary"
                                        size="mini"
                                        @click="
                                          imprimeListeHisEntrepotDmdTEmise(
                                            'EXC'
                                          )
                                        "
                                        >EXCEL</el-button
                                      >
                                    </div>
                                  </el-popover>
                                  <div>
                                    <el-button
                                      v-popover:popover4
                                      type="warning"
                                      :disabled="disabledBtnDTE"
                                      icon="el-icon-printer"
                                    >
                                      Rapport
                                    </el-button>
                                  </div>
                                </v-flex>
                              </v-layout>
                            </div>
                            <div class="grid-content" style="padding:3px;">
                              <el-row>
                                <template>
                                  <data-tables
                                    v-if="
                                      droitAcces.index_transfert ||
                                        droitAcces.index_transfert_chefValidation ||
                                        droitAcces.index_transfert_chefEntrepot
                                    "
                                    :data="listTransfertEmis"
                                    height="200"
                                    style="width: 100%"
                                  >
                                    <el-table-column
                                      prop="produit"
                                      label="Produit"
                                    >
                                      <template slot-scope="scope">
                                        {{ scope.row.produit }}
                                        <v-chip
                                          outline
                                          v-if="scope.row.reponse == 'En cours'"
                                          text-color="primary"
                                          label
                                          color="primary"
                                        >
                                          En cours
                                        </v-chip>
                                        <v-chip
                                          outline
                                          v-if="scope.row.reponse == 'Rejeté'"
                                          text-color="red"
                                          label
                                          color="red"
                                        >
                                          Rejeté
                                        </v-chip>
                                        <v-chip
                                          outline
                                          v-if="scope.row.reponse == 'Validé'"
                                          text-color="green"
                                          label
                                          color="green"
                                        >
                                          Validé
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                    <el-table-column prop="unite" label="Unité">
                                      <template slot-scope="scope">
                                        <v-chip
                                          text-color="white"
                                          color="indigo"
                                        >
                                          {{ scope.row.unite }}
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      prop="entrepotR"
                                      label="Entrepot"
                                    >
                                      <template slot-scope="scope">
                                        <v-chip
                                          text-color="white"
                                          color="primary"
                                        >
                                          {{ scope.row.entrepotR }}
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      prop="qteD"
                                      label="Quantité"
                                    >
                                      <template slot-scope="scope">
                                        <v-chip
                                          text-color="white"
                                          color="primary"
                                        >
                                          {{ scope.row.qteD }}
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      label="Actions"
                                      fixed="right"
                                    >
                                      <template slot-scope="scope">
                                        <v-tooltip top>
                                          <v-btn
                                            slot="activator"
                                            @click.stop="
                                              showTransfert(scope.row)
                                            "
                                            fab
                                            dark
                                            small
                                            color="green"
                                          >
                                            <v-icon dark>folder_open</v-icon>
                                          </v-btn>
                                          Détails
                                        </v-tooltip>
                                        <v-tooltip top>
                                          <v-btn
                                            v-if="
                                              scope.row.demande === false &&
                                                scope.row.etat === false &&
                                                droitAcces.edit_transfert
                                            "
                                            slot="activator"
                                            @click.stop="
                                              editTransfert(scope.row)
                                            "
                                            fab
                                            dark
                                            small
                                            color="primary"
                                          >
                                            <v-icon dark>edit</v-icon>
                                          </v-btn>
                                          Modifier
                                        </v-tooltip>
                                        <v-tooltip top>
                                          <v-btn
                                            slot="activator"
                                            @click.stop="
                                              imprimerTransfert(scope.row)
                                            "
                                            fab
                                            dark
                                            small
                                            color="orange"
                                          >
                                            <v-icon dark>print</v-icon>
                                          </v-btn>
                                          Imprimer
                                        </v-tooltip>
                                      </template>
                                    </el-table-column>
                                  </data-tables>
                                </template>
                              </el-row>
                            </div>
                          </el-card>
                        </el-col>

                        <el-col :span="12">
                          <v-chip text-color="white" label color="primary">
                            TOUTES VOS DEMANDES DE TRANSFERT REÇU
                            <v-icon right>transfer_within_a_station</v-icon>
                          </v-chip>

                          <el-card class="box-card">
                            <!-- <div class="text-xs-center">
                              <v-layout row>
                                <v-flex>
                                  <el-popover  ref="popover5" placement="top" width="180" trigger="hover"
                                  >
                                    <p>Veuillez choisir le format d'impression ?</p>
                                    <div style="text-align: right; margin: 0">
                                      <el-button type="success" size="mini" @click="imprimeListeHisEntrepotDmdTRecu('PDF')">PDF</el-button>
                                      <el-button type="primary" size="mini" @click="imprimeListeHisEntrepotDmdTRecu('EXC')">EXCEL</el-button>
                                    </div>
                                  </el-popover>
                                  <div>
                                    <el-button v-popover:popover5 type="warning"  icon="el-icon-printer" > Rapport
                                    </el-button>
                                  </div>
                                </v-flex>
                              </v-layout>
                            </div> -->
                            <div class="grid-content" style="padding:3px;">
                              <el-row>
                                <template>
                                  <data-tables                                  
                                    :data="listTransfertRecu"
                                    height="200"
                                    style="width: 100%"
                                  >
                                    <el-table-column
                                      prop="produit"
                                      label="Produit"
                                    >
                                      <template slot-scope="scope">
                                        {{ scope.row.produit }}
                                        <v-chip
                                          outline
                                          v-if="scope.row.reponse == 'En cours'"
                                          text-color="primary"
                                          label
                                          color="primary"
                                        >
                                          En cours
                                        </v-chip>
                                        <v-chip
                                          outline
                                          v-if="scope.row.reponse == 'Rejeté'"
                                          text-color="red"
                                          label
                                          color="red"
                                        >
                                          Rejeté
                                        </v-chip>
                                        <v-chip
                                          outline
                                          v-if="scope.row.reponse == 'Validé'"
                                          text-color="green"
                                          label
                                          color="green"
                                        >
                                          Validé
                                        </v-chip>
                                        <v-chip
                                          outline
                                          v-if="
                                            scope.row.demande === false &&
                                              scope.row.etat === false &&
                                              scope.row.priorite == 1
                                          "
                                          text-color="red"
                                          label
                                          color="red"
                                        >
                                          Très urgent
                                        </v-chip>
                                        <v-chip
                                          outline
                                          v-if="
                                            scope.row.demande === false &&
                                              scope.row.etat === false &&
                                              scope.row.priorite == 2
                                          "
                                          text-color="red"
                                          label
                                          color="red"
                                        >
                                          Urgent
                                        </v-chip>
                                        <v-chip
                                          outline
                                          v-if="
                                            scope.row.demande === false &&
                                              scope.row.etat === false &&
                                              scope.row.priorite == 3
                                          "
                                          text-color="primary"
                                          label
                                          color="primary"
                                        >
                                          Pas urgent
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                    <el-table-column prop="unite" label="Unité">
                                      <template slot-scope="scope">
                                        <v-chip
                                          text-color="white"
                                          color="indigo"
                                        >
                                          {{ scope.row.unite }}
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      prop="entrepotD"
                                      label="Entrepot"
                                    >
                                      <template slot-scope="scope">
                                        <v-chip
                                          text-color="white"
                                          color="primary"
                                        >
                                          {{ scope.row.entrepotD }}
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      prop="qteD"
                                      label="Quantité"
                                    >
                                      <template slot-scope="scope">
                                        <v-chip
                                          text-color="white"
                                          color="primary"
                                        >
                                          {{ scope.row.qteD }}
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      label="Actions"
                                      fixed="right"
                                    >
                                      <template slot-scope="scope">
                                        <v-tooltip top>
                                          <v-btn
                                            slot="activator"
                                            @mouseenter="showTooltip = true"
                                            @mouseleave="showTooltip = false"
                                            @click.stop="
                                              showTransfert(scope.row)
                                            "
                                            fab
                                            dark
                                            small
                                            color="green"
                                          >
                                            <v-icon dark>folder_open</v-icon>
                                          </v-btn>
                                          Détails
                                        </v-tooltip>
                                        <v-tooltip top>
                                          <v-btn
                                            v-if="
                                              scope.row.demande === false &&
                                                scope.row.etat === false
                                            "
                                            slot="activator"
                                            @click.stop="
                                              newReponseTransfert(scope.row)
                                            "
                                            fab
                                            dark
                                            small
                                            color="indigo"
                                          >
                                            <v-icon dark>report</v-icon>
                                          </v-btn>
                                          Répondre à la demande
                                        </v-tooltip>
                                        <v-tooltip top>
                                          <v-btn
                                            slot="activator"
                                            @click.stop="
                                              imprimerTransfert(scope.row)
                                            "
                                            fab
                                            dark
                                            small
                                            color="orange"
                                          >
                                            <v-icon dark>print</v-icon>
                                          </v-btn>
                                          Imprimer
                                        </v-tooltip>
                                      </template>
                                    </el-table-column>
                                  </data-tables>
                                </template>
                              </el-row>
                            </div>
                          </el-card>
                        </el-col>
                        <br />
                      </el-row>
                    </div>
                  </el-tab-pane>
                  <!-- LISTE DES INVENTAIRE -->
                  <el-tab-pane name="inventaire">
                    <span slot="label"
                      ><v-icon right>timeline</v-icon> Inventaire</span
                    >

                    <div>
                      <v-chip text-color="white" label color="primary">
                        LISTE DES INVENTAIRES <v-icon right>timeline</v-icon>
                      </v-chip>

                      <div class="text-xs-center">
                        <v-layout row>
                          <v-flex
                            v-if="
                              droitAcces.imprime_pdf_histo_inventaire_liste_entrepo ||
                                droitAcces.imprime_exc_histo_inventaire_entrept
                            "
                          >
                            <el-popover
                              ref="popProjet"
                              placement="top"
                              width="180"
                              trigger="hover"
                            >
                              <p>Veuillez choisir le format d'impression ?</p>
                              <div style="text-align: right; margin: 0">
                                <el-button
                                  type="success"
                                  size="mini"
                                  v-if="
                                    droitAcces.imprime_pdf_histo_inventaire_liste_entrepo
                                  "
                                  @click="
                                    imprimeListeHisEntrepotInventaire('PDF')
                                  "
                                  >PDF</el-button
                                >
                                <el-button
                                  type="primary"
                                  size="mini"
                                  v-if="
                                    droitAcces.imprime_exc_histo_inventaire_entrept
                                  "
                                  @click="
                                    imprimeListeHisEntrepotInventaire('EXC')
                                  "
                                  >EXCEL</el-button
                                >
                              </div>
                            </el-popover>
                            <div>
                              <el-button
                                v-popover:popProjet
                                type="warning"
                                :disabled="disabledBtnInv"
                                icon="el-icon-printer"
                                >Rapport
                              </el-button>
                            </div>
                          </v-flex>
                        </v-layout>
                      </div>

                      <v-card-text>
                        <data-tables :data="listInventaire" style="width: 100%">
                          <el-table-column
                            prop="ref"
                            label="Réference"
                            fixed="left"
                            width="100"
                          >
                            <template slot-scope="scope">
                              <v-chip text-color="white" label color="primary">
                                {{ scope.row.ref }}
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="entrepot"
                            label="Entrepot"
                            width="250"
                          >
                            <template slot-scope="scope">
                              <v-chip text-color="white" label color="indigo">
                                Entrepot : {{ scope.row.entrepot }}
                              </v-chip>
                              <v-chip
                                v-if="scope.row.etat === false"
                                text-color="white"
                                label
                                color="red"
                              >
                                INVALIDE
                              </v-chip>
                              <v-chip
                                v-if="scope.row.etat === true"
                                text-color="white"
                                label
                                color="green"
                              >
                                VALIDE
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column prop="dateD" label="Date de début">
                            <template slot-scope="scope">
                              <v-chip
                                outline
                                text-color="primary"
                                label
                                color="primary"
                              >
                                {{ scope.row.dateD }}
                                <v-icon dark>date_range</v-icon>
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column prop="dateF" label="Date de fin">
                            <template slot-scope="scope">
                              <v-chip
                                outline
                                text-color="primary"
                                label
                                color="primary"
                              >
                                {{ scope.row.dateF }}
                                <v-icon dark>date_range</v-icon>
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="Action"
                            fixed="right"
                            width="150"
                          >
                            <template slot-scope="scope">
                              <div class="text-xs-center">
                                <v-tooltip top>
                                  <v-btn
                                    slot="activator"
                                    @click.stop="showInventaire(scope.row)"
                                    fab
                                    dark
                                    small
                                    color="green"
                                  >
                                    <v-icon dark>folder_open</v-icon>
                                  </v-btn>
                                  Détails
                                </v-tooltip>
                                <v-tooltip top>
                                  <v-btn
                                    v-if="
                                      scope.row.etat === false
                                    "
                                    slot="activator"
                                    @click.stop="validerInventaire(scope.row)"
                                    fab
                                    dark
                                    small
                                    color="green lighten-2"
                                  >
                                    <v-icon dark>done_all</v-icon>
                                  </v-btn>
                                  Valider l'inventaire
                                </v-tooltip>
                                <v-tooltip top>
                                  <v-btn
                                    slot="activator"
                                    @click.stop="imprimerInventaire(scope.row)"
                                    fab
                                    dark
                                    small
                                    color="orange"
                                  >
                                    <v-icon dark>print</v-icon>
                                  </v-btn>
                                  Imprimer
                                </v-tooltip>
                              </div>
                            </template>
                          </el-table-column>
                        </data-tables>
                      </v-card-text>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </el-row>
            </div>
            <br />
          </el-row>

          <v-tooltip top>
            <v-btn
              slot="activator"
              icons
              color="orange"
              @click.stop="dialogShow = false"
              dark
              >Fermer <v-icon right>close</v-icon></v-btn
            >
            Fermer
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              slot="activator"
              icons
              color="primary"
              @click.stop="editEntrepot(entrepotCourant)"
              dark
              >Modifier <v-icon right>edit</v-icon></v-btn
            >
            Modifier
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              slot="activator"
              icons
              color="indigo darken-4"
              @click.stop="newStock(entrepotCourant)"
              dark
              >Stock <v-icon right>shopping_cart</v-icon></v-btn
            >
            Ajouter un nouveau stock
          </v-tooltip>
          <v-tooltip top v-if="this.multipleSelection.length == 1">
            <v-btn
              slot="activator"
              icons
              color="red"
              @click.stop="newSortie(entrepotCourant)"
              dark
              >Sortir <v-icon right>last_page</v-icon></v-btn
            >
            Effectuer un enlevement
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              v-if="detailEntre.etatInventaire === false"
              slot="activator"
              icons
              color="blue lighten-2"
              @click.stop="
                newTransfert(entrepotCourant);
                loadProduitStock(entrepotCourant);
              "
              dark
              >Transfert <v-icon right>transfer_within_a_station</v-icon></v-btn
            >
            Effectuer un transfert
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              v-if="detailEntre.etatInventaire === false"
              slot="activator"
              icons
              color="blue darken-2"
              @click.stop="
                newInventaire(entrepotCourant);
                loadStock(entrepotCourant);
                loadProduitStock(entrepotCourant);
              "
              dark
              >Inventaire <v-icon right>timeline</v-icon></v-btn
            >
            Effectuer un inventaire
          </v-tooltip>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL VALIDE APPRO ENTREPOT -->
    <v-dialog v-model="dialogValidAppro" persistent max-width="600px">
      <v-card>
        <v-form
          id="formValidApproLivr"
          ref="formValidApproLivr"
          lazy-validation
        >
          <v-card-text>
            <v-flex xs12 sm12 md12>
              <v-layout align-center>
                <v-flex>
                  <div class="title mb-3">
                    Approvisionnement en attente de votre confirmation
                  </div>
                  <span class="subheading"
                    >Details de votre approvisionnement en attente.</span
                  >
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs3 sm3 md3>
                  <v-text-field
                    name="codetLiv"
                    v-model="codetLiv"
                    :disabled="true"
                    label="Code livraison"
                  ></v-text-field>
                </v-flex>
                <v-flex xs3 sm3 md3>
                  <v-text-field
                    name="qteLivDepart"
                    v-model="qteLivDepart"
                    :rules="qteLivDepartRules"
                    :disabled="true"
                    required
                    label="La quantité"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs3 sm3 md6>
                  <v-text-field
                    name="produitLiv"
                    v-model="produitLiv"
                    :disabled="true"
                    label="Le produit"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 sm12 md12>
              <v-alert :value="true" type="warning">
                Confirmation de l'approvisionnement.
              </v-alert>
            </v-flex>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-select
                  :items="items"
                  @change="changeValidLiv()"
                  name="choixValidLiv"
                  v-model="choixValidLiv"
                  :rules="choixValidLivRules"
                  item-text="text"
                  item-value="abbr"
                  label="Faite une action"
                >
                </v-select>
              </v-flex>

              <v-flex xs12 sm12 md12 v-if="choixValidLiv == 2">
                <v-text-field
                  @change="loadChangChoix()"
                  type="number"
                  name="nbChoiceLiv"
                  v-model="nbChoiceLiv"
                  :rules="nbChoiceLivRules"
                  label="Quel nombre avez vous réçu?"
                  placeholder="Saisissez le nombre"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 v-if="choixValidLiv == 2">
                <v-text-field
                  name="Commentaire"
                  v-model="remarqueLivr"
                  :rules="remarqueLivrRules"
                  label="Qu\'est il arrivé au reste du produit manquant ?"
                  multi-line
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout align-center>
              <v-flex>
                <span class="subheading">NOM DU LIVREUR *</span>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex md12>
                <div class="block">
                  <el-input
                    name="libelle"
                    placeholder="Nom du livreur"
                    v-model="nomLivreur"
                  ></el-input>
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="resetValideLivAppro()"
              >Annuler</v-btn
            >
            <v-btn color="blue darken-1" flat @click="acceptLivrApproValid()"
              >Confirmer</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- MODAL VALIDE DEMANDE DE CARBURANT-->
    <v-dialog v-model="dialogValidCarburan" persistent max-width="600px">
      <v-card>
        <v-form
          id="formValidApproLivr"
          ref="formValidApproLivr"
          lazy-validation
        >
          <v-card-text>
            <v-flex xs12 sm12 md12>
              <v-layout align-center>
                <v-flex>
                  <div class="title mb-3">
                    Demande de carburant en attente de confirmation
                  </div>
                  <span class="subheading">Details de votre demande.</span>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs3 sm3 md9>
                  <v-text-field
                    name="produitLiv"
                    v-model="produitLiv"
                    :disabled="true"
                    label="Véhicule"
                  ></v-text-field>
                </v-flex>
                <v-flex xs3 sm3 md3>
                  <v-text-field
                    name="qteLivDepart"
                    v-model="qteLivDepart"
                    :rules="qteLivDepartRules"
                    :disabled="true"
                    required
                    label="La quantité"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 sm12 md12>
              <v-alert :value="true" type="warning">
                Confirmation de l'approvisionnement.
              </v-alert>
            </v-flex>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-select
                  :items="itemsCarburant"
                  @change="changeValidLiv()"
                  name="choixValidLiv"
                  v-model="choixValidLiv"
                  :rules="choixValidLivRules"
                  item-text="text"
                  item-value="abbr"
                  label="Faite une action"
                >
                </v-select>
              </v-flex>

              <v-flex xs12 sm12 md12 v-if="choixValidLiv == 2">
                <v-text-field
                  @change="loadChangChoix()"
                  type="number"
                  min="0"
                  name="nbChoiceLiv"
                  v-model="nbChoiceLiv"
                  :rules="nbChoiceLivRules"
                  label="Combien voulez vous affecter?"
                  placeholder="Saisissez le nombre"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 v-if="choixValidLiv == 2">
                <v-text-field
                  name="Commentaire"
                  v-model="remarqueLivr"
                  :rules="remarqueLivrRules"
                  label="Motif?"
                  multi-line
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="resetValideLivAppro()"
              >Annuler</v-btn
            >
            <v-btn
              color="blue darken-1"
              flat
              @click="acceptCarburanApproValid()"
              >Confirmer</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- MODAL SHOW SORTIE -->
    <v-dialog
      v-model="dialogShowSortie"
      max-width="60%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="red">
          <v-toolbar-title
            >Détails de l'enlèvement {{ sortieCourant.ref }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowSortie = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text
          v-loading="loading"
          element-loading-text="Veuillez patientez ..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          <el-row :gutter="20">
            <div class="grid-content" style=" padding: 3px">
              <el-row>
                <el-card class="box-card">
                  <div class="grid-content" style="padding:3px;">
                    <el-row>
                      <div class="text item">
                        <v-layout row justify>
                          <v-flex md4>
                            <p><b>Identifiant : </b> {{ detailSortie.ref }}</p>
                            <p v-if="detailSortie.infoTravaux != ''">
                              <b>Projet concerné : </b>
                              {{ detailSortie.infoTravaux }}
                            </p>
                            <p v-if="detailSortie.infoDemande != ''">
                              <b>Maintenance concerné : </b>
                              {{ detailSortie.infoDemande }}
                            </p>
                            <p v-if="detailSortie.refInterv != ''">
                              <b>Intervention concerné : </b>
                              {{ detailSortie.infoInterv }}
                            </p>
                            <p>
                              <b>Produit : </b> {{ detailSortie.produit }} ({{
                                sortieCourant.type
                              }}
                              - {{ detailSortie.refProd }})
                            </p>
                            <p>
                              <b>Quantité sortie : </b>
                              <v-chip text-color="white" label color="red">
                                {{ detailSortie.qte }}
                              </v-chip>
                            </p>
                            <p v-if="detailSortie.retour === true">
                              <b>Date de retour prévue : </b>
                              {{ detailSortie.dateR }}
                            </p>
                          </v-flex>
                          <v-flex md4>
                            <p v-if="(detailSortie.demandeur = '')">
                              <b>Demande effectué par: </b>
                              {{
                                detailSortie.demandeur
                                  ? detailSortie.demandeur
                                  : ""
                              }}
                            </p>
                            <p v-if="detailSortie.refInterv != ''">
                              <b>Demande effectué par: </b>
                              {{
                                detailSortie.demandeurInterv
                                  ? detailSortie.demandeurInterv
                                  : ""
                              }}
                            </p>
                            <p>
                              <b>Date de sortie : </b> {{ detailSortie.dateS }}
                            </p>
                            <p v-if="detailSortie.retour === true">
                              <b>Dernier retour éffectué : </b>
                              {{ detailSortie.lastRetour }}
                            </p>
                            <p>
                              <b>Retour : </b>
                              <v-chip
                                v-if="detailSortie.retour === true"
                                text-color="white"
                                label
                                color="green"
                              >
                                Retour prévu
                              </v-chip>
                              <v-chip
                                v-if="detailSortie.retour === false"
                                text-color="white"
                                label
                                color="red"
                              >
                                Aucun retour prévu
                              </v-chip>
                            </p>
                            <p v-if="detailSortie.etat === false">
                              <b>Etat : </b>
                              <v-chip
                                v-if="
                                  detailSortie.clore === false &&
                                    detailSortie.qte !==
                                      detailSortie.qteRestante
                                "
                                text-color="white"
                                label
                                color="warning"
                              >
                                Retour partiel <v-icon right>thumb_down</v-icon>
                              </v-chip>
                              <v-chip
                                v-if="
                                  detailSortie.clore === false &&
                                    detailSortie.qte ===
                                      detailSortie.qteRestante
                                "
                                text-color="white"
                                label
                                color="primary"
                              >
                                Aucun retour éffectué
                                <v-icon right>thumb_down</v-icon>
                              </v-chip>
                              <v-chip
                                v-if="detailSortie.clore === true"
                                text-color="white"
                                label
                                color="green"
                              >
                                Retour éffectué en totalité
                                <v-icon right>thumb_up</v-icon>
                              </v-chip>
                            </p>
                            <p v-if="detailSortie.etat === true">
                              <b>Etat : </b>
                              <v-chip text-color="white" label color="green">
                                Clôt <v-icon right>thumb_up</v-icon>
                              </v-chip>
                            </p>
                          </v-flex>
                          <v-flex md4>
                            <p>
                              <b>Entrepot : </b> {{ detailSortie.entrepot }}
                            </p>
                            <p>
                              <b>Etat du produit : </b>
                              <v-chip
                                v-if="detailSortie.etatSortie === 'Bon'"
                                text-color="white"
                                label
                                color="primary"
                              >
                                {{ detailSortie.etatSortie }}
                                <v-icon right>thumb_up</v-icon>
                              </v-chip>
                              <v-chip
                                v-if="detailSortie.etatSortie === 'Très bon'"
                                text-color="white"
                                label
                                color="primary"
                              >
                                {{ detailSortie.etatSortie }}
                                <v-icon right>thumb_up</v-icon>
                              </v-chip>
                              <v-chip
                                v-if="detailSortie.etatSortie === 'Mauvais'"
                                text-color="white"
                                label
                                color="primary"
                              >
                                {{ detailSortie.etatSortie }}
                                <v-icon right>thumb_down</v-icon>
                              </v-chip>
                            </p>
                            <p>
                              <b>Remarque : </b> {{ detailSortie.remarque }}
                            </p>
                            <p>
                              <b>Date d'enregistrement : </b>
                              {{ detailSortie.created }}
                            </p>
                            <p>
                              <b>Date de modification : </b>
                              {{ detailSortie.modified }}
                            </p>
                          </v-flex>
                        </v-layout>
                      </div>
                    </el-row>
                  </div>
                </el-card>
              </el-row>
            </div>
            <br />
          </el-row>

          <p align="center">
            <v-chip
              v-if="detailSortie.entree !== null"
              text-color="white"
              label
              color="primary"
            >
              TOUS LES RETOURS CONCERNANTS LA SORTIE SORT-{{ detailSortie.id }}
            </v-chip>
          </p>

          <el-row :gutter="20" v-if="detailSortie.entree !== null">
            <div class="grid-content" style=" padding: 3px">
              <el-row>
                <el-card class="box-card">
                  <div class="grid-content" style="padding:3px;">
                    <el-row>
                      <template>
                        <el-table
                          :data="detailSortie.entree"
                          height="200"
                          style="width: 100%"
                        >
                          <el-table-column
                            prop="sortie"
                            label="Sortie concerné"
                            width="180"
                          ></el-table-column>
                          <el-table-column
                            prop="produit"
                            label="Produit"
                            width="180"
                          ></el-table-column>
                          <el-table-column
                            prop="qteR"
                            label="Quantité retourné"
                          ></el-table-column>
                          <el-table-column
                            prop="dateR"
                            label="Date"
                          ></el-table-column>
                        </el-table>
                      </template>
                    </el-row>
                  </div>
                </el-card>
              </el-row>
            </div>
            <br />
          </el-row>

          <v-tooltip top>
            <v-btn
              slot="activator"
              icons
              color="orange"
              @click.stop="dialogShowSortie = false"
              dark
              >Fermer <v-icon right>close</v-icon></v-btn
            >
            Fermer
          </v-tooltip>
          <v-tooltip top v-if="detailEntre.libelle != 'Hydrocarbure'">
            <v-btn
              v-if="
                detailSortie.dateR !== null &&
                  detailSortie.etatInventaire === true &&
                  detailSortie.clore == false
              "
              slot="activator"
              icons
              color="primary"
              @click.stop="newEntree(sortieCourant)"
              dark
              >Retour <v-icon right>replay</v-icon></v-btn
            >
            Faire un retour
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              slot="activator"
              icons
              color="orange"
              @click.stop="imprimerSortie(sortieCourant)"
              dark
              >Imprimer <v-icon right>print</v-icon></v-btn
            >
            Imprimer le bon de sorti
          </v-tooltip>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SHOW ENTREE -->
    <v-dialog
      v-model="dialogShowEntree"
      max-width="60%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title
            >Détails du retour {{ entreeCourant.ref }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowEntree = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text
          v-loading="loading"
          element-loading-text="Veuillez patientez ..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          <el-row :gutter="20">
            <div class="grid-content" style=" padding: 3px">
              <el-row>
                <el-card class="box-card">
                  <div class="grid-content" style="padding:3px;">
                    <el-row>
                      <div class="text item">
                        <v-layout row justify>
                          <v-flex md6>
                            <p><b>Identifiant : </b> {{ detailEntree.ref }}</p>
                            <p>
                              <b>Sortie concerné : </b>
                              {{ detailEntree.sortie }}
                            </p>
                            <p>
                              <b>Produit : </b> {{ detailEntree.produit }} ({{
                                detailEntree.type
                              }}
                              - {{ detailEntree.ref }})
                            </p>
                            <p>
                              <b>Quantité retour : </b>
                              <v-chip color="green" text-color="white">
                                {{ detailEntree.qteR }}
                              </v-chip>
                            </p>
                            <p>
                              <b>Date de retour : </b>
                              <v-chip
                                outline
                                text-color="primary"
                                label
                                color="primary"
                              >
                                {{ detailEntree.dateR }}
                                <v-icon dark>date_range</v-icon>
                              </v-chip>
                            </p>
                          </v-flex>
                          <v-flex md6>
                            <p>
                              <b>Etat : </b>
                              <v-chip
                                v-if="detailEntree.clore === true"
                                outline
                                text-color="green"
                                label
                                color="green"
                              >
                                RETOUR CLORE
                              </v-chip>
                              <v-chip
                                v-if="detailEntree.clore === false"
                                outline
                                text-color="red"
                                label
                                color="red"
                              >
                                RETOUR NON TERMINE
                              </v-chip>
                            </p>
                            <p>
                              <b>Remarque : </b> {{ detailEntree.commentaire }}
                            </p>
                            <p>
                              <b>Date d'enregistrement : </b>
                              {{ detailEntree.created }}
                            </p>
                            <p>
                              <b>Date de modification : </b>
                              {{ detailEntree.modified }}
                            </p>
                          </v-flex>
                        </v-layout>
                      </div>
                    </el-row>
                  </div>
                </el-card>
              </el-row>
            </div>
            <br />
          </el-row>

          <v-tooltip top>
            <v-btn
              slot="activator"
              icons
              color="orange"
              @click.stop="dialogShowEntree = false"
              dark
              >Fermer <v-icon right>close</v-icon></v-btn
            >
            Fermer
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              slot="activator"
              icons
              color="orange"
              @click.stop="imprimerEntree(entreeCourant)"
              dark
              >Imprimer <v-icon right>print</v-icon></v-btn
            >
            Imprimer le retour
          </v-tooltip>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SHOW TRANSFERT -->
    <v-dialog
      v-model="dialogShowTransfert"
      max-width="60%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue lighten-2">
          <v-toolbar-title
            >Détails du transfert {{ transfertCourant.ref }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowTransfert = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text
          v-loading="loading"
          element-loading-text="Veuillez patientez ..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          <el-row :gutter="20">
            <div class="grid-content" style=" padding: 3px">
              <el-row>
                <el-card class="box-card">
                  <div class="grid-content" style="padding:3px;">
                    <el-row>
                      <div class="text item">
                        <v-layout row justify>
                          <v-flex md6>
                            <p>
                              <b>Identifiant : </b> {{ detailTransfert.ref }}
                            </p>
                            <p>
                              <b>Entrepot émettant : </b>
                              {{ detailTransfert.entrepotD }}
                            </p>
                            <p>
                              <b>Entrepot transférant : </b>
                              {{ detailTransfert.entrepotF }}
                            </p>
                            <p>
                              <b>Produit : </b> {{ detailTransfert.produit }}
                            </p>
                            <p>
                              <b>Quantité transferé : </b>
                              <v-chip text-color="white" color="primary">
                                {{ detailTransfert.qteD }}
                              </v-chip>
                            </p>
                            <p
                              v-if="
                                detailTransfert.demande === true &&
                                  detailTransfert.etat === true
                              "
                            >
                              <b>Quantité transferé : </b>
                              <v-chip text-color="white" color="primary">
                                {{ detailTransfert.qteT }}
                              </v-chip>
                            </p>
                            <p>
                              <b>Etat da la demande : </b>
                              <v-chip
                                v-if="detailTransfert.reponse === 'En cours'"
                                text-color="white"
                                label
                                color="primary"
                              >
                                En cours de traitement
                              </v-chip>
                              <v-chip
                                v-if="detailTransfert.reponse === 'Rejeté'"
                                text-color="white"
                                label
                                color="red"
                              >
                                DEMANDE REJETE
                              </v-chip>
                              <v-chip
                                v-if="detailTransfert.reponse === 'Validé'"
                                text-color="white"
                                label
                                color="green"
                              >
                                VALIDE
                              </v-chip>
                            </p>
                          </v-flex>
                          <v-flex md6>
                            <p>
                              <b>Prorité : </b>
                              <v-chip
                                v-if="detailTransfert.priorite === '1'"
                                text-color="white"
                                label
                                color="red"
                              >
                                TRES URGENT
                              </v-chip>
                              <v-chip
                                v-if="detailTransfert.priorite === '2'"
                                text-color="white"
                                label
                                color="red"
                              >
                                URGENT
                              </v-chip>
                              <v-chip
                                v-if="detailTransfert.priorite === '3'"
                                text-color="white"
                                label
                                color="red"
                              >
                                PAS D'URGENCE
                              </v-chip>
                            </p>
                            <p>
                              <b>Date de demande : </b>
                              {{ detailTransfert.created }}
                            </p>
                            <p
                              v-if="
                                detailTransfert.demande === true &&
                                  detailTransfert.etat === true
                              "
                            >
                              <b>Date de transfert : </b>
                              {{ detailTransfert.date }}
                            </p>
                            <p>
                              <b>Motif de la demande : </b>
                              {{ detailTransfert.motif }}
                            </p>
                            <p>
                              <b>Remarque : </b>
                              {{ detailTransfert.commentaire }}
                            </p>
                            <p>
                              <b>Date d'enregistrement : </b>
                              {{ detailTransfert.created }}
                            </p>
                            <p>
                              <b>Date de modification : </b>
                              {{ detailTransfert.modified }}
                            </p>
                          </v-flex>
                        </v-layout>
                      </div>
                    </el-row>
                  </div>
                </el-card>
              </el-row>
            </div>
            <br />
          </el-row>

          <v-tooltip top>
            <v-btn
              slot="activator"
              icons
              color="orange"
              @click.stop="dialogShowTransfert = false"
              dark
              >Fermer <v-icon right>close</v-icon></v-btn
            >
            Fermer
          </v-tooltip>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SHOW INVENTAIRE -->
    <v-dialog
      v-model="dialogShowInventaire"
      max-width="90%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue darken-2">
          <v-toolbar-title
            >Détails de l'inventaire
            {{ inventaireCourant.ref }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowInventaire = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text
          v-loading="loading"
          element-loading-text="Veuillez patientez ..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          <el-row :gutter="20">
            <div class="grid-content" style=" padding: 3px">
              <el-row>
                <el-card class="box-card">
                  <div class="grid-content" style="padding:3px;">
                    <el-row>
                      <div class="text item">
                        <v-layout row justify>
                          <v-flex md6>
                            <p>
                              <b>Identifiant : </b> {{ detailInventaire.ref }}
                            </p>
                            <p>
                              <b>Inventaire concernant l'entrepot : </b>
                              <v-chip text-color="white" label color="indigo">
                                Entrepot : {{ detailInventaire.entrepot }}
                              </v-chip>
                            </p>
                            <p>
                              <b>Etat de l'inventaire : </b>
                              <v-chip
                                v-if="detailInventaire.etat === true"
                                text-color="white"
                                label
                                color="green"
                              >
                                VALIDE
                              </v-chip>
                              <v-chip
                                v-if="detailInventaire.etat === false"
                                text-color="white"
                                label
                                color="red"
                              >
                                INVALIDE
                              </v-chip>
                            </p>
                          </v-flex>
                          <v-flex md6>
                            <p>
                              <b>Date de début : </b>
                              {{ detailInventaire.dateD }}
                            </p>
                            <p>
                              <b>Date de fin : </b> {{ detailInventaire.dateF }}
                            </p>
                            <p>
                              <b>Date d'enregistrement : </b>
                              {{ detailInventaire.created }}
                            </p>
                            <p>
                              <b>Date de modification : </b>
                              {{ detailInventaire.modified }}
                            </p>
                          </v-flex>
                        </v-layout>
                      </div>
                    </el-row>
                  </div>
                </el-card>
              </el-row>
            </div>
            <br />
          </el-row>

          <el-row :gutter="20">
            <div class="grid-content" style=" padding: 3px">
              <el-row>
                <el-card class="box-card">
                  <div class="grid-content" style="padding:3px;">
                    <el-row>
                      <template>
                        <el-table
                          :data="detailInventaire.option"
                          height="200"
                          style="width: 100%"
                        >
                          <el-table-column
                            prop="produit"
                            label="Produit"
                            width="280"
                          >
                            <template slot-scope="scope">
                              <v-chip text-color="white" label color="primary">
                                {{ scope.row.produit }} ({{ scope.row.type }} -
                                {{ scope.row.ref }})
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="unite"
                            label="Unité"
                            width="280"
                          >
                            <template slot-scope="scope">
                              <v-chip text-color="white" label color="primary">
                                {{ scope.row.unite }}
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="qteT"
                            label="Quantité théorique"
                          >
                            <template slot-scope="scope">
                              <v-chip text-color="white" color="primary">
                                {{ scope.row.qteT }}
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="qteReel"
                            label="Quantité réele"
                          >
                            <template slot-scope="scope">
                              <v-chip text-color="white" color="primary">
                                {{ scope.row.qteReel }}
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column prop="ecart" label="Ecart">
                            <template slot-scope="scope">
                              <v-chip text-color="white" color="primary">
                                {{ scope.row.ecart }}
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column prop="corriger" label="Corriger ?">
                            <template slot-scope="scope">
                              <v-chip
                                v-if="scope.row.corriger === null"
                                text-color="white"
                                color="primary"
                              >
                               NON
                              </v-chip>
                              <v-chip
                                v-if="scope.row.corriger === 'OUI'"
                                text-color="white"
                                color="green"
                              >
                                {{ scope.row.corriger }}
                              </v-chip>
                              <v-chip
                                v-if="scope.row.corriger === 'NON'"
                                text-color="white"
                                color="red"
                              >
                                {{ scope.row.corriger }}
                              </v-chip>
                            </template>
                          </el-table-column>
                        </el-table>
                      </template>
                    </el-row>
                  </div>
                </el-card>
              </el-row>
            </div>
            <br />
          </el-row>

          <v-tooltip top>
            <v-btn
              slot="activator"
              icons
              color="orange"
              @click.stop="dialogShowInventaire = false"
              dark
              >Fermer <v-icon right>close</v-icon></v-btn
            >
            Fermer
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              v-if="
                detailInventaire.etat === false && droitAcces.valider_inventaire
              "
              slot="activator"
              @click.stop="validerInventaire(inventaireCourant)"
              dark
              color="green lighten-2"
            >
              Valider
              <v-icon dark>done_all</v-icon>
            </v-btn>
            Valider l'inventaire
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              slot="activator"
              icons
              color="orange"
              @click.stop="imprimerInventaire(inventaireCourant)"
              dark
              >Imprimer <v-icon right>print</v-icon></v-btn
            >
            Imprimer l'inventaire
          </v-tooltip>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT DE ENTREPOT -->
    <v-dialog
      v-model="dialogAjout"
      max-width="80%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>
            <span v-if="dialogEdit != true">Ajouter un nouvel entrepot</span>
            <span v-if="dialogEdit"
              >Modification de l'entrepot {{ entrepotCourant.libelle }}
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjout = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form
            ref="formEntrepot"
            v-model="valid"
            lazy-validation
            id="formEntrepot"
          >
            <v-container fluid grid-list-md>
              <v-stepper v-model="formEtape">
                <v-stepper-header>
                  <v-stepper-step step="1" :complete="formEtape > 1">
                    ENTREPOT
                    <v-icon right
                      >local_convenience_store</v-icon
                    ></v-stepper-step
                  >
                  <v-divider></v-divider>
                  <v-stepper-step
                    step="2"
                    :complete="formEtape > 2"
                    v-if="dialogEdit !== true"
                  >
                    STOCK <v-icon right>shopping_cart</v-icon></v-stepper-step
                  >
                </v-stepper-header>
                <v-stepper-items>
                  <v-stepper-content step="1">
                    <p align="center">
                      <v-chip
                        text-color="white"
                        label
                        color="primary"
                        style="font-size:22px; width:100%"
                      >
                        Description technique de votre entrepot
                        <v-icon right>local_convenience_store</v-icon>
                      </v-chip>
                    </p>

                    <v-layout row>
                      <v-flex md3>
                        <div class="block">
                          <span class="demonstration">Projet concerné *</span>
                          <el-select
                            filterable
                            v-model="projetS"
                            placeholder="Chantier concerné"
                            style="width:100%"
                          >
                            <el-option
                              v-for="item in listProjet"
                              :key="item.id"
                              :label="item.libelle"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                        </div>
                      </v-flex>
                      
                      <v-flex md3>
                        <div class="block">
                          <span class="demonstration">Désignation *</span>
                          <el-input
                            name="libelleEntre"
                            placeholder="Désignation"
                            v-model="libelleEntre"
                            style="width:100%"
                          ></el-input>
                        </div>
                      </v-flex>
                      <v-flex md3>
                        <div class="block">
                          <span class="demonstration">Type d'entrepot *</span>
                          <el-select
                            filterable
                            v-model="selectTypeEntre"
                            placeholder="Type d'entrepot "
                            style="width:100%"
                          >
                            <el-option
                              v-for="item in typeEntre"
                              :key="item.value"
                              :label="item.text"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </div>
                      </v-flex>
                      <v-flex md3 v-if="selectTypeEntre == '2'">
                        <div class="block">
                          <span class="demonstration"
                            >Capacité de la citerne *</span
                          >
                          <el-input
                            type="number"
                            :min="0"
                            name="seletCiterne"
                            placeholder="Capacité de la citerne"
                            v-model="seletCiterne"
                            style="width:100%"
                          ></el-input>
                        </div>
                      </v-flex>
                      <v-flex md3>
                        <div class="block">
                          <span class="demonstration">Ville *</span>
                          <el-input
                            name="ville"
                            placeholder="Ville"
                            v-model="ville"
                            style="width:100%"
                          ></el-input>
                        </div>
                      </v-flex>

                      <v-flex md3>
                        <div class="block">
                          <span class="demonstration">Quartier</span>
                          <el-input
                            name="quartier"
                            placeholder="Quartier"
                            v-model="quartier"
                            style="width:100%"
                          ></el-input>
                        </div>
                      </v-flex>
                    </v-layout>

                    <v-layout row>
                      <v-flex md3>
                        <div class="block">
                          <span class="demonstration">Chef d'entrepot *</span>
                          <el-select
                            filterable
                            v-model="selectChefEntre"
                            placeholder="Chef d'entrepot"
                            style="width:100%"
                          >
                            <el-option
                              v-for="item in users"
                              :key="item.id"
                              :label="item.nom"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                        </div>
                      </v-flex>
                      <v-flex md3>
                        <div class="block">
                          <span class="demonstration"
                            >Chef de validation *</span
                          >
                          <el-select
                            filterable
                            v-model="selectChefVali"
                            placeholder="Chef de validation"
                            style="width:100%"
                          >
                            <el-option
                              v-for="item in users"
                              :key="item.id"
                              :label="item.nom"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                        </div>
                      </v-flex>
                      <v-flex md3>
                        <div class="block">
                          <span class="demonstration">Commune *</span>
                          <el-input
                            name="commune"
                            placeholder="Commune"
                            v-model="commune"
                            style="width:100%"
                          ></el-input>
                        </div>
                      </v-flex>

                      <v-flex md3>
                        <div class="block">
                          <span class="demonstration">Description</span>
                          <el-input
                            type="textarea"
                            name="descriEntre"
                            placeholder="Description"
                            v-model="descriEntre"
                            style="width:100%"
                          ></el-input>
                        </div>
                      </v-flex>
                    </v-layout>

                    <br />
                  </v-stepper-content>

                  <v-stepper-content step="2" v-if="dialogEdit !== true">
                    <p align="center">
                      <v-chip
                        text-color="white"
                        label
                        color="primary"
                        style="font-size:22px; width:100%"
                      >
                        Identification du stock actuel
                        <v-icon right>shopping_cart</v-icon>
                      </v-chip>
                    </p>
                    <div>
                      <el-form
                          id="formBudget"
                          :model="formBudget"
                          ref="formBudget"
                          :label-position="labelPosition"
                          class="demo-form-inline"
                        >
                      <v-layout row>
                        <v-flex md4 class="mr-1">
                          <el-form-item
                            prop="ressource"
                            label="Type de ressource "
                            required
                            style="width:100%"
                          >
                            <el-select
                              filterable
                              default-first-option
                              v-model="formBudget.ressource"
                              v-on:change="loadUniteProduit(formBudget.ressource)"
                              placeholder="Selectionnez un type de ressource"
                              style="width:100%"
                            >
                              <el-option
                                v-for="item in listProd"
                                :key="item.id"
                                :label="item.value"
                                :value="item.id"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </v-flex>

                        <v-flex md4 class="mr-1">
                          <el-form-item
                            prop="categorie"
                            label="Catégorie de ressource"
                            required
                            style="width:100%"
                          >
                            <el-input type="text" :readonly="true" :value="valeurCategorie" placeholder="Catégorie" v-model="formBudget.categorie" style="width:100%"></el-input>                          
                          </el-form-item>
                        </v-flex>

                        <v-flex md2 class="mr-1">
                          <el-form-item
                            prop="unite"
                            label="Unité"
                            required
                            style="width:100%"
                          >
                            <el-input type="text" :readonly="true" :value="valeurUniteMateriel" placeholder="Unité" v-model="formBudget.unite" style="width:100%"></el-input>                          
                          </el-form-item>
                        </v-flex>

                        <v-flex md2 class="mr-1">
                          <el-form-item
                            prop="seuilAlerte"
                            label="Seuil d'alerte "
                            required
                            style="width:100%"
                          >
                            <el-input-number
                              controls-position="right"
                              v-model="formBudget.seuilAlerte"
                              :min="5"
                            ></el-input-number>
                          </el-form-item>
                        </v-flex>

                        <v-flex md2 class="ml-2">
                          <el-form-item label="action" style="width:100%">
                            <el-button
                              type="primary"
                              :disabled="!verifFormBudget"
                              @click="addProduit(formBudget)"
                              >Ajouter</el-button
                            >
                          </el-form-item>
                        </v-flex>
                      </v-layout>
                      </el-form>

                      <v-layout row>
                        <v-flex xs12>
                          <el-table :data="tableProduit" style="width: 100%">                       
                            <el-table-column
                              prop="ressource"
                              label="Type de ressource"
                              sortable
                            >
                            </el-table-column>
                            <el-table-column
                              prop="categorie"
                              label="Catégorie de ressource"
                              sortable
                            >
                            </el-table-column>
                            <el-table-column
                              prop="unite"
                              label="Unité"
                              sortable
                            >
                            </el-table-column>
                            <el-table-column
                              prop="seuilAlerte"
                              label="Seuil d'alerte"
                            >
                              <template slot-scope="scope">
                                {{
                                  new Intl.NumberFormat().format(
                                    scope.row.seuilAlerte
                                  )
                                }}
                              </template>
                            </el-table-column>

                            <el-table-column label="Operations">
                              <template slot-scope="scope">
                                <v-tooltip top>
                                  <v-btn
                                    slot="activator"
                                    fab
                                    small
                                    icons
                                    color="red"
                                    @click.native.prevent="
                                      deleteRow(scope.$index, tableProduit)
                                    "
                                    dark
                                  >
                                    <v-icon center>delete</v-icon>
                                  </v-btn>
                                  Supprimer
                                </v-tooltip>
                              </template>
                            </el-table-column>
                          </el-table>
                        </v-flex>
                      </v-layout>
                    </div>
                    <br />
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>

              <v-layout row>
                <v-spacer></v-spacer>

                <v-btn
                  v-if="dialogEdit !== true && formEtape == 2"
                  color="primary"
                  @click.native="formEtape = 1"
                  ><v-icon left>chevron_left</v-icon> Précedent</v-btn
                >
                <v-btn
                  v-if="dialogEdit !== true && formEtape == 1"
                  color="primary"
                  @click.native="formEtape = 2"
                  >Suivant<v-icon right>chevron_right</v-icon></v-btn
                >

                <!--<v-btn @click="clear" icons color="orange" dark>Annuler <v-icon right>close</v-icon></v-btn>-->
                <v-btn
                  v-if="dialogEdit !== true && formEtape == 2"
                  icons
                  color="green"
                  @click="submit()"
                  :disabled="!valid"
                  dark
                  >Enregistrer <v-icon right>save</v-icon></v-btn
                >
                <v-btn
                  v-if="dialogEdit"
                  icons
                  color="orange"
                  @click="submit()"
                  :disabled="!valid"
                  dark
                  >Enregistrer <v-icon right>save</v-icon></v-btn
                >
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT DE STOCK -->
    <v-dialog
      v-model="dialogStock"
      max-width="80%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="indigo darken-4">
          <v-toolbar-title>
            <span>Ajouter un nouveau stock </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogStock = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form
            v-model="valid"
            ref="formStock"
            lazy-validation
            id="formStock"
          >
            <v-container fluid grid-list-md>
              <p align="center">
                <v-chip
                  text-color="white"
                  label
                  color="indigo darken-4"
                  style="font-size:22px; width:100%"
                >
                  Ajout d'un nouveau stock de produit dans l'entrepot ENTR-{{
                    entrepotCourant.id
                  }}
                  <v-icon right>shopping_cart</v-icon>
                </v-chip>
              </p>
              <v-flex xs12 class="text-xs-right">
                <v-tooltip top>
                  <input
                    name="fileInputExcel"
                    type="file"
                    style="display:none"
                    ref="fileInputExcel"
                    accept="image/*"
                    v-on:change="onFileExcelPicked"
                  />
                  <v-btn
                    v-if="true"
                    slot="activator"
                    color="green"
                    @click.stop="$refs.fileInputExcel.click()"
                    dark
                  >
                    Importer
                    <v-icon right>file_download</v-icon> </v-btn
                  >Importer fichier excel
                </v-tooltip>
                <v-tooltip top>
                  <v-btn
                    v-if="true"
                    slot="activator"
                    color="orange"
                    @click.stop="dialogImport = true"
                    dark
                  >
                    Générer
                    <v-icon right>file_upload</v-icon> </v-btn
                  >Générer un modèle
                </v-tooltip>
              </v-flex>
              <v-layout row>
                <!-- <v-flex md3>
                  <span class="demonstration">Type ressource *</span>
                  <el-select
                    name="typeProduit"
                    id="typeProduit"
                    v-model="prodSelct"
                    @change="loadTypeProduit()"
                    clearable
                    filterable
                    placeholder="Type ressource"
                    style="width:100%"
                  >
                    <el-option
                      v-for="item in listTypeRessource"
                      :key="item.id"
                      :label="item.libelle"
                      :value="item.libelle"
                    >
                    </el-option>
                  </el-select>
                </v-flex> -->
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Type de ressource *</span>
                    <el-select
                      v-on:change="loadUniteProduit(selectProduitRestant)"
                      clearable
                      filterable
                      v-model="selectProduitRestant"
                      placeholder="Type de ressource"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listProd"
                        :key="item.id"
                        :label="item.value"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Catégorie de ressource </span>
                    <el-input type="text" :readonly="true" :value="valeurCategorie" placeholder="Catégorie" v-model="valeurCategorie" style="width:100%"></el-input>                                            
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Unité *</span>
                    <el-input
                      type="text"
                      name="valeurSelect"
                      :readonly="true"
                      v-model="valeurUniteMateriel"
                      style="width:100%"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Seuil du stock *</span>
                    <el-input
                      type="number"
                      :min="0"
                      name="seuilStock"
                      placeholder="Seuil du stock"
                      v-model="seuilStock"
                      style="width:100%"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>
              <v-flex
                xs12
                class="text-xs-right"
                v-if="selectProduitRestant != '' && this.seuilStock != 0"
              >
                <v-btn
                  icons
                  color="primary"
                  id="plus"
                  @click="addListProduit()"
                  fab
                  small
                  dark
                >
                  <v-icon>add</v-icon></v-btn
                >
              </v-flex>

              <br />
              <v-layout row>
                <el-table :data="tabListProduit" style="width: 100%">
                  <el-table-column prop="libelle" label="Type de ressource"> </el-table-column>
                  <el-table-column prop="type" label="Catégorie de ressource"> </el-table-column>
                  <el-table-column prop="unite" label="Unité">
                  </el-table-column>
                  <el-table-column prop="seuil" label="Seuil"></el-table-column>
                  <el-table-column label="Operations">
                    <template slot-scope="scope">
                      <v-tooltip top>
                        <v-btn
                          slot="activator"
                          fab
                          small
                          icons
                          color="red"
                          @click.native.prevent="
                            deleteRow(scope.$index, tabListProduit)
                          "
                          dark
                        >
                          <v-icon center>delete</v-icon>
                        </v-btn>
                        Supprimer cette ligne
                      </v-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
              </v-layout>
              <v-btn @click="dialogStock = false" color="orange" dark
                >Annuler <v-icon right>close</v-icon></v-btn
              >
              <v-btn
                v-if="this.tabListProduit.length != 0"
                icons
                color="blue"
                @click="submitStock()"
                :disabled="!valid"
                dark
                >Enregistrer <v-icon right>save</v-icon></v-btn
              >
            </v-container>
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT DE SORTIE -->
    <v-dialog
      v-model="dialogSortie"
      max-width="80%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="red">
          <v-toolbar-title>
            <span v-if="dialogEdit != true">Ajouter un nouvel enlèvement </span>
            <span v-if="dialogEdit"
              >Modification de l'enlèvement {{ entrepotCourant.libelle }}
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click.native="
              dialogSortie = false;
              disableOption = false;
            "
            dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form
            v-model="valid"
            ref="formSortie"
            lazy-validation
            id="formSortie"
          >
            <v-container fluid grid-list-md>
              <p align="center">
                <v-chip
                  text-color="white"
                  label
                  color="red"
                  style="font-size:22px; width:100%"
                >
                  SORTI D'UN PRODUIT DE L'ENTREPOT
                  <v-icon right>last_page</v-icon>
                </v-chip>
              </p>

              <v-layout row>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Date de sortie *</span>
                    <el-date-picker
                      :readonly="disableOption"
                      v-model="dateS"
                      name="dateS"
                      id="dateS"
                      value-format="dd-MM-yyyy"
                      type="date"
                      placeholder="Date de sortie"
                      style="width: 100%"
                    ></el-date-picker>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Demandeur *</span>
                    <el-input
                      name="destinataireSortie"
                      placeholder="Demandeur"
                      v-model="destinataireSortie"
                      style="width:100%"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Remarque</span>
                    <el-input
                      type="textarea"
                      name="remarqueSortie"
                      placeholder="Remarque"
                      v-model="remarqueSortie"
                      style="width:100%"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Type de sortie *</span>
                    <el-select
                      :disabled="disableOption"
                      v-model="selectTypeSortie"
                      placeholder="Type de sortie"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in typeSortie"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>

              <p align="center">
                <v-chip
                  v-if="selectTypeSortie == 1"
                  text-color="white"
                  label
                  color="red"
                  style="font-size:22px; width:100%"
                >
                  SORTIR CONCERNANT UN CHANTIER <v-icon right>last_page</v-icon>
                </v-chip>
              </p>

              <!-- PROJET -->
              <v-layout v-if="selectTypeSortie == 1" row>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Projet concerné *</span>
                    <el-select
                      filterable
                      v-on:change="loadChantier()"
                      v-model="projetS"
                      placeholder="Chantier concerné"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listProjet"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Chantier concerné *</span>
                    <el-select
                      filterable
                      v-on:change="loadTravaux()"
                      v-model="chantierS"
                      placeholder="Chantier concerné"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listChantier"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Travaux *</span>
                    <el-select
                      filterable
                      v-model="travauxS"
                      placeholder="Travaux"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listTravaux"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>

              <p align="center">
                <v-chip
                  v-if="selectTypeSortie == 2"
                  text-color="white"
                  label
                  color="red"
                  style="font-size:22px; width:100%"
                >
                  SORTIR CONCERNANT UNE DEMANDE DE MAINTENANCE
                  <v-icon right>last_page</v-icon>
                </v-chip>
              </p>

              <!-- MAINTENANCE -->
              <v-layout v-if="selectTypeSortie == 2" row>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration"
                      >Demande de maintenance concerné *</span
                    >
                    <el-select
                      :disabled="disableOption"
                      v-model="selectDemande"
                      placeholder="Demande de maintenance concerné"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listDemande"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>

              <p align="center">
                <v-chip
                  text-color="white"
                  label
                  color="red"
                  style="font-size:22px; width:100%"
                >
                  PRODUIT A SORTIR <v-icon right>last_page</v-icon>
                </v-chip>
              </p>

              <v-layout
                row
                v-for="(optionS, index) in optionSortie"
                :key="optionS.key"
              >
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Désignation *</span>
                    <el-input
                      v-if="optionS.qte !== 0"
                      :readonly="true"
                      :prop="'optionSortie.' + index + '.produit'"
                      value="produit"
                      placeholder="Demandeur"
                      v-model="optionS.produit"
                      style="width:100%"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md2>
                  <div class="block">
                    <span class="demonstration">Quantité sortie *</span>
                    <el-input
                      :readonly="disableOption"
                      type="number"
                      :min="0"
                      :max="optionS.qte"
                      v-if="optionS.qte !== 0"
                      :prop="'optionSortie.' + index + '.qteS'"
                      value="qteS"
                      placeholder="Quantité sortie"
                      v-model="optionS.qteS"
                      style="width:100%"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md2>
                  <div class="block">
                    <span class="demonstration">Etat du produit *</span>
                    <el-select
                      v-if="optionS.qte !== 0"
                      filterable
                      :prop="'optionSortie.' + index + '.etat'"
                      v-model="optionS.selectEtatProduit"
                      name="etat"
                      placeholder="Etat du produit"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in etatProduit"
                        :key="item.text"
                        :label="item.text"
                        :value="item.text"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md2>
                  <div class="block">
                    <span class="demonstration"
                      >Un retour est-il prévue ? *</span
                    >
                    <el-select
                      v-if="optionS.qte !== 0"
                      filterable
                      :prop="'optionSortie.' + index + '.retour'"
                      v-model="optionS.selectRetourPrev"
                      name="retour"
                      placeholder="Un retour est-il prévue ?"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in retourPrev"
                        :key="item.text"
                        :label="item.text"
                        :value="item.text"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md3 v-if="optionS.selectRetourPrev === 'Oui'">
                  <div class="block">
                    <span class="demonstration">Date du retour ? *</span>
                    <el-date-picker
                      v-if="optionS.qte !== 0"
                      :prop="'optionSortie.' + index + '.dateRe'"
                      v-model="optionS.dateRe"
                      name="dateRe"
                      id="dateRe"
                      value-format="dd-MM-yyyy"
                      type="date"
                      placeholder="Date du retour ?"
                      style="width: 100%"
                    ></el-date-picker>
                  </div>
                </v-flex>
              </v-layout>
              <br />

              <v-btn
                @click="
                  dialogSortie = false;
                  disableOption = false;
                "
                color="orange"
                dark
                >Annuler <v-icon right>close</v-icon></v-btn
              >
              <v-btn
                icons
                color="blue"
                @click="submitSortie()"
                :disabled="!valid"
                dark
                >Enregistrer <v-icon right>save</v-icon></v-btn
              >
            </v-container>
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT DE SORTIE CARBURANT -->
    <v-dialog
      v-model="dialogCarburanSortie"
      max-width="80%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="red">
          <v-toolbar-title>
            <span v-if="dialogEdit != true">Ajouter un nouvel enlèvement </span>
            <span v-if="dialogEdit"
              >Modification de l'enlèvement {{ entrepotCourant.libelle }}
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click.native="
              dialogCarburanSortie = false;
              disableOption = false;
            "
            dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form
            v-model="valid"
            ref="formSortie"
            lazy-validation
            id="formSortie"
          >
            <v-container fluid grid-list-md>
              <p align="center">
                <v-chip
                  text-color="white"
                  label
                  color="red"
                  style="font-size:22px; width:100%"
                >
                  SORTI DE CARBURANT CONCERNANT UNE TACHE
                  <v-icon right>last_page</v-icon>
                </v-chip>
              </p>

              <!-- PROJET -->
              <v-layout row>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Projet concerné *</span>
                    <el-select
                      :disabled="detailEntre.typeHydro"
                      filterable
                      v-on:change="loadChantier()"
                      v-model="projetS"
                      placeholder="Chantier concerné"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listProjet"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Chantier concerné *</span>
                    <el-select
                      :disabled="detailEntre.typeHydro"
                      filterable
                      v-on:change="loadTravaux()"
                      v-model="chantierS"
                      placeholder="Chantier concerné"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listChantier"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Travaux *</span>
                    <el-select
                      :disabled="detailEntre.typeHydro"
                      filterable
                      v-model="travauxS"
                      placeholder="Travaux"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listTravaux"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Tache *</span>
                    <el-select
                      :disabled="detailEntre.typeHydro"
                      filterable
                      v-model="tacheS"
                      placeholder="Tâche"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listTravaux"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>

              <p align="center">
                <v-chip
                  text-color="white"
                  label
                  color="red"
                  style="font-size:22px; width:100%"
                >
                  SORTI D'UNE QUANTITE <v-icon right>last_page</v-icon>
                </v-chip>
              </p>

              <v-layout row>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Demandeur *</span>
                    <el-input
                      :disabled="detailEntre.typeHydro"
                      name="destinataireSortie"
                      placeholder="Demandeur"
                      v-model="destinataireSortie"
                      style="width:100%"
                    ></el-input>
                  </div>
                </v-flex>

                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Date de sortie *</span>
                    <el-date-picker
                      :readonly="disableOption"
                      v-model="dateS"
                      name="dateS"
                      id="dateS"
                      value-format="dd-MM-yyyy"
                      type="date"
                      placeholder="Date de sortie"
                      style="width: 100%"
                    ></el-date-picker>
                  </div>
                </v-flex>

                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Remarque</span>
                    <el-input
                      type="textarea"
                      name="remarqueSortie"
                      placeholder="Remarque"
                      v-model="remarqueSortie"
                      style="width:100%"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <p align="center">
                <v-chip
                  text-color="white"
                  label
                  color="red"
                  style="font-size:22px; width:100%"
                >
                  VEHICULE/ENGIN<v-icon right>last_page</v-icon>
                </v-chip>
              </p>

              <v-layout
                row
                v-for="(optionS, index) in optionSortie"
                :key="optionS.key"
              >
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Engin *</span>
                    <el-input
                      v-if="optionS.qte !== 0"
                      :readonly="true"
                      :prop="'optionSortie.' + index + '.produit'"
                      value="produit"
                      placeholder="Demandeur"
                      v-model="optionS.produit"
                      style="width:100%"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Quantité demandé *</span>
                    <el-input
                      :readonly="true"
                      :prop="'optionSortie.' + index + '.qte'"
                      value="qte"
                      placeholder="qte"
                      v-model="optionS.qte"
                      style="width:100%"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Quantité sortie *</span>
                    <el-input
                      :readonly="disableOption"
                      type="number"
                      :min="0"
                      :max="'optionSortie.' + index + '.qte'"
                      :prop="'optionSortie.' + index + '.qteS'"
                      value="qteS"
                      placeholder="Quantité sortie"
                      v-model="optionS.qteS"
                      style="width:100%"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Carburant *</span>
                    <el-select
                      v-model="optionS.carburant"
                      placeholder="Selectionner le carburant"
                    >
                      <el-option
                        v-for="item in listStock"
                        :key="item.value"
                        :label="item.produit"
                        :value="item.id"
                        style="width:100%"
                      >
                      </el-option>
                    </el-select>

                    <!-- <el-input :readonly= "disableOption"  type="number" :min="0" :max="optionS.qte" :prop="'optionSortie.' + index + '.qteS'" value="qteS" placeholder="Quantité sortie" v-model="optionS.qteS" style="width:100%"></el-input> -->
                  </div>
                </v-flex>
              </v-layout>
              <br />

              <v-btn
                @click="
                  dialogCarburanSortie = false;
                  disableOption = false;
                "
                color="orange"
                dark
                >Annuler <v-icon right>close</v-icon></v-btn
              >
              <v-btn
                icons
                color="blue"
                @click="submitSortie()"
                :disabled="!valid"
                dark
                >Enregistrer <v-icon right>save</v-icon></v-btn
              >
            </v-container>
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT DE ENTREE -->
    <v-dialog
      v-model="dialogEntree"
      max-width="80%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span v-if="dialogEdit != true"
              >Ajouter un nouveau retour pour la sortie SORT-{{
                sortieCourant.id
              }}
            </span>
            <span v-if="dialogEdit">Modification le retour </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogEntree = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form
            v-model="valid"
            ref="formEntree"
            lazy-validation
            id="formEntree"
          >
            <v-container fluid grid-list-md>
              <p align="center">
                <v-chip
                  text-color="white"
                  label
                  color="primary"
                  style="font-size:22px; width:100%"
                >
                  Retour dans l'entrepot <v-icon right>replay</v-icon>
                </v-chip>
              </p>

              <v-layout row style="font-size:15px; font-weight: bold">
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Réference du produit *</span>
                    <el-input
                      :value="sortieCourant.refProd"
                      placeholder="Réference du produit"
                      v-model="sortieCourant.refProd"
                      style="width:100%"
                      :disabled="true"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Produit sorti</span>
                    <el-input
                      :value="sortieCourant.produit"
                      placeholder="Produit sorti"
                      v-model="sortieCourant.produit"
                      style="width:100%"
                      :disabled="true"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Quantité sortie</span>
                    <el-input
                      :value="sortieCourant.qte"
                      placeholder="Quantité sortie"
                      v-model="sortieCourant.qte"
                      style="width:100%"
                      :disabled="true"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Date de sortie</span>
                    <el-input
                      :value="sortieCourant.dateS"
                      placeholder="Date de sortie"
                      v-model="sortieCourant.dateS"
                      style="width:100%"
                      :disabled="true"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Date de retour *</span>
                    <el-date-picker
                      v-model="dateRetour"
                      name="dateRetour"
                      id="dateRetour"
                      value-format="dd-MM-yyyy"
                      type="date"
                      placeholder="Date de retour"
                      style="width: 100%"
                    ></el-date-picker>
                  </div>
                </v-flex>
                <v-flex md2>
                  <div class="block">
                    <span class="demonstration">Quantité restante</span>
                    <el-input
                      :value="sortieCourant.qteRestante"
                      placeholder="Quantité restante"
                      v-model="sortieCourant.qteRestante"
                      style="width:100%"
                      :disabled="true"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md2>
                  <div class="block">
                    <span class="demonstration">Quantité restante</span>
                    <el-input
                      name="qteRetour"
                      type="number"
                      :min="0"
                      :max="sortieCourant.qteRestante"
                      @change="verifeClore()"
                      placeholder="Quantité restante"
                      v-model="qteRetour"
                      style="width:100%"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md2>
                  <div class="block">
                    <span class="demonstration">Etat du produit *</span>
                    <el-select
                      filterable
                      v-model="selectEtatRetour"
                      placeholder="Etat du produit"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in etatRetour"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md3 v-if="verifeEtat == true">
                  <div class="block">
                    <span class="demonstration"
                      >Qu'est-il arrivé aux autres produit ? *</span
                    >
                    <el-input
                      type="textarea"
                      name="raison"
                      placeholder="Qu'est-il arrivé aux autres produit ?"
                      v-model="raison"
                      style="width:100%"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Remarque</span>
                    <el-input
                      type="textarea"
                      name="remarqueRetour"
                      placeholder="Remarque"
                      v-model="remarqueRetour"
                      style="width:100%"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>
              <br />

              <v-btn @click="dialogEntree = false" color="orange" dark
                >Annuler <v-icon right>close</v-icon></v-btn
              >
              <v-btn
                icons
                color="blue"
                @click="submitEntree()"
                :disabled="!valid"
                dark
                >Enregistrer <v-icon right>save</v-icon></v-btn
              >
            </v-container>
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT DE TRANSFERT -->
    <v-dialog
      v-model="dialogTransfert"
      max-width="70%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue lighten-2">
          <v-toolbar-title>
            <span v-if="dialogEdit != true"
              >Ajouter une nouvelle demande de transfert
            </span>
            <span v-if="dialogEdit"
              >Modification de la demande transfert TRANS-{{
                transfertCourant.id
              }}
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogTransfert = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form
            v-model="valid"
            ref="formTransfert"
            lazy-validation
            id="formTransfert"
          >
            <v-container fluid grid-list-md>
              <p align="center">
                <v-chip
                  text-color="white"
                  label
                  color="blue lighten-2"
                  style="font-size:22px; width:100%"
                >
                  TRANSFERT DE PRODUIT
                  <v-icon right>transfer_within_a_station</v-icon>
                </v-chip>
              </p>

              <v-layout row>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Motif du transfert *</span>
                    <el-input
                      name="motifTransfert"
                      placeholder="Motif du transfert"
                      v-model="motifTransfert"
                      style="width:100%"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Priorité *</span>
                    <el-select
                      filterable
                      v-model="selectPriorite"
                      placeholder="Priorité"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in priorite"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Désignation *</span>
                    <el-select
                      filterable
                      v-model="selectProduitDemande"
                      placeholder="Désignation"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in produitStock"
                        :key="item.id"
                        :label="item.produit"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Quantité demandé *</span>
                    <el-input
                      type="number"
                      :min="0"
                      name="qteD"
                      placeholder="Quantité demandé"
                      v-model="qteD"
                      style="width:100%"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration"
                      >Entrepot concerné par la demande *</span
                    >
                    <el-select
                      filterable
                      v-model="selectEntrepot"
                      placeholder="Entrepot concerné par la demande"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listAutreEntrepot"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>
              <br />

              <v-btn @click="dialogTransfert = false" color="orange" dark
                >Annuler <v-icon right>close</v-icon></v-btn
              >
              <v-btn
                icons
                color="blue"
                @click="submitTransfert()"
                :disabled="!valid"
                dark
                >Enregistrer <v-icon right>save</v-icon></v-btn
              >
            </v-container>
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT DE REPONSE TRANSFERT -->
    <v-dialog
      v-model="dialogReponseTransfert"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="indigo">
          <v-toolbar-title>
            <span
              >Répondre à la demande de transfert TRANS-{{
                transfertCourant.id
              }}
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogReponseTransfert = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form
            v-model="valid"
            ref="formReponseTransfert"
            lazy-validation
            id="formReponseTransfert"
          >
            <v-container fluid grid-list-md>
              <p align="center">
                <v-chip
                  text-color="white"
                  label
                  color="indigo"
                  style="font-size:22px; width:100%"
                >
                  REPONSE AU TRANSFERT TRANS-{{ transfertCourant.id }}
                  <v-icon right>report</v-icon>
                </v-chip>
              </p>

              <v-layout row style="font-size:15px">
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Produit concerné</span>
                    <el-input
                      :value="transfertCourant.produit"
                      placeholder="Produit concerné"
                      v-model="transfertCourant.produit"
                      style="width:100%"
                      :disabled="true"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Quantité demande</span>
                    <el-input
                      :value="transfertCourant.qteD"
                      placeholder="Quantité demande"
                      v-model="transfertCourant.qteD"
                      style="width:100%"
                      :disabled="true"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Motif de la demande</span>
                    <el-input
                      :value="transfertCourant.motif"
                      placeholder="Motif de la demande"
                      v-model="transfertCourant.motif"
                      style="width:100%"
                      :disabled="true"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Date de la demande</span>
                    <el-input
                      :value="transfertCourant.date"
                      placeholder="Date de la demande"
                      v-model="transfertCourant.date"
                      style="width:100%"
                      :disabled="true"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration"
                      >Réponse à la demande éffectué *</span
                    >
                    <el-select
                      filterable
                      v-model="selectReponseTransfert"
                      placeholder="Réponse à la demande éffectué"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in reponseTransfert"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Remarque</span>
                    <el-input
                      type="textarea"
                      name="remarqueReponse"
                      placeholder="Remarque"
                      v-model="remarqueReponse"
                      style="width:100%"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md4 v-if="selectReponseTransfert === 1">
                  <div class="block">
                    <span class="demonstration">Quantité transferé</span>
                    <el-input
                      type="number"
                      :min="0"
                      name="qteT"
                      placeholder="Quantité transferé"
                      v-model="qteT"
                      style="width:100%"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>
              <br />

              <v-btn @click="dialogReponseTransfert = false" color="orange" dark
                >Annuler <v-icon right>close</v-icon></v-btn
              >
              <v-btn
                icons
                color="blue"
                @click="submitReponseTransfert()"
                :disabled="!valid"
                dark
                >Enregistrer <v-icon right>save</v-icon></v-btn
              >
            </v-container>
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT D'INVENTAIRE -->
    <v-dialog
      v-model="dialogInventaire"
      max-width="90%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue darken-2">
          <v-toolbar-title>
            <span>Ajouter un nouveau inventaire </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogInventaire = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form
            v-model="valid"
            ref="formInventaire"
            lazy-validation
            id="formInventaire"
          >
            <v-container fluid grid-list-md>
              <v-stepper v-model="formEtape">
                <v-stepper-header>
                  <v-stepper-step step="1" :complete="formEtape > 1">
                    PERIODE <v-icon right>event</v-icon></v-stepper-step
                  >
                  <v-divider></v-divider>
                  <v-stepper-step
                    step="2"
                    :complete="formEtape > 2"
                    v-if="dialogEdit !== true"
                  >
                    STOCK <v-icon right>shopping_cart</v-icon></v-stepper-step
                  >
                </v-stepper-header>
                <v-stepper-items>
                  <v-stepper-content step="1">
                    <p align="center">
                      <v-chip
                        text-color="white"
                        label
                        color="blue darken-2"
                        style="font-size:22px; width: 100%"
                      >
                        INVENTAIRE DE L'ENTREPOT ENTR-{{ entrepotCourant.id }}
                        <v-icon right>timeline</v-icon>
                      </v-chip>
                    </p>

                    <v-layout row>
                      <v-flex md6>
                        <div class="block">
                          <span class="demonstration">Date de début *</span>
                          <el-date-picker
                            v-model="dateDeb"
                            format="dd-MM-yyyy"
                            name="dateDeb"
                            id="dateDeb"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="Date de début"
                            style="width: 100%"
                          ></el-date-picker>
                        </div>
                      </v-flex>
                      <v-flex md6>
                        <div class="block">
                          <span class="demonstration">Date de fin *</span>
                          <el-date-picker
                            v-model="dateFin"
                            format="dd-MM-yyyy"
                            name="dateFin"
                            id="dateFin"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="Date de fin"
                            style="width: 100%"
                          ></el-date-picker>
                        </div>
                      </v-flex>
                    </v-layout>
                    <br />

                    <v-layout row>
                      <v-btn @click="clearInventaire" color="orange" dark
                        >Annuler <v-icon right>close</v-icon></v-btn
                      >
                      <v-spacer></v-spacer>
                      <v-btn
                        v-if="dateDeb != '' && dateFin != ''"
                        color="primary"
                        @click.native="formEtape = 2"
                        >Suivant<v-icon left>chevron_right</v-icon></v-btn
                      >
                    </v-layout>
                  </v-stepper-content>
                  <v-stepper-content step="2">
                    <p align="center">
                      <v-chip
                        text-color="white"
                        label
                        color="blue darken-2"
                        style="font-size:22px; width: 100%"
                      >
                        Identification du stock concerné
                        <v-icon right>shopping_cart</v-icon>
                      </v-chip>
                    </p>
                    <v-flex xs12 class="text-xs-right">
                      <v-tooltip top>
                        <input
                          name="fileInputExcelInvent"
                          type="file"
                          style="display:none"
                          ref="fileInputExcelInvent"
                          accept="image/*"
                          v-on:change="onFileExcelInvent"
                        />
                        <v-btn
                          v-if="true"
                          slot="activator"
                          color="green"
                          @click.stop="$refs.fileInputExcelInvent.click()"
                          dark
                        >
                          Importer
                          <v-icon right>file_download</v-icon> </v-btn
                        >Importer fichier excel
                      </v-tooltip>
                      <v-tooltip top>
                        <v-btn
                          v-if="true"
                          slot="activator"
                          color="orange"
                          @click.stop="dialogIventair = true"
                          dark
                        >
                          Générer
                          <v-icon right>file_upload</v-icon> </v-btn
                        >Générer un modèle
                      </v-tooltip>
                    </v-flex>

                    <v-layout row>
                      <!-- <v-flex md3>
                          <span class="demonstration">Type ressource *</span>
                            <el-select name="typeProduit" id="typeProduit"  v-model="prodSelct" @change="filterStock(prodSelct)" clearable filterable placeholder="Type ressource" style="width:100%">
                              <el-option v-for="item in listTypeRessource" :key="item.id" :label="item.libelle" :value="item.libelle">
                              </el-option>
                          </el-select>
                        </v-flex> -->
                    </v-layout>
                    <el-form
                      id="formAddStock"
                      ref="formAddStock"
                      label-position="top"
                      :inline="true"
                      :model="formAddStock"
                      class="demo-form-inline"
                    >
                      <v-layout row>
                        <v-flex md3>
                          <div class="block">
                            <span class="demonstration">Désignation *</span>
                            <el-select
                              clearable
                              filterable
                              v-model="formAddStock.designation"
                              @change="
                                filterProdStock(formAddStock.designation)
                              "
                              placeholder="Produit"
                              style="width:100%"
                            >
                              <el-option
                                v-for="item in listeInventaire"
                                :key="item.id"
                                :label="item.produit"
                                :value="item.id"
                              >
                              </el-option>
                            </el-select>
                          </div>
                        </v-flex>
                        <v-flex md3>
                          <div class="block">
                            <span class="demonstration">Unité*</span>
                            <el-input
                              type="text"
                              name="valeurSelect"
                              :readonly="true"
                              v-model="valeurUniteMateriel"
                              style="width:100%"
                            ></el-input>
                          </div>
                        </v-flex>
                        <v-flex md2>
                          <div class="block">
                            <span class="demonstration"
                              >Quantité théorique
                            </span>
                            <el-input
                              value="qte"
                              placeholder="Quantité théorique"
                              v-model="formAddStock.qte"
                              style="width: 100%"
                              :readonly="true"
                            ></el-input>
                          </div>
                        </v-flex>
                        <v-flex md3>
                          <div class="block">
                            <span class="demonstration">Quantité réele *</span>
                            <el-input
                              type="number"
                              :min="0"
                              value="qteReel"
                              placeholder="Quantité réele"
                              v-model="formAddStock.qteReel"
                              style="width: 100%"
                            ></el-input>
                          </div>
                        </v-flex>
                        <v-btn
                          icons
                          color="primary"
                          v-if="formAddStock.designation != ''"
                          id="plus"
                          @click="addNewStockProduit(formAddStock)"
                          fab
                          small
                          dark
                        >
                          <v-icon>add</v-icon></v-btn
                        >
                      </v-layout>
                    </el-form>
                    <br />
                    <v-layout row>
                      <el-table :data="tabNewstock" style="width: 100%">
                        <el-table-column prop="designation" label="Désignation">
                        </el-table-column>
                        <el-table-column prop="unite" label="Unité">
                        </el-table-column>
                        <el-table-column
                          prop="qteTeori"
                          label="Quantité théorique"
                        >
                        </el-table-column>
                        <el-table-column
                          prop="qteReel"
                          label="Quantité réele"
                        ></el-table-column>
                        <el-table-column label="Operations">
                          <template slot-scope="scope">
                            <v-tooltip top>
                              <v-btn
                                slot="activator"
                                fab
                                small
                                icons
                                color="red"
                                @click.native.prevent="
                                  deleteRowStock(scope.$index, tabNewstock)
                                "
                                dark
                              >
                                <v-icon center>delete</v-icon>
                              </v-btn>
                              Supprimer cette ligne
                            </v-tooltip>
                          </template>
                        </el-table-column>
                      </el-table>
                    </v-layout>
                    <br />
                    <v-layout row>
                      <v-btn @click="clearInventaire" color="orange" dark
                        >Annuler <v-icon right>close</v-icon></v-btn
                      >
                      <v-btn color="primary" @click.native="formEtape = 1"
                        ><v-icon left>chevron_left</v-icon> Précedent</v-btn
                      >
                      <v-spacer></v-spacer>
                      <v-btn
                        icons
                        color="green"
                        @click="submitInventaire()"
                        :disabled="!valid"
                        dark
                        >Enregistrer <v-icon right>save</v-icon></v-btn
                      >
                    </v-layout>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-container>
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION -->
    <v-dialog
      v-model="dialogConfir"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h3 align="center">
            Voulez-vous corriger le stock pour toutes les lignes?
          </h3>
          <p align="center">
            <v-btn @click.native="dialogConfir = false" color="orange" dark
              >Annuler <v-icon right>remove_circle</v-icon></v-btn
            >
            <v-btn icons color="green" @click.stop="confirmerAll" dark
              >Enregistrer <v-icon right>save</v-icon></v-btn
            >
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT DE VALIDATION D'INVENTAIRE -->
    <v-dialog
      v-model="dialogValiderInventaire"
      max-width="90%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="green lighten-2">
          <v-toolbar-title>
            <span
              >Validation de l'inventaire INVE-{{ inventaireCourant.id }}
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogValiderInventaire = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form
            v-model="valid"
            ref="formValiderInventaire"
            lazy-validation
            id="formValiderInventaire"
          >
            <v-container fluid grid-list-md>
              <p align="center">
                <v-chip
                  text-color="white"
                  label
                  color="green lighten-2"
                  style="font-size:22px;width:100%"
                >
                  VALIDATION DE L'INVENTAIRE DU STOCK DE L'ENTREPOT ENTR-{{
                    entrepotCourant.id
                  }}
                  <v-icon right>timeline</v-icon>
                </v-chip>
              </p>
              <v-flex xs12 class="text-xs-right">
                <v-tooltip top>
                  <v-btn
                    v-if="true"
                    slot="activator"
                    color="orange"
                    @click.stop="dialogConfir = true"
                    dark
                  >
                    Corriger (OUI)
                    <v-icon right>done_all</v-icon> </v-btn
                  >Confirmer pour tous
                </v-tooltip>
              </v-flex>

              <v-layout
                row
                v-for="(optionV, index) in optionInventaire"
                :key="optionV.key"
              >
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Désignation</span>
                    <el-input
                      value="produit"
                      :prop="'optionInventaire.' + index + '.produit'"
                      placeholder="Désignation"
                      v-model="optionV.produit"
                      style="width:100%"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md2>
                  <div class="block">
                    <span class="demonstration">Unité</span>
                    <el-input
                      value="unite"
                      :prop="'optionInventaire.' + index + '.unite'"
                      placeholder="Unité"
                      v-model="optionV.unite"
                      style="width:100%"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md2>
                  <div class="block">
                    <span class="demonstration">Quantité théorique</span>
                    <el-input
                      value="qteT"
                      :prop="'optionInventaire.' + index + '.qteT'"
                      placeholder="Quantité théorique"
                      v-model="optionV.qteT"
                      style="width:100%"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md1>
                  <div class="block">
                    <span class="demonstration">Quantité réele</span>
                    <el-input
                      value="qteReel"
                      :prop="'optionInventaire.' + index + '.qteReel'"
                      placeholder="Quantité réele"
                      v-model="optionV.qteReel"
                      style="width:100%"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md1>
                  <div class="block">
                    <span class="demonstration">Ecart type</span>
                    <el-input
                      value="ecart"
                      :prop="'optionInventaire.' + index + '.ecart'"
                      placeholder="Ecart type"
                      v-model="optionV.ecart"
                      style="width:100%"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md2>
                  <div class="block">
                    <span class="demonstration">Corriger le stock ? *</span>
                    <el-select
                      filterable
                      v-model="optionV.selectCorriger"
                      :prop="'optionInventaire.' + index + '.corriger'"
                      placeholder="Corriger le stock ?"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in corriger"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>
              <br />
              <v-flex xs12 class="text-xs-right">
                <v-btn
                  @click="dialogValiderInventaire = false"
                  color="orange"
                  dark
                  >Annuler <v-icon right>close</v-icon></v-btn
                >
                <v-btn
                  icons
                  color="green"
                  v-if="droitAcces.valider_inventaire"
                  @click="submitValiderInventaire()"
                  :disabled="!valid"
                  dark
                  >Enregistrer <v-icon right>save</v-icon></v-btn
                >
              </v-flex>
            </v-container>
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION -->
    <v-dialog
      v-model="dialogSupr"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h6 align="center">
            Voulez-vous vraiment supprimer cet enrégistrement ?
          </h6>
          <p align="center">
            <v-btn @click.native="dialogSupr = false" color="orange" dark
              >Annuler <v-icon right>remove_circle</v-icon></v-btn
            >
            <v-btn icons color="red" @click.stop="deleteEntrepot" dark
              >Supprimer <v-icon right>delete</v-icon></v-btn
            >
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- TABLEAU -->
    <v-card>
      <div>
        <v-chip text-color="white" label color="primary">
          LISTE DES ENTREPOTS <v-icon right>local_convenience_store</v-icon>
        </v-chip>
        <v-spacer></v-spacer>

        <div class="text-xs-center">
          <v-layout row>
            <v-flex
              v-if="
                droitAcces.imprime_pdf_histo_stock_liste_entrepot ||
                  droitAcces.imprime_exc_histo_stock_liste_entrepot
              "
            >
              <el-popover
                ref="popProjetStock"
                placement="top"
                width="180"
                trigger="hover"
              >
                <p>Veuillez choisir le format d'impression ?</p>
                <div style="text-align: right; margin: 0">
                  <el-button
                    type="success"
                    size="mini"
                    v-if="droitAcces.imprime_pdf_histo_stock_liste_entrepot"
                    @click="imprimeListeHis('PDF')"
                    >PDF</el-button
                  >
                  <el-button
                    type="primary"
                    size="mini"
                    v-if="droitAcces.imprime_exc_histo_stock_liste_entrepot"
                    @click="imprimeListeHis('EXC')"
                    >EXCEL</el-button
                  >
                </div>
              </el-popover>
              <div>
                <el-button
                  v-popover:popProjetStock
                  type="warning"
                  icon="el-icon-printer"
                  >Rapport
                </el-button>
              </div>
            </v-flex>
          </v-layout>
        </div>

        <v-card-text>
          <data-tables :data="listEntrepot" style="width: 100%">
            <el-table-column
              prop="projet"
              label="Projet"
              width="370"
              fixed="left"
            >
              <template slot-scope="scope">
                <v-chip text-color="white" label color="warning">
                  {{ scope.row.projet }}
                </v-chip>
              </template>
            </el-table-column>
            <el-table-column
              prop="libelle"
              label="Libellé"
              width="370"
              fixed="left"
            >
              <template slot-scope="scope">
                <v-chip text-color="white" label color="primary">
                  {{ scope.row.libelle }}
                </v-chip>
              </template>
            </el-table-column>
            <el-table-column prop="ville" label="Localisation">
              <template slot-scope="scope">
                <v-chip text-color="white" label color="primary">
                  {{ scope.row.ville }} - {{ scope.row.commune }} -
                  {{ scope.row.quartier }}<v-icon right>location_on</v-icon>
                </v-chip>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="Type d'entrepot">
              <template slot-scope="scope">
                <v-chip
                  v-if="scope.row.type == '1' || scope.row.type == 'Produit'"
                  outline
                  text-color="orange"
                  label
                  color="orange"
                >
                  PRODUIT
                </v-chip>              
                <v-chip
                  v-if="
                    scope.row.type == '2' || scope.row.type == 'Hydrocarbure'
                  "
                  outline
                  text-color="warning"
                  label
                  color="warning"
                >
                  HYDROCARBURE
                </v-chip>
              </template>
            </el-table-column>
            <el-table-column label="Action" fixed="right">
              <template slot-scope="scope">
                <div class="text-xs-center">
                  <v-tooltip top>
                    <v-btn
                      slot="activator"
                      @click.stop="
                        showEntrepot(scope.row);
                        loadAutreEntrepot(scope.row);
                        loadProduitStock(scope.row);
                        loadProduitRestant(scope.row);
                      "
                      fab
                      dark
                      small
                      color="green"
                    >
                      <v-icon dark>folder_open</v-icon>
                    </v-btn>
                    Détails
                  </v-tooltip>
                  <v-tooltip top>
                    <v-btn
                      slot="activator"
                      @click.stop="editEntrepot(scope.row)"
                      fab
                      dark
                      small
                      color="blue"
                    >
                      <v-icon dark>edit</v-icon>
                    </v-btn>
                    Modifier
                  </v-tooltip>
                  <v-tooltip
                    top
                    v-if="
                      scope.row.idCreated == user.id ||
                        droitAcces.entrepot_delete
                    "
                  >
                    <v-btn
                      slot="activator"
                      @click.stop="
                        dialogSupr = true;
                        idEntrepot = scope.row.id;
                      "
                      fab
                      dark
                      small
                      color="red"
                    >
                      <v-icon dark>delete</v-icon>
                    </v-btn>
                    Supprimer
                  </v-tooltip>
                </div>
              </template>
            </el-table-column>
          </data-tables>          
        </v-card-text>
      </div>
    </v-card>

    <!-- MODAL SHOW APPRO -->
    <v-dialog
      v-model="showDetailAppro"
      max-width="60%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>
            <span>Détails de l'approvisionnement {{ approCourant.ref }}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="showDetailAppro = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text
          v-loading="loading"
          element-loading-text="Veuillez patientez ..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          <el-row :gutter="20" style="padding:10px;">
            <el-card class="box-card">
              <div class="grid-content" style="padding:3px;">
                <el-row>
                  <div class="text item">
                    <v-layout row justify>
                      <v-flex md6>
                        <p><b>N° Commande : </b> {{ approCourant.refCom }}</p>
                        <p><b>N° Livraison : </b> {{ approCourant.refLivr }}</p>
                        <p>
                          <b>Dispatching éffectué par : </b>
                          {{ approCourant.dispatching }}
                        </p>
                        <p><b>Livreur: </b> {{ approCourant.userCreated }}</p>
                      </v-flex>
                      <v-flex md6>
                        <p><b>Validé par : </b> {{ approCourant.created }}</p>
                        <p>
                          <b>Date de validation : </b>
                          {{ approCourant.created }}
                        </p>
                        <p><b>Service achat: </b> {{ approCourant.achat }}</p>
                        <p>
                          <b>Receptioniste: </b>
                          {{ approCourant.receptioniste }}
                        </p>
                      </v-flex>
                    </v-layout>
                  </div>
                </el-row>
              </div>
            </el-card>
          </el-row>
          <v-flex xs12 class="text-xs-right">
            <v-tooltip top>
              <v-btn
                slot="activator"
                icons
                color="orange"
                @click.stop="showDetailAppro = false"
                dark
                >Fermer <v-icon right>close</v-icon></v-btn
              >
              Fermer
            </v-tooltip>
            <v-tooltip top>
              <v-btn
                slot="activator"
                icons
                color="orange"
                @click.stop="imprimerAppro(approCourant)"
                dark
                >Imprimer <v-icon right>print</v-icon></v-btn
              >
              Imprimer la fiche
            </v-tooltip>
          </v-flex>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL IMPORTATION STOCK -->
    <v-dialog
      v-model="dialogImport"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h4 align="center">
            Nb: Le fichier contient uniquement les ressources qui ne figurent
            pas dans votre stock.
          </h4>
          <h4 align="center">
            Indiquer uniquement le seuil de chaque ligne de produit que vous
            souhaitez ajouter à votre stock.
          </h4>
          <h3 align="center">
            Supprimer ensuite les lignes restantes dans votre fichier avant
            importation.
          </h3>
          <p align="center">
            <v-btn @click.native="dialogImport = false" color="orange" dark
              >Annuler <v-icon right>remove_circle</v-icon></v-btn
            >
            <v-btn icons color="green" @click.stop="generateFileExcel()" dark
              >Généner <v-icon right>done</v-icon></v-btn
            >
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL IMPORTATION INVENTAIRE -->
    <v-dialog
      v-model="dialogIventair"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h4 align="center">
            Nb: Le fichier contient uniquement les ressources qui ne figurent
            dans votre stock.
          </h4>
          <h4 align="center">
            Indiquer uniquement la quantité réele de chaque ligne de produit que
            vous souhaitez corriger.
          </h4>
          <h3 align="center">
            Supprimer ensuite les lignes restantes dans votre fichier avant
            importation.
          </h3>
          <p align="center">
            <v-btn @click.native="dialogIventair = false" color="orange" dark
              >Annuler <v-icon right>remove_circle</v-icon></v-btn
            >
            <v-btn icons color="green" @click.stop="geneFileExcelInvent()" dark
              >Généner <v-icon right>done</v-icon></v-btn
            >
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
var echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/bar");
require("echarts/lib/chart/pictorialBar");
require("echarts/lib/chart/funnel");
require("echarts/lib/chart/sankey");
require("echarts/lib/chart/scatter");
require("echarts/lib/chart/pie");
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
import ECharts from "vue-echarts";
import "echarts/lib/chart/line";
import Loading from "@/components/Loading";
import $ from "jquery";
import Vue from "vue";

export default {
  components: { Loading, "v-chart": ECharts },
  name: "app",
  data() {
    return {
      val: 35,
      loading: false,
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      racourcis: [
        { path: "/", text: "Accueil", disabled: false },
        { path: "/entrepot", text: "Liste des entrepots", disabled: true }
      ],

      nbQteDisponible: 0,
      nbQteUtilise: 0,
      dialogAide: false,
      showTooltip: false,
      dataCommandeFour: {},
      dataFactHistoFour: {},
      dataNbFactFour: {},
      dataMntFactFour: [],
      dialogAjout: false,
      dialogStock: false,
      dialogCarburanSortie: false,
      dialogSortie: false,
      dialogEntree: false,
      dialogTransfert: false,
      dialogReponseTransfert: false,
      dialogInventaire: false,
      dialogValiderInventaire: false,
      dialogEdit: false,
      dialogShow: false,
      showDetailAppro: false,
      dialogShowSortie: false,
      dialogShowEntree: false,
      dialogShowInventaire: false,
      dialogShowTransfert: false,
      lstRessources: [],
      dialogSupr: false,
      dialogImport: false,
      valid: true,
      choix: true,
      formEtape: 1,
      tab: "fiche",
      listProd: [],
      listeProduitAffich: [],
      statsCarburant: [],
      infoSelect: [],
      typeEntre: [
        { text: "Produit", value: 1 },
        { text: "Hydrocarbure", value: 2 }
      ],
      selectTypeEntre: "",
      libelleEntre: "",
      seletCiterne: "",
      descriEntre: "",
      hauteur: "",
      aire: "",
      espace: "",
      travauxSId: "",
      resistance: "",
      ville: "",
      commune: "",
      quartier: "",
      optionStock: [
        {
          key: 1,
          ref: "",
          value: "",
          type: "",
          seuil: 0,
          unite: "",
          coche: false,
          id: ""
        }
      ],
      selectChefEntre: "",
      selectChefVali: "",
      users: [],
      listEntrepot: [],
      entrepotCourant: [],
      idEntrepot: "",
      detailEntre: [],
      showEnlevement: false,
      listStock: [],
      multipleSelection: [],
      optionSortie: [],
      selectEtatProduit: "",
      etatProduit: [{ text: "Très bon" }, { text: "Bon" }, { text: "Mauvais" }],
      selectRetourPrev: "",
      retourPrev: [{ text: "Non" }, { text: "Oui" }],
      dateRe: "",
      dateS: "",
      selectAll: false,
      remarqueSortie: "",
      destinataireSortie: "",
      projetS: "",
      chantierS: "",
      listSortie: [],
      sortieCourant: [],
      detailSortie: [],
      dateRetour: "",
      qteRetour: 0,
      verifeEtat: false,
      dialogConfir: false,
      remarqueRetour: "",
      selectEtatRetour: "",
      etatRetour: [
        { text: "Très bon", value: "Très bon" },
        { text: "Bon", value: "Bon" },
        { text: "Mauvais", value: "Mauvais" }
      ],
      raison: "",
      listEntree: [],
      entreeCourant: [],
      detailEntree: [],
      listAutreEntrepot: [],
      selectEntrepot: "",
      motifTransfert: "",
      selectPriorite: "",
      priorite: [
        { text: "Très urgent", value: 1 },
        { text: "Urgent", value: 2 },
        { text: "Pas urgent", value: 3 }
      ],
      qteD: 0,
      produitStock: [],
      selectProduitDemande: "",
      listTransfert: [],
      listTransfertEmis: [],
      listTransfertRecu: [],
      transfertCourant: [],
      detailTransfert: [],
      qteT: 0,
      remarqueReponse: "",
      selectReponseTransfert: "",
      reponseTransfert: [
        { text: "Accepté", value: 1 },
        { text: "Rejeté", value: 2 }
      ],
      dateFin: "",
      dateDeb: "",
      inventaireCourant: [],
      listSortie: [],
      optionInventaire: [],
      corriger: [{ text: "Oui", value: 1 }, { text: "Non", value: 2 }],
      stockInventaire: "",
      nomLivreur: "",
      selectCorriger: "",
      ecart: 0,
      qteReel: 0,
      projetS:'',
      totalEcartLigne: 0,
      detailInventaire: [],
      pourcentageNR: 0,
      pourcentageRP: 0,
      pourcentageRE: 0,
      pourcentageRD: 0,
      pourcentageRND: 0,
      pourcNR: 0,
      compt: 0,
      pourcRP: 0,
      pourcRE: 0,
      pourcRD: 0,
      pourcRND: 0,
      statsEntreApproAll: [],
      statsEntreAppro: [],
      nbrAppro: 0,
      nbrRetour: 0,
      nbrTrans: 0,
      nbrSortie: 0,
      nbrCarburant: 0,
      nbrApproEntre: 0,
      nbrRetourEntre: 0,
      nbrTransEntre: 0,
      nbrSortieEntre: 0,
      nbrCarburantEntre: 0,
      listProduitRestant: [],
      selectProduitRestant: "",
      seuilStock: 0,
      listAppro: [],
      listCarburant: [],
      listInventaire: [],
      approCourant: [],
      travauxS: "",
      optionBesoin: "",
      tacheS: "",
      listProjet: [],
      listChantier: [],
      listTravaux: [],
      //Importer fichier excel
      fileExcel: [],
      lstRessources: [],
      //imprimer
      disabledBtn: false,
      disabledBtnS: false,
      disabledBtnA: false,
      disabledBtnE: false,
      disabledBtnR: false,
      disabledBtnDTE: false,
      disabledBtnDTR: false,
      disabledBtnInv: false,
      disableOption: false,
      typeSortie: [
        { text: "Sortie pour un chantier", value: 1 },
        { text: "Sortie pour une maintenance", value: 2 }
      ],
      selectTypeSortie: "",
      listDemande: [],
      selectDemande: "",
      formProduit: {},
      rulesProduit: {
        reference: [{ required: false, message: "Veuillez saisir" }],
        produit: [{ required: false, message: "Veuillez saisir" }],
        unite: [{ required: false, message: "Veuillez saisir" }],
        idDemande: ""
      },
      dialogValidAppro: false,
      dialogValidCarburan: false,
      items: [
        { text: "OUI J'AI TOUT RECU", abbr: 1 },
        { text: "J'EN AI RECU QUELQUES-UNS", abbr: 2 }
      ],

      itemsCarburant: [
        { text: "TOUTE LA QUANITE", abbr: 1 },
        { text: "UNE CERTAINE QUANTITE", abbr: 2 }
      ],
      labelPosition: "top",
      qteLivDepart: 0,
      qteLivDepartRules: [v => !!v || "Champs obligatoire"],
      produitLiv: "",
      codetLiv: "",
      idProduitLiv: "",
      produitLivRules: [v => !!v || "Champs obligatoire"],
      choixValidLiv: "",
      choixValidLivRules: [v => !!v || "Champs obligatoire"],
      nbChoiceLiv: 0,
      nbChoiceLivRules: [v => !!v || "Champs obligatoire"],
      remarqueLivr: "",
      remarqueLivrRules: [v => !!v || "Champs obligatoire"],
      idApproLiv: "",
      listeStockSelect: [],
      tabListProduit: [],
      tabNewstock: [],
      prodSelct: "",
      listTypeRessource: [],
      listeInventaire: [],
      tableProduit: [],
      valeurUniteMateriel: '',
      valeurCategorie: '',
      formAddStock: {},
      dialogIventair: false,
      formBudget: {
        ressource: "",
        categorie: "",
        unite: '',
        seuilAlerte: 5,
      },
    };
  },
  computed: {
    verifFormBudget: function() {
      if (        
        this.formBudget.ressource != "" &&
        this.formBudget.seuilAlerte != "" 
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    addProduit(item) {
      if (this.tableProduit.length > 0) {
        let eltProd = this.tableProduit.find(
          elt =>           
            elt.idressource == this.infoSelect.id
        );
        if (eltProd != null) {
          this.$message.error("Cet element a déjà été ajouté à la liste");
          return;
        }
      }
      this.tableProduit.push({
        idressource: this.infoSelect.id,
        ressource: this.infoSelect.value,
        categorie: this.valeurCategorie,
        unite: this.valeurUniteMateriel,
        seuilAlerte: item.seuilAlerte
      });

      this.valeurUniteMateriel = "";
      this.valeurCategorie = ''
      this.formBudget.ressource = "";
      this.formBudget.seuilAlerte = 5;
      this.formBudget.categorie = "";
      this.formBudget.unite = "";
      this.infoSelect = []
    },
    geneFileExcelInvent() {
      this.dialogIventair = false;
      let url =
        this.domaine +
        "entrepot/exportEXC/inventairRessources/" +
        this.entrepotCourant.id;
      window.open(url);
    },
    generateFileExcel() {
      this.dialogImport = false;
      let url =
        this.domaine +
        "entrepot/exportEXC/stockListRessources/" +
        this.entrepotCourant.id;
      window.open(url);
    },
    onFileExcelInvent(event) {
      this.loading = true;
      this.fileExcel.splice(0, 1);
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".xls") <= 0) {
        return alert("Veuillez selectionner un fichier excel valide ");
      }
      if (files[0].size > 2097152) {
        this.$message.error("La taille du fichier est supérieur à 2 Mo");
        return;
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.fileExcel.push(fileReader.result);
      });
      fileReader.readAsDataURL(files[0]);
      let url = this.domaine + "entrepot/loadStockInventaitr/excel";
      let data = new FormData();
      data.append("fichierExcel", files[0], files[0][name]);
      this.$http.post(url, data).then(
        resp => {
          this.loading = false;
          this.$notify({
            title: "Chargement des données",
            message: "Chargement effectué",
            type: "success",
            position: "top-right",
            duration: 7000
          });
          this.tabNewstock = resp.body.listeTypeTravaux;
        },
        error => {
          this.loading = false;
          this.$message.error("Erreur lors de l'importation du fichier");
        }
      );
    },
    onFileExcelPicked(event) {
      this.loading = true;
      this.fileExcel.splice(0, 1);
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".xls") <= 0) {
        return alert("Veuillez selectionner un fichier excel valide ");
      }
      if (files[0].size > 2097152) {
        this.$message.error("La taille du fichier est supérieur à 2 Mo");
        return;
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.fileExcel.push(fileReader.result);
      });
      fileReader.readAsDataURL(files[0]);

      let url = this.domaine + "entrepot/loadStock/excel";
      let data = new FormData();
      data.append("fichierExcel", files[0], files[0][name]);
      this.$http.post(url, data).then(
        resp => {
          this.loading = false;
          this.$notify({
            title: "Chargement des données",
            message: "Chargement effectué",
            type: "success",
            position: "top-right",
            duration: 7000
          });
          this.tabListProduit = resp.body.listeTypeTravaux;
        },
        error => {
          this.loading = false;
          this.$message.error("Erreur lors de l'importation du fichier");
        }
      );
    },
    handleSelectionChange(val) {
      this.listeStockSelect = val;
    },
    headerRowStyle({ row, rowIndex }) {
      return { color: "black" };
    },
    getSummDetailBudget(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        if (index === 5) {
          sums[index] = "N/A";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = new Intl.NumberFormat().format(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          );
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    filtrerProduit() {
      let idType = this.prodSelct;
      let tab = this.listProduit;
      if (idType == null || idType == "undefined" || idType == "") {
        this.listProduit = tab;
        return;
      }

      let libele = this.listTypeRessource.find(function(item) {
        return item.id == idType;
      });

      this.listProduit = tab.filter(function(item) {
        return item.type == libele.value;
      });
      this.comboProduit = this.listProduit;
    },
    loadUniteProduit(item) {
      console.log("loadUniteProduit",item)
      let valeur;
      valeur = this.listeProduitAffich.find(function(element) {
        if (element.id == item) {
          return element;
        }
      });
      console.log("loadUniteProduit",valeur)

      this.infoSelect = valeur;
      this.valeurUniteMateriel = valeur.unite;
      this.formBudget.unite = valeur.unite
      this.formBudget.categorie = valeur.type
      this.valeurCategorie = valeur.type;

    },
    loadTypeProduit() {
      this.loading = true;
      if (this.prodSelct != 0) {
        let url = this.domaine + "product/productSelect/type/" + this.prodSelct;
        this.$http.get(url).then(
          response => {
            this.loading = false;
            this.listProd = response.body.produits;
            this.listeProduitAffich = response.body.produits;
          },
          errRep => {
            this.loading = false;
          }
        );
      } else {
        this.loading = false;
      }
    },
    allCheck(value) {
      for (let optionSt in this.optionStock) {
        this.optionStock[optionSt].coche = value;
      }
    },
    querySearch(queryString, cb) {
      var links = this.listProd;
      var results = queryString
        ? links.filter(this.createFilter(queryString))
        : links;
      cb(results);
    },
    createFilter(queryString) {
      return link => {
        return (
          link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    chartsSortie() {
      let optionSortieAll = {
        title: {
          text: "Etat globale des sorties",
          subtext: "",
          left: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          x: "left",
          data: [
            "Sortie avec non retour",
            "Sortie avec retour prévue",
            "Retour éffectué",
            "Retour retardé",
            "Retour non éffectué avec un delai encore valide"
          ]
        },
        series: [
          {
            type: "pie",
            radius: ["50%", "80%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center"
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "12",
                  fontWeight: "bold"
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              { value: this.pourcentageNR, name: "Sortie avec non retour" },
              { value: this.pourcentageRP, name: "Sortie avec retour prévue" },
              { value: this.pourcentageRE, name: "Retour éffectué" },
              { value: this.pourcentageRD, name: "Retour retardé" },
              {
                value: this.pourcentageRND,
                name: "Retour non éffectué avec un délai valide"
              }
            ]
          }
        ]
      };

      let chartsSortieAll = echarts.init(
        document.getElementById("chartsSortieAll")
      );
      chartsSortieAll.setOption(optionSortieAll);
    },
    chartsAppro() {
      var dataAxis = [];
      var data = [];
      var yMax = 500;
      var dataShadow = [];

      for (var i = 0; i < data.length; i++) {
        dataShadow.push(yMax);
      }

      let optionApproAll = {
        title: {
          text: "Evolution des approvisionnements",
          subtext: "",
          left: "center"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        xAxis: {
          data: [],
          axisLabel: {
            inside: true,
            textStyle: {
              color: "#000"
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          z: 10
        },
        yAxis: {
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: "#999"
            }
          }
        },
        dataZoom: [
          {
            type: "inside"
          }
        ],
        series: [
          {
            // For shadow
            type: "bar",
            itemStyle: {
              normal: { color: "rgba(0,0,0,0.05)" }
            },
            barGap: "-100%",
            barCategoryGap: "40%",
            data: dataShadow,
            animation: false
          },
          {
            type: "bar",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#83bff6" },
                  { offset: 0.5, color: "#188df0" },
                  { offset: 1, color: "#188df0" }
                ])
              },
              emphasis: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#2378f7" },
                  { offset: 0.7, color: "#2378f7" },
                  { offset: 1, color: "#83bff6" }
                ])
              }
            },
            data: []
          }
        ]
      };

      // Enable data zoom when user click bar.
      var zoomSize = 23;

      this.statsEntreApproAll.forEach(function(element) {
        optionApproAll.xAxis.data.push(element.date);
        optionApproAll.series[1].data.push(element.nbr);
      });

      let chartsApproAll = echarts.init(
        document.getElementById("chartsApproAll")
      );
      chartsApproAll.setOption(optionApproAll);
    },
    chartsApproEntre() {
      var dataAxis = [];
      var data = [];
      var yMax = 500;
      var dataShadow = [];

      for (var i = 0; i < data.length; i++) {
        dataShadow.push(yMax);
      }

      let optionApproEntre = {
        title: {
          text: "Evolution des approvisionnements",
          subtext: "",
          left: "center"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        xAxis: {
          data: [],
          axisLabel: {
            inside: true,
            textStyle: {
              color: "#000"
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          z: 10
        },
        yAxis: {
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: "#999"
            }
          }
        },
        dataZoom: [
          {
            type: "inside"
          }
        ],
        series: [
          {
            // For shadow
            type: "bar",
            itemStyle: {
              normal: { color: "rgba(0,0,0,0.05)" }
            },
            barGap: "-100%",
            barCategoryGap: "40%",
            data: dataShadow,
            animation: false
          },
          {
            type: "bar",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#83bff6" },
                  { offset: 0.5, color: "#188df0" },
                  { offset: 1, color: "#188df0" }
                ])
              },
              emphasis: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#2378f7" },
                  { offset: 0.7, color: "#2378f7" },
                  { offset: 1, color: "#83bff6" }
                ])
              }
            },
            data: []
          }
        ]
      };

      // Enable data zoom when user click bar.
      var zoomSize = 23;

      this.statsEntreAppro.forEach(function(element) {
        optionApproEntre.xAxis.data.push(element.date);
        optionApproEntre.series[1].data.push(element.nbr);
      });

      let chartsApproEntre = echarts.init(
        document.getElementById("chartsApproEntre")
      );
      chartsApproEntre.setOption(optionApproEntre);
    },
    chartsSortieEntre() {
      let optionSortieEntre = {
        title: {
          text: "Etat globale des sorties",
          subtext: "",
          left: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          x: "left",
          data: [
            "Sortie avec non retour",
            "Sortie avec retour prévue",
            "Retour éffectué",
            "Retour retardé",
            "Retour non éffectué avec un delai encore valide"
          ]
        },
        series: [
          {
            type: "pie",
            radius: ["50%", "80%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center"
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "12",
                  fontWeight: "bold"
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              { value: this.pourcNR, name: "Sortie avec non retour" },
              { value: this.pourcRP, name: "Sortie avec retour prévue" },
              { value: this.pourcRE, name: "Retour éffectué" },
              { value: this.pourcRD, name: "Retour retardé" },
              {
                value: this.pourcRND,
                name: "Retour non éffectué avec un délai valide"
              }
            ]
          }
        ]
      };
      let chartsSortieEntre = document.getElementById("chartsSortieEntre")
        ? echarts.init(document.getElementById("chartsSortieEntre"))
        : null;
      if (document.getElementById("chartsSortieEntre") != null) {
        chartsSortieEntre.setOption(optionSortieEntre);
      }
    },
    loadUser() {
      this.loading = true;
      let url = this.domaine + "userCreate/user-list";
      this.$http.get(url).then(response => {
        this.loading = false;
        if (response.body) {
          this.users = response.body;
        }
      });
    },
    addListProduit() {
      let libelle = "";
      this.listProd.find(item => {
        if (item.id == this.selectProduitRestant) {
          libelle = item;
        }
      });
      console.log('jrjrr',libelle)
      this.tabListProduit.push({
        type: libelle.type,
        id: libelle.id,
        libelle: libelle.value,
        unite: this.valeurUniteMateriel,
        seuil: this.seuilStock
      });
      this.seuilStock = 0;
      this.selectProduitRestant = "";
      this.valeurUniteMateriel = "";
      this.valeurCategorie = ''
    },
    filterProdStock(produit) {
      this.formAddStock.qte = 0;
      this.optionInventaire.find(item => {
        if (item.id == produit) {
          this.valeurUniteMateriel = item.unite;
          this.formAddStock.qte = item.qte;
        }
      });
    },
    filterStock(prodSelct) {
      let valeur = this.optionInventaire;
      let prod = this.strNoAccent(prodSelct);
      console.log("prodSelct", prodSelct);
      console.log("optionInventaire", this.optionInventaire);
      this.listeInventaire = [];
      if (prodSelct != "") {
        this.optionInventaire.filter(item => {
          if (item.type != null) {
            if (
              this.strNoAccent(item.type.toUpperCase()) == prod.toUpperCase()
            ) {
              this.listeInventaire.push(item);
            }
          }
        });
      } else {
        this.listeInventaire = valeur;
      }
      console.log("this.listeInventaire", this.listeInventaire);
    },
    addNewStockProduit(item) {
      let libelle = [];
      this.optionInventaire.find(elemnt => {
        if (elemnt.id == item.designation) {
          libelle = elemnt;
        }
      });
      let etat = false;
      this.tabNewstock.find(elt => {
        if (item.id == libelle.id) {
          etat = true;
        }
      });
      if (etat == false) {
        this.tabNewstock.push({
          id: libelle.id,
          unite: this.valeurUniteMateriel,
          designation: libelle.produit,
          qteTeori: libelle.qte,
          qteReel: item.qteReel,
          ecart: parseInt(item.qteReel) - parseInt(libelle.qte)
        });
        this.formAddStock = {};
        this.valeurUniteMateriel = "";
      } else {
        this.$notify({
          title: "Ajout",
          message:
            "Impossible d'ajouter cette ressource, car elle existe déja dans le tableau d'inventaire.",
          type: "error",
          position: "top-center"
        });
      }
    },
    loadProduit() {
      this.loading = true;
      let url = this.domaine + "product/product-list";
      this.$http.get(url).then(response => {
        this.loading = false;
        if (response.body) {
          this.listProd = response.body;
          this.optionStock = this.listProd;
          this.listeProduitAffich = response.body;
        }
      });
    },
    loadProjet() {
      let url = this.domaine + "projet/index-projet-all";
      this.loading = true;
      this.$http.get(url).then(response => {
        this.loading = false;
        if (response.body) {
          this.listProjet = response.body.projet;
        }
      });
    },
    loadChantier() {
      this.loading = true;
      this.chantierS = "";
      this.travauxS = "";
      this.listChantier = [];
      if (this.projetS !== "") {
        let url = this.domaine + "projet/" + this.projetS + "/index/chantier";
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listChantier = response.body.chantier;
            this.loading = false;
          }
        });
      } else {
        this.$message.error("Veuillez sélectionner un projet");
        this.loading = false;
      }
    },
    loadTravaux() {
      this.loading = true;
      this.travauxS = "";
      this.listTravaux = [];
      if (this.chantierS !== "") {
        let url =
          this.domaine + "projet/" + this.chantierS + "/index/chantier/travaux";
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listTravaux = response.body.travaux;
            this.loading = false;
          }
        });
      } else {
        this.$message.error("Veuillez sélectionner un chantier");
        this.loading = false;
      }
    },
    loadDemande() {
      this.loading = true;
      this.listDemande = [];
      let url = this.domaine + "entrepot/index/demande/devis/valide";
      this.$http.get(url).then(response => {
        this.loading = false;
        if (response.body) {
          this.listDemande = response.body.demande;
          this.loading = false;
        }
      });
    },
    loadStock(ligne) {
      console.log("ligne", ligne);
      this.entrepotCourant = ligne;
      this.loading = true;
      let url = "";
      if (this.droitAcces.entrepot) {
        url = this.domaine + "entrepot/" + this.entrepotCourant.id + "/stock";
      } else {
        url =
          this.domaine +
          "entrepot/" +
          this.entrepotCourant.id +
          "/" +
          this.user.id +
          "/chefEntrepot/stock";
      }

      // if(this.droitAcces.index_stock_chefEntrepot){
      //    url = this.domaine + 'entrepot/' + this.entrepotCourant.id + '/' + this.user.id + '/chefEntrepot/stock'
      // }
      // if(this.droitAcces.index_stock_chefValidation){
      //   url = this.domaine + 'entrepot/' + this.entrepotCourant.id + '/' + this.user.id + '/stock'
      // }
      // if (this.droitAcces.index_stock) {//list de tous les stocks de lentrepot
      //   url = this.domaine + 'entrepot/' + this.entrepotCourant.id + '/stock'
      // }
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listStock = response.body.stock;
          this.optionInventaire = response.body.stock;
          this.listeInventaire = response.body.stock;
          if (this.listStock === undefined || this.listStock.length == 0) {
            this.disabledBtnS = true;
          } else {
            this.disabledBtnS = false;
          }

          for (let produit in this.listStock) {
            for (let optionSt in this.optionStock) {
              if (
                this.listStock[produit].idprod == this.optionStock[optionSt].id
              ) {
                this.selectAll = true;
                this.optionStock[optionSt].coche = true;
                this.optionStock[optionSt].unite = this.listStock[
                  produit
                ].unite;
                this.optionStock[optionSt].seuil = this.listStock[
                  produit
                ].seuil;
                this.optionStock[optionSt].type = this.listStock[produit].type;
              }
            }
          }
          this.loading = false;
        }
      });
    },
    loadProduitRestant(ligne) {
      this.entrepotCourant = ligne;
      let url =
        this.domaine +
        "entrepot/" +
        this.entrepotCourant.id +
        "/produit/restant";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listProduitRestant = response.body.produit;
        }
      });
    },
    loadAppro(ligne) {
      this.entrepotCourant = ligne;
      this.loading = true;
      let url = "";

      if (this.droitAcces.index_approvisionnement_chefEntrepot) {
        //vérification pour le chef de projet
        url =
          this.domaine +
          "entrepot/" +
          this.entrepotCourant.id +
          "/" +
          this.user.id +
          "/chefEntrepot/approvisionnement";
      }
      if (this.droitAcces.index_approvisionnement) {
        //pour celui qui a tout les droits
        url =
          this.domaine +
          "entrepot/" +
          this.entrepotCourant.id +
          "/approvisionnement";
      }
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listAppro = response.body.approvisionnement;
          if (this.listAppro === undefined || this.listAppro.length == 0) {
            this.disabledBtnA = true;
          } else {
            this.disabledBtnA = false;
          }
          this.loading = false;
        }
      });
    },
    loadACarburant(ligne) {
      this.entrepotCourant = ligne;
      this.loading = true;
      let url = "";

      if (this.droitAcces.index_approvisionnement_chefEntrepot) {
        //vérification pour le chef de projet
        url =
          this.domaine +
          "entrepot/" +
          this.entrepotCourant.id +
          "/" +
          this.user.id +
          "/chefEntrepot/demande/carburant";
      }
      if (this.droitAcces.index_approvisionnement) {
        //pour celui qui a tout les droits
        url =
          this.domaine +
          "entrepot/" +
          this.entrepotCourant.id +
          "/demande/carburant";
      }
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listCarburant = response.body.carburant;
          if (
            this.listCarburant === undefined ||
            this.listCarburant.length == 0
          ) {
            this.disabledBtnA = true;
          } else {
            this.disabledBtnA = false;
          }
          this.loading = false;
        }
      });
    },

    loadSortie(ligne) {
      this.entrepotCourant = ligne;
      this.loading = true;
      let url = "";
      // if (this.droitAcces.index_sortie) {
      url = this.domaine + "entrepot/" + this.entrepotCourant.id + "/sortie";
      // }
      //  if(this.droitAcces.index_sortie_chefEntrepot) {//vérification pour le chef de projet
      //   url = this.domaine + 'entrepot/' + this.entrepotCourant.id + '/' + this.user.id + '/chefEntrepot/sortie'
      // }
      // if (this.droitAcces.index_sortie_chefValidation) {//affiche les elements quil a creé utilisateur
      //   url = this.domaine + 'entrepot/' + this.entrepotCourant.id + '/' + this.user.id + '/sortie'
      // }

      this.$http.get(url).then(response => {
        if (response.body) {
          this.listSortie = response.body.sortie;
          if (this.listSortie === undefined || this.listSortie.length == 0) {
            this.disabledBtnE = true;
          } else {
            this.disabledBtnE = false;
          }
          this.loading = false;
        }
      });
    },
    loadEntree(ligne) {
      this.entrepotCourant = ligne;
      this.loading = true;

      let url = "";

      if (this.droitAcces.index_entree_chefEntrepot) {
        //vérification pour le chef de projet
        url =
          this.domaine +
          "entrepot/" +
          this.entrepotCourant.id +
          "/" +
          this.user.id +
          "/chefEntrepot/entree";
      }

      if (this.droitAcces.index_entree_chefValidation) {
        //affiche les elements pour le chef de validation
        url =
          this.domaine +
          "entrepot/" +
          this.entrepotCourant.id +
          "/" +
          this.user.id +
          "/entree";
      }

      if (this.droitAcces.index_entree) {
        //list de tous
        url = this.domaine + "entrepot/" + this.entrepotCourant.id + "/entree";
      }

      this.$http.get(url).then(response => {
        if (response.body) {
          this.listEntree = response.body.entree;
          if (this.listEntree === undefined || this.listEntree.length == 0) {
            this.disabledBtnR = true;
          } else {
            this.disabledBtnR = false;
          }

          this.loading = false;
        }
      });
    },
    loadEntrepot() {
      this.loading = true;
      let url = "";
      if (this.droitAcces.entrepot) {
        //list de tous
        url = this.domaine + "entrepot/index";
      } else {
        //vérification pour le chef de projet,chef validattion et aussi personne qui a fait lenregistrement (this.droitAcces.entrepot_unique_chefEntrepot_index)
        url =
          this.domaine +
          "entrepot/unique/" +
          this.user.id +
          "/chefEntrepot/index";
      }
      // else if(this.droitAcces.entrepot_unique_chefValidation_index){//affiche les elements pour le chef de validation
      //  url = this.domaine + 'entrepot/unique/'+ this.user.id +'/index'
      // }
      // else{
      //      url = this.domaine + 'entrepot/index'
      //  }

      this.disabledBtn = false;
      this.$http.get(url).then(
        response => {
          this.loading = false;
          if (response.body) {
            this.listEntrepot = response.body.entrepot;
            if (this.listEntrepot.length == 0) {
              this.disabledBtn = true;
            }
            this.statsEntreApproAll = response.body.stats;
            this.pourcentageNR = response.body.pourcentageNR;
            this.pourcentageRP = response.body.pourcentageRP;
            this.pourcentageRE = response.body.pourcentageRE;
            this.pourcentageRD = response.body.pourcentageRD;
            this.pourcentageRND = response.body.pourcentageRND;
            this.nbrAppro = response.body.nbrAppro;
            this.nbrRetour = response.body.nbrRetour;
            this.nbrTrans = response.body.nbrTrans;
            this.nbrSortie = response.body.nbrSortie;
            this.nbrCarburant = response.body.nbrCarburant;
            this.chartsSortie();
            this.chartsAppro();
          }
        },
        error => {
          this.loading = false;
        }
      );
    },
    loadAutreEntrepot(ligne) {
      this.loading = true;
      this.entrepotCourant = ligne;
      let url = this.domaine + "entrepot/autre/" + this.entrepotCourant.id;
      this.$http.get(url).then(
        response => {
          this.loading = false;
          if (response.body) {
            this.listAutreEntrepot = response.body.autre;
          }
        },
        error => {
          this.loading = false;
        }
      );
    },
    loadProduitStock(ligne) {
      this.loading = true;
      this.entrepotCourant = ligne;
      let url =
        this.domaine + "entrepot/stock/dispo/" + this.entrepotCourant.id;
      this.$http.get(url).then(
        response => {
          this.loading = false;
          if (response.body) {
            this.produitStock = response.body.stock;
          }
        },
        error => {
          this.loading = false;
        }
      );
    },
    loadTransfert(ligne) {
      this.loading = true;
      this.entrepotCourant = ligne;
      let url = "";

      if (this.droitAcces.index_transfert_chefEntrepot) {
        //vérification pour le chef de projet
        url =
          this.domaine +
          "entrepot/" +
          this.entrepotCourant.id +
          "/" +
          this.user.id +
          "/chefEntrepot/transfert";
      }
      if (this.droitAcces.index_transfert_chefValidation) {
        //affiche les elements quil a creé utilisateur
        url =
          this.domaine +
          "entrepot/" +
          this.entrepotCourant.id +
          "/" +
          this.user.id +
          "/transfert";
      }
      if (this.droitAcces.index_transfert) {
        url =
          this.domaine + "entrepot/" + this.entrepotCourant.id + "/transfert";
      }
      this.$http.get(url).then(
        response => {
          if (response.body) {
            this.listTransfert = response.body.transfert;
            this.listTransfertEmis = response.body.transfert.emis;
            if (
              this.listTransfertEmis === undefined ||
              this.listTransfertEmis.length == 0
            ) {
              this.disabledBtnDTE = true;
            } else {
              this.disabledBtnDTE = false;
            }
            this.listTransfertRecu = response.body.transfert.recu;
            if (
              this.listTransfertRecu === undefined ||
              this.listTransfertRecu.length == 0
            ) {
              this.disabledBtnDTR = true;
            } else {
              this.disabledBtnDTR = false;
            }

            this.loading = false;
          }
        },
        error => {
          this.loading = false;
          this.$message.error("Erreur lors du chargement");
        }
      );
    },
    loadInventaire(ligne) {
      this.loading = true;
      this.entrepotCourant = ligne;
      let url = "";
      if (this.droitAcces.entrepot) {
        url =
          this.domaine + "entrepot/" + this.entrepotCourant.id + "/inventaire";
      } else {
        url =
          this.domaine +
          "entrepot/" +
          this.entrepotCourant.id +
          "/" +
          this.user.id +
          "/chefEntrepot/inventaire";
      }

      //  if(this.droitAcces.index_inventaire_chefEntrepot) {//vérification pour le chef de projet
      //   url = this.domaine + 'entrepot/' + this.entrepotCourant.id + '/' + this.user.id + '/chefEntrepot/inventaire'
      // }
      // if(this.droitAcces.index_inventaire_chefValidation){//affiche les elements quil a creé utilisateur
      //   url = this.domaine + 'entrepot/' + this.entrepotCourant.id + '/' + this.user.id + '/inventaire'
      // }
      // if (this.droitAcces.index_inventaire) {
      //   url = this.domaine + 'entrepot/' + this.entrepotCourant.id + '/inventaire'
      // }
      this.$http.get(url).then(
        response => {
          this.loading = false;
          if (response.body) {
            this.listInventaire = response.body.inventaire;
            if (
              this.listInventaire === undefined ||
              this.listInventaire.length == 0
            ) {
              this.disabledBtnInv = true;
            } else {
              this.disabledBtnInv = false;
            }
            this.loading = false;
          }
        },
        error => {
          this.loading = false;
          this.$message.error("Erreur lors du chargement");
        }
      );
    },
    stockMultiSortie(val) {
      this.multipleSelection = val;
      if (this.multipleSelection.length === 0) {
        this.choix = true;
      } else {
        this.choix = false;
      }
    },
    stockSelect(row, index) {
      let etat = null;
      if (parseInt(row.qte) != 0) {
        etat = true;
      } else {
        etat = false;
      }
      console.log("jre", etat);
      return etat;
    },
    stockDemande(row, index) {
      let etat = null;
      if (parseInt(row.etat) != 0) {
        etat = true;
      } else {
        etat = false;
      }
      return etat;
    },
    newEntrepot() {
      this.loading = true;
      this.entrepotCourant.id = "";
      this.libelleEntre = "";
      this.seletCiterne = "";
      this.hauteur = "";
      this.aire = "";
      this.espace = "";
      this.selectChefEntre = "";
      this.selectChefVali = "";
      this.selectTypeEntre = "";
      this.resistance = "";
      this.ville = "";
      this.commune = "";
      this.quartier = "";
      this.projetS = ''
      this.loadUser(), this.loadProduit();
      this.optionStock = this.listProd;
      this.descriEntre = "";
      this.formEtape = 1;
      this.dialogEdit = false;
      this.dialogAjout = true;
    },
    newStock(ligne) {
      this.tabListProduit = [];
      this.loading = false;
      this.dialogStock = true;
      this.dialogEdit = false;
      this.valeurUniteMateriel = "";
      this.prodSelct = "";
      this.entrepotCourant = ligne;
    },
    newSortie(ligne) {
      if (this.showEnlevement) {
        this.loading = false;
        this.dialogCarburanSortie = true;
        this.dialogEdit = false;
        this.entrepotCourant = ligne;
        this.dateS = "";
        this.remarqueSortie = "";
        this.selectTypeSortie = 1;
        let comp = 0;
        this.factNull = false;
        for (let index = 0; index < this.multipleSelection.length; index++) {
          this.chantierS = this.multipleSelection[0]["chantier"];
          this.projetS = this.multipleSelection[0]["projet"];
          this.travauxS = this.multipleSelection[0]["travaux"];
          this.optionBesoin = this.multipleSelection[0]["id"];
          this.tacheSId = this.multipleSelection[0]["tacheId"];
          this.travauxSId = this.multipleSelection[0]["idTravaux"];
          this.tacheS = this.multipleSelection[0]["tache"];
          this.destinataireSortie = this.multipleSelection[0]["demnandeur"];

          let element1 = this.multipleSelection[0]["idTravaux"];
          const element = this.multipleSelection[index]["idTravaux"];
          const element2 = this.multipleSelection[index]["idTravaux"];
          let magasin1 = this.multipleSelection[0]["entrepotId"];

          if (element1 != "") {
            if (element1 == element) {
              comp++;
            } else {
              this.factNull = true;
              this.$refs.multipleTable.toggleRowSelection(
                this.multipleSelection[index]
              );
            }
          }
        }

        if (this.multipleSelection.length == comp && this.factNull === false) {
          let multipleSelection1 = this.multipleSelection;
          var tableau = multipleSelection1;
          for (var i = 0; i < tableau.length; ++i) {
            for (var j = i + 1; j < tableau.length; ++j) {
              if (tableau[i].idTravaux === tableau[j].idTravaux) {
                tableau[i].qte = tableau[i].qte + tableau[j].qte;
                tableau.splice(j--, 1);
              }
            }
          }
          this.optionSortie = tableau;
          this.idTravaux = this.multipleSelection[0]["idTravaux"];
          this.projetLib = this.multipleSelection[0]["projet"];
          this.dateLivr = this.multipleSelection[0]["dateLivr"];
          this.chantieretLib = this.multipleSelection[0]["chantier"];
          this.entrepotLib = this.multipleSelection[0]["libEntrepot"];
          this.travuxLib = this.multipleSelection[0]["travaux"];
          this.libelle = this.multipleSelection[0]["libelle"]
            ? this.multipleSelection[0]["libelle"]
            : "";
        } else {
          this.$notify({
            title: "Fusion",
            message:
              "Impossible de lier ces demandes de carburant pour le bon de sorti",
            type: "error",
            position: "top-center"
          });
        }
      } else {
        this.loading = false;
        this.dialogCarburanSortie = false;
        this.dialogSortie = true;
        this.dialogEdit = false;
        this.entrepotCourant = ligne;
        this.chantierS = "";
        this.projetS = "";
        this.travauxS = "";
        this.travauxSId = "";
        this.destinataireSortie = "";
        this.dateS = "";
        this.remarqueSortie = "";
        this.optionSortie = this.multipleSelection;
        for (let prop in this.optionSortie) {
          ligne = this.optionSortie[prop];
          if (ligne.qte === 0) {
            this.$notify({
              title: "ATTENTION",
              message: "Le stock de " + ligne.produit + " est vide.",
              type: "warning",
              position: "top-center"
            });
          }
        }
      }
    },
    newEntree(ligne) {
      this.loading = false;
      this.dialogEntree = true;
      this.dialogEdit = false;
      this.sortieCourant = ligne;
      this.dateRetour = "";
      this.qteRetour = 0;
      this.selectEtatRetour = "";
    },
    newTransfert(ligne) {
      this.loading = false;
      this.dialogTransfert = true;
      this.dialogEdit = false;
      this.entrepotCourant = ligne;
      this.selectEntrepot = "";
      this.motifTransfert = "";
      this.selectPriorite = "";
      this.selectProduitDemande = "";
      this.qteD = 0;
    },
    newReponseTransfert(ligne) {
      this.loading = false;
      this.dialogReponseTransfert = true;
      this.transfertCourant = ligne;
    },
    newInventaire(ligne) {
      this.formEtape = 1;
      this.loading = false;
      this.dialogInventaire = true;
      this.entrepotCourant = ligne;
      this.tabNewstock = [];
      console.log(this.optionInventaire);
      this.listeInventaire = this.optionInventaire;
      // this.optionInventaire = this.listStock
    },
    validerInventaire(ligne) {
      this.loading = false;
      this.dialogValiderInventaire = true;
      this.inventaireCourant = ligne;
      this.optionInventaire = this.inventaireCourant.valider;
    },
    editEntrepot(ligne) {
      this.loading = false;
      this.formEtape = 1;
      this.dialogAjout = true;
      this.dialogEdit = true;
      this.entrepotCourant = ligne;
      this.libelleEntre = this.entrepotCourant.libelle;
      this.seletCiterne = this.entrepotCourant.citerne;
      this.hauteur = this.entrepotCourant.hauteur;
      this.aire = this.entrepotCourant.aire;
      this.espace = this.entrepotCourant.espace;
      this.selectChefEntre = this.entrepotCourant.chefEntreId;
      this.selectChefVali = this.entrepotCourant.chefValiId;
      this.selectTypeEntre = this.entrepotCourant.type
      // if (this.entrepotCourant.type == '') {
      //   this.selectTypeEntre = "Produit";
      // } else if (
      //   this.entrepotCourant.type == 2 ||
      //   this.entrepotCourant.type == "Hydrocarbure"
      // ) {
      //   this.selectTypeEntre = "Hydrocarbure";
      // }
      this.resistance = this.entrepotCourant.resistance;
      this.ville = this.entrepotCourant.ville;
      this.commune = this.entrepotCourant.commune;
      this.quartier = this.entrepotCourant.quartier;
      this.descriEntre = this.entrepotCourant.descriEntre;
      this.projetS = this.entrepotCourant.projet;
      // requete pour recuperer les stock deja selectionne
      this.optionStock = this.listProd;
      this.loadStock(ligne);
    },
    editTransfert(ligne) {
      this.loading = false;
      this.dialogTransfert = true;
      this.dialogEdit = true;
      this.transfertCourant = ligne;
      this.selectEntrepot = this.transfertCourant.idEntR;
      this.motifTransfert = this.transfertCourant.motif;
      this.selectPriorite = parseInt(this.transfertCourant.priorite);
      this.selectProduitDemande = this.transfertCourant.stock;
      this.qteD = this.transfertCourant.qteD;
    },
    submit() {
      if (
        this.$refs.formEntrepot.validate() &&
        this.selectTypeEntre != "" &&
        this.selectChefEntre != "" &&
        this.selectChefVali != "" &&
        this.libelleEntre != "" &&
        this.projetS != "" &&
        this.ville != "" &&
        this.commune != ""
      ) {
        let url = "";
        console.log("entrepotCourant", this.entrepotCourant);
        if (this.entrepotCourant.id) {
          url = this.domaine + "entrepot/" + this.entrepotCourant.id + "/edit";
        } else {
          url = this.domaine + "entrepot/create";
        }
        var form = document.getElementById("formEntrepot");
        var data = new FormData(form);
        data.append("idUser", this.user.id);
        data.append("id", this.entrepotCourant.id);
        let detail = "";

        if (typeof this.selectTypeEntre != "string") {
          switch (this.selectTypeEntre) {
            case 1:
              detail = "Produit";
              break;
            case 2:
              detail = "Hydrocarbure";
              break;
            default:
              detail = "Produit";
              break;
          }
        } else {
          switch (this.selectTypeEntre) {
            case "Produit":
              detail = "Produit";
              break;
            case "Hydrocarbure":
              detail = "Hydrocarbure";
              break;
            default:
              detail = "Produit";
              break;
          }
        }
        data.append("type", detail);
        data.append("chefEntre", this.selectChefEntre);
        data.append("chefVali", this.selectChefVali);
        data.append("citerne", this.seletCiterne);     
        data.append("projetS", this.projetS);     
         
        data.append("tableProduit", JSON.stringify(this.tableProduit));
        this.loading = true;
        this.$http.post(url, data).then(
          response => {
            if (response.body) {
              let verif = response.body;
              if (verif.code === 1) {
                if (this.entrepotCourant.id) {
                  this.$notify({
                    title: "MODIFICATION REUSSI",
                    message: "Entrepot modifié avec succès.",
                    type: "success",
                    position: "top-center"
                  });
                } else {
                  this.createStock(response.body.entrepot);
                  this.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "Entrepot enregistré avec succès.",
                    type: "success",
                    position: "top-center"
                  });
                }
                this.loadEntrepot();
                this.dialogAjout = false;
                this.loading = false;
              } else if (verif.code === 0) {
                this.$message.error(verif.message);
                this.loading = false;
              }
            } else {
              this.$message.error(
                "Une erreur est survenue. Veuillez contacter votre administrateur"
              );
              this.loading = false;
            }
          },
          response => {
            this.$message.error(
              "Une erreur est survenue. Veuillez contacter votre administrateur"
            );
            this.loading = false;
          }
        );
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "L'entrepot n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
        this.formEtape = 1;
      }
    },
    createStock(entrepot) {
      var form = document.getElementById("formEntrepot");
      let nbData = 1;
      if (this.listeStockSelect.length > 10) {
        nbData = 10;
      }
      let nbReq = Math.round(this.listeStockSelect.length / nbData);
      let nbRest = this.listeStockSelect.length % nbData;
      if (nbRest > 0) {
        nbReq += 1;
      }
      if (nbReq == 0 && this.listeStockSelect.length > 0) {
        nbReq = 1;
      }
      let ligne = null;
      for (let i = 0; i < nbReq; i++) {
        let initJ = i * nbData;
        let finJ = (i + 1) * nbData;
        let dataLot = [];
        if (this.listeStockSelect.length > 0) {
          for (let j = initJ; j < finJ; j++) {
            if (this.listeStockSelect[j] == undefined) {
              break;
            }
            dataLot.push(this.listeStockSelect[j]);
          }
        }
        var data = new FormData();

        for (let prop in dataLot) {
          ligne = dataLot[prop];
          data.append("options[id][]", ligne.id);
          data.append("options[seuil][]", ligne.seuil);
          data.append("options[unite][]", ligne.unite);
          data.append("options[coche][]", ligne.coche);
        }
        let url = this.domaine + "entrepot/" + entrepot + "/stock/entrepot";
        this.loading = true;
        this.$http.post(url, data).then(
          response => {
            if (response.body) {
              let verif = response.body;
              if (verif.code === 1) {
                this.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Entrepot enregistré avec succès.",
                  type: "success",
                  position: "top-center"
                });
                this.loadEntrepot();
                this.dialogAjout = false;
                this.loading = false;
              } else if (verif.code === 0) {
                this.$message.error(verif.message);
                this.loading = false;
              }
            } else {
              this.$message.error(
                "Une erreur est survenue. Veuillez contacter votre administrateur"
              );
              this.loading = false;
            }
          },
          response => {
            this.$message.error(
              "Une erreur est survenue. Veuillez contacter votre administrateur"
            );
            this.loading = false;
          }
        );
      }
    },
    submitStock() {
      this.loading = true;
      if (this.tabListProduit.length != 0) {
        var form = document.getElementById("formStock");
        let ligne = null;
        let nbData = 10;
        let nbReq = 1;
        let nbRest;
        if (this.tabListProduit.length > 10) {
          nbData = 10;
          nbReq = Math.round(this.tabListProduit.length / nbData);
          nbRest = this.tabListProduit.length % nbData;
          if (nbRest > 0) {
            nbReq += 1;
          }
        }
        for (let i = 0; i < nbReq; i++) {
          let initJ = i * nbData;
          let finJ = (i + 1) * nbData;
          let dataLot = [];
          if (this.tabListProduit.length > 0) {
            for (let j = initJ; j < finJ; j++) {
              if (this.tabListProduit[j] == undefined) {
                break;
              }
              dataLot.push(this.tabListProduit[j]);
            }
          }
          let url =
            this.domaine +
            "entrepot/" +
            this.entrepotCourant.id +
            "/new/stock/appro";
          var data = new FormData();
          data.append("idUser", this.user.id);
          for (let prop in dataLot) {
            ligne = dataLot[prop];
            data.append("options[produit][]", ligne.id);
            data.append("options[seuil][]", ligne.seuil);
          }

          this.$http.post(url, data).then(
            response => {
              if (response.body) {
                let verif = response.body;
                if (verif.code === 1) {
                  this.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "Stock enregistré avec succès.",
                    type: "success",
                    position: "top-center"
                  });
                  this.loadStock(this.entrepotCourant);
                  this.loadProduitRestant(this.entrepotCourant);
                  this.showEntrepot(this.entrepotCourant);
                  this.loadEntrepot();
                  this.dialogStock = false;
                  this.loading = false;
                } else {
                  this.$notify({
                    title: "ENREGISTREMENT ECHOUE",
                    message: verif.message,
                    type: "error",
                    position: "top-center"
                  });
                  this.loading = false;
                }
              } else {
                this.$message.error(
                  "Une erreur est survenue. Veuillez contacter votre administrateur"
                );
                this.loading = false;
              }
            },
            response => {
              this.$message.error(
                "Une erreur est survenue. Veuillez contacter votre administrateur"
              );
              this.loading = false;
            }
          );
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Le stock n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
        this.formEtape = 1;
      }
    },
    deleteRow(index, rows) {
      let item = rows.splice(index, 1);
    },
    deleteRowStock(index, rows) {
      let item = rows.splice(index, 1);
    },
    submitSortie() {
      this.loading = true;
      if (
        this.$refs.formSortie.validate() &&
        (this.dateS != "" && this.travauxS != "")
      ) {
        var form = document.getElementById("formSortie");
        var data = new FormData(form);
        let url =
          this.domaine + "entrepot/" + this.entrepotCourant.id + "/new/sortie";
        data.append("idUser", this.user.id);
        data.append("travaux", this.travauxS);
        data.append("demande", this.selectDemande);
        data.append("optionBesoin", this.optionBesoin);

        data.append("tache", this.tacheSId);
        data.append("typeHydro", this.detailEntre.typeHydro);
        data.append("type", this.selectTypeSortie);
        data.append("destinataireSortie", this.destinataireSortie);
        let ligne = null;
        for (let prop in this.optionSortie) {
          ligne = this.optionSortie[prop];
          data.append("options[id][]", ligne.id);
          data.append("options[qte][]", ligne.qte);
          data.append("options[carburant][]", ligne.carburant);
          data.append("options[qteS][]", ligne.qteS);
          data.append("options[etat][]", ligne.selectEtatProduit);
          data.append("options[retour][]", ligne.selectRetourPrev);
          data.append("options[dateRe][]", ligne.dateRe);
        }
        this.$http.post(url, data).then(
          response => {
            this.loading = false;
            if (response.body) {
              let verif = response.body;
              if (verif.code === 1) {
                this.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Sortie enregistré avec succès.",
                  type: "success",
                  position: "top-center"
                });
                this.loadStock(this.entrepotCourant);
                this.loadSortie(this.entrepotCourant);
                this.showEntrepot(this.entrepotCourant);
                if (this.detailEntre.typeHydro) {
                  this.loadACarburant(this.detailEntre);
                  this.loadStock(this.detailEntre);
                }

                this.dialogSortie = false;
                this.dialogCarburanSortie = false;
                this.loading = false;
              } else if (verif.code === 2) {
                this.$message.error(verif.message);
                this.loading = false;
              } else if (verif.code === 0) {
                this.$message.error(verif.message);
                this.loading = false;
              }
            } else {
              this.$message.error(
                "Une erreur est survenue. Veuillez contacter votre administrateur"
              );
              this.loading = false;
            }
          },
          response => {
            this.$message.error(
              "Une erreur est survenue. Veuillez contacter votre administrateur"
            );
            this.loading = false;
          }
        );
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La sortie n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    submitEntree() {
      this.loading = true;
      if (
        this.$refs.formEntree.validate() &&
        this.selectEtatRetour != "" &&
        this.dateRetour != "" &&
        this.qteRetour != 0
      ) {
        var form = document.getElementById("formEntree");
        var data = new FormData(form);
        let url =
          this.domaine + "entrepot/" + this.entrepotCourant.id + "/new_entree";
        data.append("idUser", this.user.id);
        data.append("idSortie", this.sortieCourant.id);
        data.append("etat", this.selectEtatRetour);
        this.$http.post(url, data).then(
          response => {
            this.loading = false;
            if (response.body) {
              let verif = response.body;
              if (verif.code === 1) {
                this.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Retour enregistré avec succès.",
                  type: "success",
                  position: "top-center"
                });
                this.loadSortie(this.entrepotCourant);
                this.loadEntree(this.entrepotCourant);
                this.loadStock(this.entrepotCourant);
                this.showEntrepot(this.entrepotCourant);
                this.loadEntrepot();
                this.dialogEntree = false;
                this.loading = false;
              } else if (verif.code === 0) {
                this.$message.error(verif.message);
                this.loading = false;
              } else if (verif.code === 2) {
                this.$message.error(verif.message);
                this.loading = false;
              }
            } else {
              this.$message.error(
                "Une erreur est survenue. Veuillez contacter votre administrateur"
              );
              this.loading = false;
            }
          },
          response => {
            this.$message.error(
              "Une erreur est survenue. Veuillez contacter votre administrateur"
            );
            this.loading = false;
          }
        );
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La retour n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
        this.formEtape = 1;
      }
    },
    submitTransfert() {
      this.loading = true;
      if (
        this.$refs.formTransfert.validate() &&
        this.selectPriorite != "" &&
        this.selectProduitDemande != "" &&
        this.selectEntrepot != "" &&
        this.motifTransfert != ""
      ) {
        var form = document.getElementById("formTransfert");
        var data = new FormData(form);
        let url = "";
        if (this.transfertCourant.id) {
          url =
            this.domaine +
            "entrepot/" +
            this.transfertCourant.id +
            "/edit_transfert";
        } else {
          url =
            this.domaine +
            "entrepot/" +
            this.entrepotCourant.id +
            "/new_transfert";
        }
        data.append("idUser", this.user.id);
        data.append("priorite", this.selectPriorite);
        data.append("produitDemande", this.selectProduitDemande);
        data.append("autre", this.selectEntrepot);
        this.$http.post(url, data).then(
          response => {
            this.loading = false;
            if (response.body) {
              let verif = response.body;
              if (verif.code === 1) {
                if (this.transfertCourant.id) {
                  this.$notify({
                    title: "MODIFICATION REUSSI",
                    message: response.body.message,
                    type: "success",
                    position: "top-center"
                  });
                } else {
                  this.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "Transfert enregistré avec succès.",
                    type: "success",
                    position: "top-center"
                  });
                }
                this.loadTransfert(this.entrepotCourant);
                this.showEntrepot(this.entrepotCourant);
                this.loadEntrepot();
                this.dialogTransfert = false;
                this.loading = false;
              } else if (verif.code === 2) {
                this.$message.error(verif.message);
                this.loading = false;
              } else if (verif.code === 0) {
                this.$message.error(verif.message);
                this.loading = false;
              } else if (verif.code === 3) {
                this.$message.error(verif.message);
                this.loading = false;
              }
            } else {
              this.$message.error(
                "Une erreur est survenue. Veuillez contacter votre administrateur"
              );
              this.loading = false;
            }
          },
          response => {
            this.$message.error(
              "Une erreur est survenue. Veuillez contacter votre administrateur"
            );
            this.loading = false;
          }
        );
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Le transfert n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
        this.formEtape = 1;
      }
    },
    submitReponseTransfert() {
      this.loading = true;
      if (
        this.$refs.formReponseTransfert.validate() &&
        this.selectReponseTransfert != "" &&
        this.qteT > 0
      ) {
        var form = document.getElementById("formReponseTransfert");
        var data = new FormData(form);
        let url =
          this.domaine +
          "entrepot/" +
          this.transfertCourant.id +
          "/new/reponse/transfert";
        data.append("idUser", this.user.id);
        data.append("reponseTransfert", this.selectReponseTransfert);
        this.$http.post(url, data).then(
          response => {
            this.loading = false;
            if (response.body) {
              let verif = response.body;
              if (verif.code === 1) {
                this.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "La réponse a été enregistré avec succès.",
                  type: "success",
                  position: "top-center"
                });
                this.dialogReponseTransfert = false;
                this.loadTransfert(this.entrepotCourant);
                this.showEntrepot(this.entrepotCourant);
                this.loadEntrepot();
                this.loading = false;
              } else if (verif.code === 2) {
                this.$message.error(verif.message);
                this.loading = false;
              } else if (verif.code === 0) {
                this.$message.error(verif.message);
                this.loading = false;
              }
            } else {
              this.$message.error(
                "Une erreur est survenue. Veuillez contacter votre administrateur"
              );
              this.loading = false;
            }
          },
          response => {
            this.$message.error(
              "Une erreur est survenue. Veuillez contacter votre administrateur"
            );
            this.loading = false;
          }
        );
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La réponse n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
        this.formEtape = 1;
      }
    },
    submitInventaire() {
      //on verifi si la date debut est inferieur a la date de fin
      if (
        this.tabNewstock.length != 0 &&
        this.dateDeb != "" &&
        this.dateFin != ""
      ) {
        if (new Date(this.dateDeb) <= new Date(this.dateFin)) {
          this.loading = true;
          var form = document.getElementById("formInventaire");
          var data = new FormData(form);
          let url =
            this.domaine +
            "entrepot/" +
            this.entrepotCourant.id +
            "/new_inventaire";
          data.append("idUser", this.user.id);
          this.$http.post(url, data).then(
            response => {
              this.createInventaire(response.body.inventaire);
            },
            error => {
              this.$message.error(
                "Une erreur est survenue. Veuillez contacter votre administrateur"
              );
              this.loading = false;
            }
          );
        } else {
          this.$notify.error({
            title: "ERREUR DE DATE",
            message:
              "La date de début ne doit pas être supérieur à la date de fin.",
            position: "top-center"
          });
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "L'inventaire n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
        this.formEtape = 1;
      }
    },
    createInventaire(inventaire) {
      let ligne = null;
      let nbData = 10;
      let nbReq = 1;
      let tabfinal = [];
      let nbRest;
      if (this.tabNewstock.length > 10) {
        nbData = 10;
        nbReq = Math.round(this.tabNewstock.length / nbData);
        nbRest = this.tabNewstock.length % nbData;
        if (nbRest > 0) {
          nbReq += 1;
        }
      }
      for (let i = 0; i < nbReq; i++) {
        let initJ = i * nbData;
        let finJ = (i + 1) * nbData;
        let dataLot = [];
        if (this.tabNewstock.length > 0) {
          for (let j = initJ; j < finJ; j++) {
            if (this.tabNewstock[j] == undefined) {
              break;
            }
            dataLot.push(this.tabNewstock[j]);
          }
        }
        var data = new FormData();
        let url =
          this.domaine + "entrepot/" + inventaire + "/inventaire/valide";
        data.append("idUser", this.user.id);
        for (let prop in dataLot) {
          ligne = dataLot[prop];
          data.append("options[stock][]", ligne.id);
          data.append("options[qteT][]", ligne.qte);
          data.append("options[qteReel][]", ligne.qteReel);
          data.append("options[ecart][]", ligne.ecart);
        }

        this.$http.post(url, data).then(
          response => {
            this.loading = false;
            if (response.body) {
              let verif = response.body;
              if (verif.code === 1) {
                this.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "L'inventaire a été enregistré avec succès.",
                  type: "success",
                  position: "top-center"
                });

                this.showEntrepot(this.entrepotCourant);
                this.loadInventaire(this.entrepotCourant);
                this.showEntrepot(this.entrepotCourant);
                this.loadEntrepot();
                this.dialogInventaire = false;
                this.loading = false;
              } else if (verif.code === 0) {
                this.$message.error(verif.message);
                this.loading = false;
              }
            } else {
              this.$message.error(
                "Une erreur est survenue. Veuillez contacter votre administrateur"
              );
              this.loading = false;
            }
          },
          error => {
            this.$message.error(
              "Une erreur est survenue. Veuillez contacter votre administrateur"
            );
            this.loading = false;
          }
        );
      }
    },
    submitValiderInventaire() {
      this.loading = true;
      if (this.$refs.formValiderInventaire.validate()) {
        let nbData = 10;
        let nbReq = 1;
        let tabfinal = [];
        this.optionInventaire.forEach((item, index) => {
          if (item.stockInventaire == true || item.selectCorriger == 1) {
            tabfinal.push(item);
          }
        });

        let nbRest;
        if (tabfinal.length > 10) {
          nbData = 10;
          nbReq = Math.round(tabfinal.length / nbData);
          nbRest = tabfinal.length % nbData;
          if (nbRest > 0) {
            nbReq += 1;
          }
        }
        for (let i = 0; i < nbReq; i++) {
          let initJ = i * nbData;
          let finJ = (i + 1) * nbData;
          let dataLot = [];
          if (tabfinal.length > 0) {
            for (let j = initJ; j < finJ; j++) {
              if (tabfinal[j] == undefined) {
                break;
              }
              dataLot.push(tabfinal[j]);
            }
          }

          var form = document.getElementById("formValiderInventaire");
          var data = new FormData(form);
          let url =
            this.domaine +
            "entrepot/" +
            this.inventaireCourant.id +
            "/new/valider/inventaire";
          data.append("idUser", this.user.id);
          let ligne = null;
          for (let prop in dataLot) {
            ligne = dataLot[prop];
            data.append("options[id][]", ligne.idOption);
            data.append("options[stock][]", ligne.stock);
            data.append("options[corriger][]", ligne.selectCorriger);
          }
          this.$http.post(url, data).then(
            response => {
              this.loading = false;
              if (response.body) {
                let verif = response.body;
                if (verif.code === 1) {
                  this.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message:
                      "La validation de l'inventaire a été enregistré avec succès.",
                    type: "success",
                    position: "top-center"
                  });
                  this.loadInventaire(this.entrepotCourant);
                  this.showEntrepot(this.entrepotCourant);
                  this.loadEntrepot();

                  this.dialogValiderInventaire = false;
                  this.dialogConfir = false;
                  this.dialogShowInventaire = false;
                  this.loading = false;
                } else if (verif.code === 0) {
                  this.$message.error(verif.message);
                  this.loading = false;
                }
              } else {
                this.$message.error(
                  "Une erreur est survenue. Veuillez contacter votre administrateur"
                );
                this.loading = false;
              }
            },
            response => {
              this.$message.error(
                "Une erreur est survenue. Veuillez contacter votre administrateur"
              );
              this.loading = false;
            }
          );
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La validation de l'inventaire n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
        this.formEtape = 1;
      }
    },
    calculEcart() {
      this.ecart = this.qteReel - this.inventaireCourant.qteT;
    },

    statCommande(dataCitrene = []) {
      let posList = [
        "left",
        "right",
        "top",
        "bottom",
        "inside",
        "insideTop",
        "insideLeft",
        "insideRight",
        "insideBottom",
        "insideTopLeft",
        "insideTopRight",
        "insideBottomLeft",
        "insideBottomRight"
      ];
      app.configParameters = {
        rotate: {
          min: -90,
          max: 90
        },
        align: {
          options: {
            left: "left",
            center: "center",
            right: "right"
          }
        },
        verticalAlign: {
          options: {
            top: "top",
            middle: "middle",
            bottom: "bottom"
          }
        },
        position: {
          options: echarts.util.reduce(
            posList,
            function(map, pos) {
              map[pos] = pos;
              return map;
            },
            {}
          )
        },
        distance: {
          min: 0,
          max: 100
        }
      };

      app.config = {
        rotate: 90,
        align: "left",
        verticalAlign: "middle",
        position: "insideBottom",
        distance: 15,
        onChange: function() {
          let labelOption = {
            normal: {
              rotate: app.config.rotate,
              align: app.config.align,
              verticalAlign: app.config.verticalAlign,
              position: app.config.position,
              distance: app.config.distance
            }
          };
          myChart.setOption({
            series: [
              {
                label: labelOption
              },
              {
                label: labelOption
              },
              {
                label: labelOption
              },
              {
                label: labelOption
              }
            ]
          });
        }
      };

      let optionComd = {
        title: {
          text: "QUANTITE DANS LA CITERNE",
          subtext: "",
          left: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: ["Disponible(s)", "Sortie(s)"]
        },
        series: [
          {
            name: "Quantité(s)",
            type: "pie",
            radius: "75%",
            center: ["50%", "60%"],
            color: ["#FF7043", "#26A69A"],
            data: [
              //{value: 1548, name: '搜索引擎'}
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      };
      for (let dataCom in dataCitrene) {
        optionComd.series[0].data.push({
          value: dataCitrene[dataCom],
          name: dataCom
        });
      }
      this.nbQteDisponible = dataCitrene.disponible;
      this.nbQteUtilise = dataCitrene.utilise;
      let chartCiterneCarburant = document.getElementById(
        "chartCiterneCarburant"
      )
        ? echarts.init(document.getElementById("chartCiterneCarburant"))
        : null;
      if (document.getElementById("chartCiterneCarburant") != null) {
        chartCiterneCarburant.setOption(optionComd);
      }
    },

    calculEcartLigne() {
      for (let pop in this.optionInventaire) {
        this.optionInventaire[pop].ecart =
          parseInt(this.optionInventaire[pop].qteReel) -
          parseInt(this.optionInventaire[pop].qte);
      }
    },
    verifeClore() {
      if (this.sortieCourant.qteRestante == this.qteRetour) {
        this.verifeEtat = false;
      } else if (this.sortieCourant.qteRestante > this.qteRetour) {
        this.verifeEtat = true;
      } else {
        this.verifeEtat = true;
        this.qteRetour = 0;
      }
    },
    showClick(tab, event) {
      this.loading = true;
      if (tab.name == "fiche") {
        this.showEntrepot(this.detailEntre);
      } else if (tab.name == "stock") {
        this.showEnlevement = false;
        this.loadStock(this.detailEntre);
      } else if (tab.name == "sortie") {
        this.loadSortie(this.detailEntre);
      } else if (tab.name == "retour") {
        this.loadEntree(this.detailEntre);
      } else if (tab.name == "carburant") {
        this.showEnlevement = true;
        this.loadACarburant(this.detailEntre);
      } else if (tab.name == "appro") {
        this.loadAppro(this.detailEntre);
      } else if (tab.name == "transfert") {
        this.loadTransfert(this.detailEntre);
      } else if (tab.name == "inventaire") {
        this.loadInventaire(this.detailEntre);
      }
    },
    showEntrepot(ligne) {
      this.loading = true;
      this.dialogShow = true;
      this.detailEntre = [];
      this.nbrApproEntre = 0;
      this.nbrRetourEntre = 0;
      this.nbrTransEntre = 0;
      this.nbrSortieEntre = 0;
      this.nbrCarburantEntre = 0;
      this.pourcNR = 0;
      this.pourcRP = 0;
      this.pourcRE = 0;
      this.pourcRD = 0;
      this.pourcRND = 0;
      this.entrepotCourant = ligne;
      let url = this.domaine + "entrepot/" + this.entrepotCourant.id + "/show";
      this.$http.get(url).then(response => {
        this.loading = false;
        if (response.body) {
          this.detailEntre = response.body.entrepot;
          this.statsEntreAppro = response.body.stats;
          this.pourcNR = response.body.pourcNR;
          this.pourcRP = response.body.pourcRP;
          this.pourcRE = response.body.pourcRE;
          this.pourcRD = response.body.pourcRD;
          this.pourcRND = response.body.pourcRND;
          this.nbrApproEntre = response.body.nbrAppro;
          this.nbrRetourEntre = response.body.nbrRetour;
          this.nbrTransEntre = response.body.nbrTrans;
          this.nbrSortieEntre = response.body.nbrSortie;
          this.nbrCarburantEntre = response.body.nbrCarburant;
          this.statsCarburant = response.body.citerne;
          if (this.detailEntre.typeHydro != "") {
            this.statCommande(response.body.citerne);
          }
          this.chartsSortieEntre();
          this.chartsApproEntre();
          this.loading = false;
        }
      });
    },
    showSortie(ligne) {
      this.loading = true;
      this.dialogShowSortie = true;
      this.sortieCourant = ligne;
      let url =
        this.domaine + "entrepot/" + this.sortieCourant.id + "/show/sortie";
      this.$http.get(url).then(response => {
        this.loading = false;
        if (response.body) {
          this.detailSortie = response.body.sortie;
          this.loading = false;
        }
      });
    },
    showEntree(ligne) {
      this.loading = true;
      this.dialogShowEntree = true;
      this.entreeCourant = ligne;
      let url =
        this.domaine +
        "entrepot/" +
        this.entreeCourant.id +
        "/show/entree/produit";
      this.$http.get(url).then(response => {
        this.loading = false;
        if (response.body) {
          this.detailEntree = response.body.entree;
          this.loading = false;
        }
      });
    },
    showTransfert(ligne) {
      this.loading = true;
      this.dialogShowTransfert = true;
      this.transfertCourant = ligne;
      let url =
        this.domaine +
        "entrepot/" +
        this.transfertCourant.id +
        "/transfert/show";
      this.$http.get(url).then(response => {
        this.loading = false;
        if (response.body) {
          this.detailTransfert = response.body.transfert;
          this.loading = false;
        }
      });
    },
    showInventaire(ligne) {
      this.loading = true;
      this.dialogShowInventaire = true;
      this.inventaireCourant = ligne;
      let url =
        this.domaine + "entrepot/show-inventaire/" + this.inventaireCourant.id;
      this.$http.get(url).then(response => {
        this.loading = false;
        if (response.body) {
          this.detailInventaire = response.body.inventaire;
          this.loading = false;
        }
      });
    },
    confirmerAll() {
      this.optionInventaire.forEach((item, index) => {
        item.selectCorriger = 1;
      });
      this.submitValiderInventaire();
    },
    showAppro(ligne) {
      this.showDetailAppro = true;
      this.approCourant = ligne;
    },
    imprimerAppro(ligne) {
      this.loading = true;
      this.approCourant = ligne;
      let url =
        this.domaine +
        "entrepot/" +
        this.approCourant.id +
        "/" +
        this.user.id +
        "/imprimer/approvisionnement";
      this.$http.get(url).then(response => {
        this.loading = false;
        if (response.body) {
        }
      });
      window.open(url);
    },
    imprimerSortie(ligne) {
      this.loading = true;
      this.sortieCourant = ligne;
      let url =
        this.domaine +
        "entrepot/" +
        this.sortieCourant.id +
        "/" +
        this.user.id +
        "/imprimer/sortie/imprim";
      this.$http.get(url).then(response => {
        this.loading = false;
        if (response.body) {
        }
      });
      window.open(url);
      this.loading = false;
    },
    imprimerEntree(ligne) {
      this.entreeCourant = ligne;
      let url =
        this.domaine +
        "entrepot/" +
        this.entreeCourant.id +
        "/" +
        this.user.id +
        "/imprimer/entree/produit";
      this.$http.get(url).then(response => {
        if (response.body) {
        }
      });
      window.open(url);
      this.loading = false;
    },
    imprimerTransfert(ligne) {
      this.transfertCourant = ligne;
      let url =
        this.domaine +
        "entrepot/" +
        this.transfertCourant.id +
        "/" +
        this.user.id +
        "/transfert/imprimer";
      this.$http.get(url).then(response => {
        this.loading = false;

        if (response.body) {
        }
      });
      window.open(url);
      this.loading = false;
    },
    imprimerInventaire(ligne) {
      this.inventaireCourant = ligne;
      let url =
        this.domaine +
        "entrepot/" +
        this.inventaireCourant.id +
        "/" +
        this.user.id +
        "/imprimerInventaire";
      this.$http.get(url).then(response => {
        this.loading = false;

        if (response.body) {
        }
      });
      window.open(url);
      this.loading = false;
    },
    imprimerAllSortie(ligne) {
      let url = this.domaine + "entrepot/" + ligne + "/imprimer/sortie/demande";
      this.$http.get(url).then(response => {
        this.loading = false;

        if (response.body) {
        }
      });
      this.loading = false;

      window.open(url);
    },
    imprimeListeHisEntrepotStock(type) {
      let idEntr = this.entrepotCourant.id;
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "entrepot/imprimerPDF/historique/" +
          idEntr +
          "/stock/liste";
      } else {
        url =
          this.domaine +
          "entrepot/imprimerEXC/historique/" +
          idEntr +
          "/stock/liste";
      }
      window.open(url);
    },
    imprimeListeHisEntrepotAppro(type) {
      let idEntr = this.entrepotCourant.id;
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "entrepot/imprimerPDF/historique/" +
          idEntr +
          "/appro/liste";
      } else {
        url =
          this.domaine +
          "entrepot/imprimerEXC/historique/" +
          idEntr +
          "/appro/liste";
      }
      window.open(url);
    },
    imprimeListeHisEntrepotEnlevmt(type) {
      let idEntr = this.entrepotCourant.id;
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "entrepot/imprimerPDF/historique/" +
          idEntr +
          "/Enlevmt/liste";
      } else {
        url =
          this.domaine +
          "entrepot/imprimerEXC/historique/" +
          idEntr +
          "/Enlevmt/liste";
      }
      window.open(url);
    },
    imprimeListeHisEntrepotRetour(type) {
      let idEntr = this.entrepotCourant.id;
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "entrepot/imprimerPDF/historique/" +
          idEntr +
          "/retour/liste";
      } else {
        url =
          this.domaine +
          "entrepot/imprimerEXC/historique/" +
          idEntr +
          "/retour/liste";
      }
      window.open(url);
    },
    imprimeListeHisEntrepotDmdTEmise(type) {
      let idEntr = this.entrepotCourant.id;
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "entrepot/imprimerPDF/historique/" +
          idEntr +
          "/dmdemise/liste";
      } else {
        url =
          this.domaine +
          "entrepot/imprimerEXC/historique/" +
          idEntr +
          "/dmdemise/liste";
      }
      window.open(url);
    },
    imprimeListeHisEntrepotDmdTRecu(type) {
      let idEntr = this.entrepotCourant.id;
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "entrepot/imprimerPDF/historique/" +
          idEntr +
          "/dmdrecu/liste";
      } else {
        url =
          this.domaine +
          "entrepot/imprimerEXC/historique/" +
          idEntr +
          "/dmdrecu/liste";
      }
      window.open(url);
    },
    imprimeListeHisEntrepotInventaire(type) {
      let idEntr = this.entrepotCourant.id;
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "entrepot/imprimerPDF/historique/" +
          idEntr +
          "/inventaire/liste";
      } else {
        url =
          this.domaine +
          "entrepot/imprimerEXC/historique/" +
          idEntr +
          "/inventaire/liste";
      }
      window.open(url);
    },
    deleteEntrepot() {
      this.loading = true;
      let url = this.domaine + "entrepot/" + this.idEntrepot + "/delete";
      this.$http.get(url).then(
        response => {
          this.loading = false;
          if (response.body) {
            this.$notify({
              title: "SUPPRESSION",
              message: "Entrepot supprimé avec succès.",
              type: "success",
              position: "top-center"
            });
            this.dialogSupr = false;
            this.loading = false;
            this.loadEntrepot();
            this.loading = false;
          }
        },
        error => {
          this.loading = false;
          this.$notify({
            title: "SUPPRESSION",
            message:
              "Impossible de surprimer ce entrepot,Veuillez contacter votre administrateur.",
            type: "danger",
            position: "top-center"
          });
        }
      );
    },
    clear() {
      this.$refs.formEntrepot.reset();
      this.dialogAjout = false;
    },
    clearInventaire() {
      this.$refs.formInventaire.reset();
      this.dialogInventaire = false;
    },
    beforeMount: function() {
      if (!this.roleAcces[this.$router.history.current.name]) {
        this.$router.push({ name: "Home" });
      }
    },
    imprimeListeHis(type) {
      let url = "";
      if (type == "PDF") {
        url = this.domaine + "entrepot/imprimerPDF/liste";
      } else {
        url = this.domaine + "entrepot/imprimerEXC/liste";
      }
      window.open(url);
    },
    strNoAccent(a) {
      var b = "áàâäãåçéèêëíïîìñóòôöõúùûüýÁÀÂÄÃÅÇÉÈÊËÍÏÎÌÑÓÒÔÖÕÚÙÛÜÝ",
        c = "aaaaaaceeeeiiiinooooouuuuyAAAAAACEEEEIIIINOOOOOUUUUY",
        d = "";
      for (var i = 0, j = a.length; i < j; i++) {
        var e = a.substr(i, 1);
        d += b.indexOf(e) !== -1 ? c.substr(b.indexOf(e), 1) : e;
      }
      return d;
    },
    loadTypeRessource() {
      let url = this.domaine + "product/typeRessource";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listTypeRessource = response.body.types;
          this.loading = false;
        }
      });
    },
    openDialogBon(item) {
      this.loading = true;
      let url =
        this.domaine + "demande_maintenance/" + item.id + "/listeProduitBon";
      var data = new FormData();
      data.append("idUser", this.user.id);

      this.$http.post(url, data).then(
        response => {
          this.loading = false;
          let resp = response.body;
          if (resp.code == 0) {
            this.$notify({
              title: "BON DE SORTI D'UNE PRODUIT",
              message: resp.message,
              type: "success",
              duration: 5000,
              position: "top-center"
            });
          } else {
            this.$notify({
              title: "BON DE SORTI D'UNE PRODUIT",
              message: resp.message,
              type: "error",
              duration: 5000,
              position: "top-center"
            });
          }
          this.loading = false;
          this.loadSortie(this.entrepotCourant);
          this.loadStock(this.entrepotCourant);
          this.showEntrepot(this.entrepotCourant);
        },
        err => {
          this.loading = false;
        }
      );
    },
    validDmCarbur(item) {
      this.qteLivDepart = item.qte;
      this.produitLiv = item.produit;
      this.idProduitLiv = item.idProduit;
      this.codetLiv = item.refLivr;
      this.idApproLiv = item.id;
      this.dialogValidCarburan = true;
    },
    validLivrAppro(item) {
      this.qteLivDepart = item.qte;
      this.produitLiv = item.produit;
      this.idProduitLiv = item.idProduit;
      this.codetLiv = item.refLivr;
      this.idApproLiv = item.id;
      this.dialogValidAppro = true;
    },
    acceptLivrApproValid() {
      if (this.$refs.formValidApproLivr.validate()) {
        var form = document.getElementById("formValidApproLivr");
        var data = new FormData(form);
        data.append("idUser", this.user.id);
        data.append("idEntrepot", this.entrepotCourant.id);
        data.append("qteDepart", this.qteLivDepart);
        data.append("idProduit", this.idProduitLiv);
        data.append("idAppro", this.idApproLiv);
        data.append("idReponse", this.choixValidLiv);
        data.append("nomLivreur", this.nomLivreur);
        // data.append('nbChoice', this.nbChoiceLiv)

        let url = this.domaine + "entrepot/valide/livraison/appro";
        this.$http.post(url, data).then(response => {
          if (response.body.code == 1) {
            this.$notify({
              title: "VALIDATION REUSSIE",
              message: "La validation a été ennregistrée.",
              type: "success",
              position: "top-center"
            });

            this.nomLivreur = "";
          }

          this.loadAppro(this.entrepotCourant);
        });

        this.dialogValidAppro = false;
        //this.dialogShow = false
      }
    },
    acceptCarburanApproValid() {
      if (this.$refs.formValidApproLivr.validate()) {
        var form = document.getElementById("formValidApproLivr");
        var data = new FormData(form);
        data.append("idUser", this.user.id);
        data.append("idEntrepot", this.entrepotCourant.id);
        data.append("qteDepart", this.qteLivDepart);
        data.append("idProduit", this.idProduitLiv);
        data.append("idAppro", this.idApproLiv);
        data.append("idReponse", this.choixValidLiv);
        data.append("nomLivreur", this.nomLivreur);
        // data.append('nbChoice', this.nbChoiceLiv)

        let url = this.domaine + "entrepot/valide/livraison/appro";
        this.$http.post(url, data).then(response => {
          if (response.body.code == 1) {
            this.$notify({
              title: "VALIDATION REUSSIE",
              message: "La validation a été ennregistrée.",
              type: "success",
              position: "top-center"
            });

            this.nomLivreur = "";
          }

          this.loadAppro(this.entrepotCourant);
        });

        this.dialogValidCarburan = false;
      }
    },
    changeValidLiv() {
      if (this.choixValidLiv == 2) {
        this.nbChoiceLiv = 0;
      }
    },
    loadChangChoix() {
      if (
        this.nbChoiceLiv > this.qteLivDepart ||
        this.nbChoiceLiv == this.qteLivDepart ||
        this.nbChoiceLiv < 0
      ) {
        this.nbChoiceLiv = 0;
      }
    },
    resetValideLivAppro() {
      this.qteLivDepart = "";
      this.produitLiv = "";
      this.idProduitLiv = "";
      this.nbChoiceLiv = "";
      this.remarqueLivr = "";
      this.choixValidLiv = "";
      this.idApproLiv = "";
      this.dialogValidAppro = false;
      this.dialogValidCarburan = false;
    }
  },
  mounted() {
    this.loadProduit();
    this.loadUser();
    this.loadEntrepot();
    this.chartsSortie();
    this.chartsAppro();
    this.loadProjet();
    this.loadDemande();
    this.loadTypeRessource();
  },
  beforeMount: function() {
    if (!this.roleAcces[this.$router.history.current.name]) {
      this.$router.push({ name: "Home" });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Entrepot.vue